webpackJsonp([35783957827783],{

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var emotionUtils = __webpack_require__(49);
	var PropTypes = _interopDefault(__webpack_require__(6));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var channel = '__EMOTION_THEMING__';
	
	var _contextTypes;
	
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	function setTheme(theme) {
	  this.setState({
	    theme: theme
	  });
	}
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|accept|acceptCharset|accessKey|action|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan)|(on[A-Z].*)|((data|aria)-.*))$/;
	var testOmitPropsOnStringTag = emotionUtils.memoize(function (key) {
	  return reactPropsRegex.test(key);
	});
	var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	var testAlwaysTrue = function testAlwaysTrue() {
	  return true;
	};
	var omitAssign = function omitAssign(testFn, target) {
	  var i = 2;
	  var length = arguments.length;
	
	  for (; i < length; i++) {
	    var source = arguments[i];
	
	    var _key = void 0;
	
	    for (_key in source) {
	      if (testFn(_key)) {
	        target[_key] = source[_key];
	      }
	    }
	  }
	
	  return target;
	};
	
	function _componentWillMount() {
	  if (this.context[channel] !== undefined) {
	    this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
	  }
	}
	
	function _componentWillUnmount() {
	  if (this.unsubscribe !== undefined) {
	    this.context[channel].unsubscribe(this.unsubscribe);
	  }
	}
	
	function _get(target, property) {
	  switch (property) {
	    // react-hot-loader tries to access this stuff
	    case '__proto__':
	    case 'name':
	    case 'prototype':
	    case 'displayName':
	      {
	        return target[property];
	      }
	
	    default:
	      {
	        throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
	      }
	  }
	}
	
	function createEmotionStyled(emotion, view) {
	  var _createStyled = function createStyled(tag, options) {
	    if (false) {
	      if (tag === undefined) {
	        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	      }
	    }
	
	    var staticClassName;
	    var identifierName;
	    var stableClassName;
	
	    if (options !== undefined) {
	      staticClassName = options.e;
	      identifierName = options.label;
	      stableClassName = options.target;
	    }
	
	    var isReal = tag.__emotion_real === tag;
	    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
	    var omitFn = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
	
	    function _value() {
	      if (false) {
	        throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	      }
	
	      return "." + stableClassName;
	    }
	
	    return function () {
	      var args = arguments;
	      var styles = isReal && tag[emotionUtils.STYLES_KEY] !== undefined ? tag[emotionUtils.STYLES_KEY].slice(0) : [];
	
	      if (identifierName !== undefined) {
	        styles.push("label:" + identifierName + ";");
	      }
	
	      if (staticClassName === undefined) {
	        if (args[0] == null || args[0].raw === undefined) {
	          styles.push.apply(styles, args);
	        } else {
	          styles.push(args[0][0]);
	          var len = args.length;
	          var i = 1;
	
	          for (; i < len; i++) {
	            styles.push(args[i], args[0][i]);
	          }
	        }
	      }
	
	      function _render() {
	        var props = this.props,
	            state = this.state;
	        this.mergedProps = omitAssign(testAlwaysTrue, {}, props, {
	          theme: state !== null && state.theme || props.theme || {}
	        });
	        var className = '';
	        var classInterpolations = [];
	
	        if (props.className) {
	          if (staticClassName === undefined) {
	            className += emotion.getRegisteredStyles(classInterpolations, props.className);
	          } else {
	            className += props.className + " ";
	          }
	        }
	
	        if (staticClassName === undefined) {
	          className += emotion.css.apply(this, styles.concat(classInterpolations));
	        } else {
	          className += staticClassName;
	        }
	
	        if (stableClassName !== undefined) {
	          className += " " + stableClassName;
	        }
	
	        return view.createElement(baseTag, omitAssign(omitFn, {}, props, {
	          className: className,
	          ref: props.innerRef
	        }));
	      }
	
	      var Styled =
	      /*#__PURE__*/
	      function (_view$Component) {
	        _inheritsLoose(Styled, _view$Component);
	
	        function Styled() {
	          return _view$Component.apply(this, arguments) || this;
	        }
	
	        var _proto = Styled.prototype;
	        _proto.componentWillMount = _componentWillMount;
	        _proto.componentWillUnmount = _componentWillUnmount;
	        _proto.render = _render;
	        return Styled;
	      }(view.Component);
	
	      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	      Styled.contextTypes = contextTypes;
	      Styled[emotionUtils.STYLES_KEY] = styles;
	      Styled.__emotion_base = baseTag;
	      Styled.__emotion_real = Styled;
	      Object.defineProperty(Styled, 'toString', {
	        enumerable: false,
	        value: _value
	      });
	
	      Styled.withComponent = function (nextTag, nextOptions) {
	        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
	        omitAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, args);
	      };
	
	      return Styled;
	    };
	  };
	
	  if (false) {
	    _createStyled = new Proxy(_createStyled, {
	      get: _get
	    });
	  }
	
	  return _createStyled;
	}
	
	module.exports = createEmotionStyled;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var emotionUtils = __webpack_require__(49);
	var stylisRuleSheet = _interopDefault(__webpack_require__(128));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var processStyleName = emotionUtils.memoize(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  if (emotionUtils.unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  !isNaN(value) && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'function':
	        toAdd = classnames([arg()]);
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	var isBrowser = typeof document !== 'undefined';
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function makeStyleTag(opts) {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-emotion', opts.key || '');
	
	  if (opts.nonce !== undefined) {
	    tag.setAttribute('nonce', opts.nonce);
	  }
	
	  tag.appendChild(document.createTextNode('')) // $FlowFixMe
	  ;
	  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
	  return tag;
	}
	
	function _StyleSheet(options) {
	  this.isSpeedy = ("production") === 'production'; // the big drawback here is that the css won't be editable in devtools
	
	  this.tags = [];
	  this.ctr = 0;
	  this.opts = options;
	}
	
	function _inject() {
	  if (this.injected) {
	    throw new Error('already injected!');
	  }
	
	  this.tags[0] = makeStyleTag(this.opts);
	  this.injected = true;
	}
	
	function _speedy(bool) {
	  if (this.ctr !== 0) {
	    // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
	    throw new Error("cannot change speedy now");
	  }
	
	  this.isSpeedy = !!bool;
	}
	
	function _insert(rule, sourceMap) {
	  // this is the ultrafast version, works across browsers
	  if (this.isSpeedy) {
	    var tag = this.tags[this.tags.length - 1];
	    var sheet = sheetForTag(tag);
	
	    try {
	      sheet.insertRule(rule, sheet.cssRules.length);
	    } catch (e) {
	      if (false) {
	        console.warn('illegal rule', rule); // eslint-disable-line no-console
	      }
	    }
	  } else {
	    var _tag = makeStyleTag(this.opts);
	
	    this.tags.push(_tag);
	
	    _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
	  }
	
	  this.ctr++;
	
	  if (this.ctr % 65000 === 0) {
	    this.tags.push(makeStyleTag(this.opts));
	  }
	}
	
	function _ref(tag) {
	  return tag.parentNode.removeChild(tag);
	}
	
	function _flush() {
	  // $FlowFixMe
	  this.tags.forEach(_ref);
	  this.tags = [];
	  this.ctr = 0; // todo - look for remnants in document.styleSheets
	
	  this.injected = false;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  var _proto = _StyleSheet.prototype;
	  _proto.inject = _inject;
	  _proto.speedy = _speedy;
	  _proto.insert = _insert;
	  _proto.flush = _flush;
	  return _StyleSheet;
	}();
	
	function createEmotion(context, options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	
	  if (false) {
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  } // $FlowFixMe
	
	
	  var caches = context.__SECRET_EMOTION__;
	  var current;
	
	  function insertRule(rule) {
	    current += rule;
	
	    if (isBrowser) {
	      sheet.insert(rule, currentSourceMap);
	    }
	  }
	
	  var insertionPlugin = stylisRuleSheet(insertRule);
	
	  if (caches === undefined) {
	    var stylisOptions = {
	      keyframe: false,
	      global: false,
	      prefix: options.prefix === undefined ? true : options.prefix,
	      semicolon: true
	    };
	
	    if (false) {
	      stylisOptions.compress = false;
	    }
	
	    context.__SECRET_EMOTION__ = caches = {
	      registered: {},
	      inserted: {},
	      sheet: new StyleSheet(options),
	      stylis: new emotionUtils.Stylis(stylisOptions),
	      nonce: options.nonce,
	      key: key
	    };
	    caches.stylis.use(options.stylisPlugins)(insertionPlugin); // 🚀
	
	    if (isBrowser) {
	      caches.sheet.inject();
	    }
	  }
	
	  var stylis = caches.stylis;
	  var sheet = caches.sheet;
	  var currentSourceMap = '';
	
	  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
	    if (interpolation == null) {
	      return '';
	    }
	
	    switch (typeof interpolation) {
	      case 'boolean':
	        return '';
	
	      case 'function':
	        if (interpolation[emotionUtils.STYLES_KEY] !== undefined) {
	          return interpolation.toString();
	        }
	
	        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
	        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
	
	      case 'object':
	        return createStringFromObject.call(this, interpolation);
	
	      default:
	        var cached = caches.registered[interpolation];
	        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
	    }
	  }
	
	  var objectToStringCache = new WeakMap();
	
	  function createStringFromObject(obj) {
	    if (objectToStringCache.has(obj)) {
	      // $FlowFixMe
	      return objectToStringCache.get(obj);
	    }
	
	    var string = '';
	
	    function _ref(interpolation) {
	      string += handleInterpolation.call(this, interpolation, false);
	    }
	
	    function _ref2(key) {
	      if (typeof obj[key] !== 'object') {
	        if (caches.registered[obj[key]] !== undefined) {
	          string += key + "{" + caches.registered[obj[key]] + "}";
	        } else {
	          string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
	        }
	      } else {
	        string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
	      }
	    }
	
	    if (Array.isArray(obj)) {
	      obj.forEach(_ref, this);
	    } else {
	      Object.keys(obj).forEach(_ref2, this);
	    }
	
	    objectToStringCache.set(obj, string);
	    return string;
	  }
	
	  var name;
	  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	
	  var createStyles = function createStyles(strings) {
	    var stringMode = true;
	    var styles = '';
	    var identifierName = '';
	
	    if (strings == null || strings.raw === undefined) {
	      stringMode = false;
	      styles += handleInterpolation.call(this, strings, false);
	    } else {
	      styles += strings[0];
	    }
	
	    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    interpolations.forEach(function (interpolation, i) {
	      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
	      );
	
	      if (stringMode === true && strings[i + 1] !== undefined) {
	        styles += strings[i + 1];
	      }
	    }, this);
	    styles = styles.replace(labelPattern, function (match, p1) {
	      identifierName += "-" + p1;
	      return '';
	    });
	    name = emotionUtils.hashString(styles + identifierName) + identifierName;
	    return styles;
	  };
	
	  if (false) {
	    var sourceMapRegEx = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	    var oldStylis = stylis;
	
	    stylis = function stylis(selector, styles) {
	      var result = sourceMapRegEx.exec(styles);
	      currentSourceMap = result ? result[0] : '';
	      oldStylis(selector, styles);
	      currentSourceMap = '';
	    };
	  }
	
	  function insert(scope, styles) {
	    if (caches.inserted[name] === undefined) {
	      current = '';
	      stylis(scope, styles);
	      caches.inserted[name] = current;
	    }
	  }
	
	  var css = function css() {
	    var styles = createStyles.apply(this, arguments);
	    var selector = key + "-" + name;
	
	    if (caches.registered[selector] === undefined) {
	      caches.registered[selector] = styles;
	    }
	
	    insert("." + selector, styles);
	    return selector;
	  };
	
	  var keyframes = function keyframes() {
	    var styles = createStyles.apply(this, arguments);
	    var animation = "animation-" + name;
	    insert('', "@keyframes " + animation + "{" + styles + "}");
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    var styles = createStyles.apply(this, arguments);
	    insert('', styles);
	  };
	
	  function getRegisteredStyles(registeredStyles, classNames) {
	    var rawClassName = '';
	    classNames.split(' ').forEach(function (className) {
	      if (caches.registered[className] !== undefined) {
	        registeredStyles.push(className);
	      } else {
	        rawClassName += className + " ";
	      }
	    });
	    return rawClassName;
	  }
	
	  function merge(className, sourceMap) {
	    var registeredStyles = [];
	    var rawClassName = getRegisteredStyles(registeredStyles, className);
	
	    if (registeredStyles.length < 2) {
	      return className;
	    }
	
	    return rawClassName + css(registeredStyles, sourceMap);
	  }
	
	  function cx() {
	    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      classNames[_key2] = arguments[_key2];
	    }
	
	    return merge(classnames(classNames));
	  }
	
	  function hydrateSingleId(id) {
	    caches.inserted[id] = true;
	  }
	
	  function hydrate(ids) {
	    ids.forEach(hydrateSingleId);
	  }
	
	  function flush() {
	    if (isBrowser) {
	      sheet.flush();
	      sheet.inject();
	    }
	
	    caches.inserted = {};
	    caches.registered = {};
	  }
	
	  function _ref3(node) {
	    // $FlowFixMe
	    sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe
	
	    node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
	  }
	
	  if (isBrowser) {
	    var chunks = Array.from(document.querySelectorAll("[data-emotion-" + key + "]"));
	    chunks.forEach(_ref3);
	  }
	
	  var emotion = {
	    flush: flush,
	    hydrate: hydrate,
	    cx: cx,
	    merge: merge,
	    getRegisteredStyles: getRegisteredStyles,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    css: css,
	    sheet: sheet,
	    caches: caches
	  };
	  return emotion;
	}
	
	module.exports = createEmotion;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyObject = __webpack_require__(36);
	var _invariant = __webpack_require__(2);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function hashString(str) {
	  return murmurhash2_32_gc(str, str.length).toString(36);
	}
	
	function murmurhash2_32_gc(str, seed) {
	  var l = str.length,
	      h = seed ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return h >>> 0;
	}
	
	var pa = function fa(ha) {
	  function V(b, c, d, k, l) {
	    for (var a = 0, f = 0, n = 0, e = 0, h, q, m, v = 0, A = 0, B = 0, x = 0, C = 0, p = 0, G = 0, r = 0, N = q = 0, L = 0, t = 0, D = d.length, F = D - 1, g = "", u = "", S = "", M = "", H; r < D;) {
	      m = d.charCodeAt(r);
	      r === F && 0 !== f + e + n + a && (0 !== f && (m = 47 === f ? 10 : 47), e = n = a = 0, D++, F++);
	
	      if (0 === f + e + n + a) {
	        if (r === F && (0 < q && (g = g.replace(P, "")), 0 < g.trim().length)) {
	          switch (m) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              g += d.charAt(r);
	          }
	
	          m = 59;
	        }
	
	        if (1 === N) switch (m) {
	          case 123:
	          case 125:
	          case 59:
	          case 34:
	          case 39:
	          case 40:
	          case 41:
	          case 44:
	            N = 0;
	
	          case 9:
	          case 13:
	          case 10:
	          case 32:
	            break;
	
	          default:
	            for (N = 0, t = r, h = m, r--, m = 59; t < D;) {
	              switch (d.charCodeAt(++t)) {
	                case 10:
	                case 13:
	                case 59:
	                  r++, m = h;
	
	                case 58:
	                case 123:
	                  t = D;
	              }
	            }
	
	        }
	
	        switch (m) {
	          case 123:
	            g = g.trim();
	            h = g.charCodeAt(0);
	            x = 1;
	
	            for (t = ++r; r < D;) {
	              m = d.charCodeAt(r);
	
	              switch (m) {
	                case 123:
	                  x++;
	                  break;
	
	                case 125:
	                  x--;
	              }
	
	              if (0 === x) break;
	              r++;
	            }
	
	            p = d.substring(t, r);
	            0 === h && (h = (g = g.replace(qa, "").trim()).charCodeAt(0));
	
	            switch (h) {
	              case 64:
	                0 < q && (g = g.replace(P, ""));
	                q = g.charCodeAt(1);
	
	                switch (q) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    h = c;
	                    break;
	
	                  default:
	                    h = W;
	                }
	
	                p = V(c, h, p, q, l + 1);
	                t = p.length;
	                0 < X && 0 === t && (t = g.length);
	                0 < E && (h = ia(W, g, L), H = O(3, p, h, c, I, y, t, q, l), g = h.join(""), void 0 !== H && 0 === (t = (p = H.trim()).length) && (q = 0, p = ""));
	                if (0 < t) switch (q) {
	                  case 115:
	                    g = g.replace(ra, sa);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    p = g + "{" + p + "}";
	                    break;
	
	                  case 107:
	                    g = g.replace(ta, "$1 $2" + (0 < Q ? T : ""));
	                    p = g + "{" + p + "}";
	                    p = 1 === w || 2 === w && U("@" + p, 3) ? "@-webkit-" + p + "@" + p : "@" + p;
	                    break;
	
	                  default:
	                    p = g + p, 112 === k && (p = (u += p, ""));
	                } else p = "";
	                break;
	
	              default:
	                p = V(c, ia(c, g, L), p, k, l + 1);
	            }
	
	            S += p;
	            p = L = q = G = N = C = 0;
	            g = "";
	            m = d.charCodeAt(++r);
	            break;
	
	          case 125:
	          case 59:
	            g = (0 < q ? g.replace(P, "") : g).trim();
	            if (1 < (t = g.length)) switch (0 === G && (h = g.charCodeAt(0), 45 === h || 96 < h && 123 > h) && (t = (g = g.replace(" ", ":")).length), 0 < E && void 0 !== (H = O(1, g, c, b, I, y, u.length, k, l)) && 0 === (t = (g = H.trim()).length) && (g = "\x00\x00"), h = g.charCodeAt(0), q = g.charCodeAt(1), h + q) {
	              case 0:
	                break;
	
	              case 169:
	              case 163:
	                M += g + d.charAt(r);
	                break;
	
	              default:
	                58 !== g.charCodeAt(t - 1) && (u += ja(g, h, q, g.charCodeAt(2)));
	            }
	            L = q = G = N = C = 0;
	            g = "";
	            m = d.charCodeAt(++r);
	        }
	      }
	
	      switch (m) {
	        case 13:
	        case 10:
	          if (0 === f + e + n + a + ka) switch (B) {
	            case 41:
	            case 39:
	            case 34:
	            case 64:
	            case 126:
	            case 62:
	            case 42:
	            case 43:
	            case 47:
	            case 45:
	            case 58:
	            case 44:
	            case 59:
	            case 123:
	            case 125:
	              break;
	
	            default:
	              0 < G && (N = 1);
	          }
	          47 === f ? f = 0 : 0 === z + C && (q = 1, g += "\x00");
	          0 < E * la && O(0, g, c, b, I, y, u.length, k, l);
	          y = 1;
	          I++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === f + e + n + a) {
	            y++;
	            break;
	          }
	
	        default:
	          y++;
	          h = d.charAt(r);
	
	          switch (m) {
	            case 9:
	            case 32:
	              if (0 === e + a + f) switch (v) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  h = "";
	                  break;
	
	                default:
	                  32 !== m && (h = " ");
	              }
	              break;
	
	            case 0:
	              h = "\\0";
	              break;
	
	            case 12:
	              h = "\\f";
	              break;
	
	            case 11:
	              h = "\\v";
	              break;
	
	            case 38:
	              0 === e + f + a && 0 < z && (q = L = 1, h = "\f" + h);
	              break;
	
	            case 108:
	              if (0 === e + f + a + J && 0 < G) switch (r - G) {
	                case 2:
	                  112 === v && 58 === d.charCodeAt(r - 3) && (J = v);
	
	                case 8:
	                  111 === A && (J = A);
	              }
	              break;
	
	            case 58:
	              0 === e + f + a && (G = r);
	              break;
	
	            case 44:
	              0 === f + n + e + a && (q = 1, h += "\r");
	              break;
	
	            case 34:
	              0 === f && (e = e === m ? 0 : 0 === e ? m : e);
	              break;
	
	            case 39:
	              0 === f && (e = e === m ? 0 : 0 === e ? m : e);
	              break;
	
	            case 91:
	              0 === e + f + n && a++;
	              break;
	
	            case 93:
	              0 === e + f + n && a--;
	              break;
	
	            case 41:
	              0 === e + f + a && n--;
	              break;
	
	            case 40:
	              if (0 === e + f + a) {
	                if (0 === C) switch (2 * v + 3 * A) {
	                  case 533:
	                    break;
	
	                  default:
	                    x = 0, C = 1;
	                }
	                n++;
	              }
	
	              break;
	
	            case 64:
	              0 === f + n + e + a + G + p && (p = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < e + a + n)) switch (f) {
	                case 0:
	                  switch (2 * m + 3 * d.charCodeAt(r + 1)) {
	                    case 235:
	                      f = 47;
	                      break;
	
	                    case 220:
	                      t = r, f = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === m && 42 === v && (33 === d.charCodeAt(t + 2) && (u += d.substring(t, r + 1)), h = "", f = 0);
	              }
	          }
	
	          if (0 === f) {
	            if (0 === z + e + a + p && 107 !== k && 59 !== m) switch (m) {
	              case 44:
	              case 126:
	              case 62:
	              case 43:
	              case 41:
	              case 40:
	                if (0 === C) {
	                  switch (v) {
	                    case 9:
	                    case 32:
	                    case 10:
	                    case 13:
	                      h += "\x00";
	                      break;
	
	                    default:
	                      h = "\x00" + h + (44 === m ? "" : "\x00");
	                  }
	
	                  q = 1;
	                } else switch (m) {
	                  case 40:
	                    C = ++x;
	                    break;
	
	                  case 41:
	                    0 === (C = --x) && (q = 1, h += "\x00");
	                }
	
	                break;
	
	              case 9:
	              case 32:
	                switch (v) {
	                  case 0:
	                  case 123:
	                  case 125:
	                  case 59:
	                  case 44:
	                  case 12:
	                  case 9:
	                  case 32:
	                  case 10:
	                  case 13:
	                    break;
	
	                  default:
	                    0 === C && (q = 1, h += "\x00");
	                }
	
	            }
	            g += h;
	            32 !== m && 9 !== m && (B = m);
	          }
	
	      }
	
	      A = v;
	      v = m;
	      r++;
	    }
	
	    t = u.length;
	    0 < X && 0 === t && 0 === S.length && 0 === c[0].length === !1 && (109 !== k || 1 === c.length && (0 < z ? K : R) === c[0]) && (t = c.join(",").length + 2);
	
	    if (0 < t) {
	      if (0 === z && 107 !== k) {
	        d = 0;
	        a = c.length;
	
	        for (f = Array(a); d < a; ++d) {
	          v = c[d].split(ua);
	          A = "";
	          B = 0;
	
	          for (D = v.length; B < D; ++B) {
	            if (!(0 === (x = (e = v[B]).length) && 1 < D)) {
	              r = A.charCodeAt(A.length - 1);
	              L = e.charCodeAt(0);
	              n = "";
	              if (0 !== B) switch (r) {
	                case 42:
	                case 126:
	                case 62:
	                case 43:
	                case 32:
	                case 40:
	                  break;
	
	                default:
	                  n = " ";
	              }
	
	              switch (L) {
	                case 38:
	                  e = n + K;
	
	                case 126:
	                case 62:
	                case 43:
	                case 32:
	                case 41:
	                case 40:
	                  break;
	
	                case 91:
	                  e = n + e + K;
	                  break;
	
	                case 58:
	                  switch (2 * e.charCodeAt(1) + 3 * e.charCodeAt(2)) {
	                    case 530:
	                      if (0 < Y) {
	                        e = n + e.substring(8, x - 1);
	                        break;
	                      }
	
	                    default:
	                      if (1 > B || 1 > v[B - 1].length) e = n + K + e;
	                  }
	
	                  break;
	
	                case 44:
	                  n = "";
	
	                default:
	                  e = 1 < x && 0 < e.indexOf(":") ? n + e.replace(va, "$1" + K + "$2") : n + e + K;
	              }
	
	              A += e;
	            }
	          }
	
	          f[d] = A.replace(P, "").trim();
	        }
	
	        c = f;
	      }
	
	      h = c;
	      if (0 < E && (H = O(2, u, h, b, I, y, t, k, l), void 0 !== H && 0 === (u = H).length)) return M + u + S;
	      u = h.join(",") + "{" + u + "}";
	
	      if (0 !== w * J) {
	        2 !== w || U(u, 2) || (J = 0);
	
	        switch (J) {
	          case 111:
	            u = u.replace(wa, ":-moz-$1") + u;
	            break;
	
	          case 112:
	            u = u.replace(Z, "::-webkit-input-$1") + u.replace(Z, "::-moz-$1") + u.replace(Z, ":-ms-input-$1") + u;
	        }
	
	        J = 0;
	      }
	    }
	
	    return M + u + S;
	  }
	
	  function ia(b, c, d) {
	    var k = c.trim().split(xa);
	    c = k;
	    var l = k.length,
	        a = b.length;
	
	    switch (a) {
	      case 0:
	      case 1:
	        var f = 0;
	
	        for (b = 0 === a ? "" : b[0] + " "; f < l; ++f) {
	          c[f] = ma(b, c[f], d, a).trim();
	        }
	
	        break;
	
	      default:
	        var n = f = 0;
	
	        for (c = []; f < l; ++f) {
	          for (var e = 0; e < a; ++e) {
	            c[n++] = ma(b[e] + " ", k[f], d, a).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function ma(b, c, d, k) {
	    var l = c.charCodeAt(0);
	    33 > l && (l = (c = c.trim()).charCodeAt(0));
	
	    switch (l) {
	      case 38:
	        switch (z + k) {
	          case 0:
	          case 1:
	            if (0 === b.trim().length) break;
	
	          default:
	            return c.replace(M, "$1" + b.trim());
	        }
	
	        break;
	
	      case 58:
	        switch (c.charCodeAt(1)) {
	          case 103:
	            if (0 < Y && 0 < z) return c.replace(ya, "$1").replace(M, "$1" + R);
	            break;
	
	          default:
	            return b.trim() + c;
	        }
	
	      default:
	        if (0 < d * z && 0 < c.indexOf("\f")) return c.replace(M, (58 === b.charCodeAt(0) ? "" : "$1") + b.trim());
	    }
	
	    return b + c;
	  }
	
	  function ja(b, c, d, k) {
	    var l = 0,
	        a = b + ";";
	    c = 2 * c + 3 * d + 4 * k;
	
	    if (944 === c) {
	      l = a.length;
	      b = a.indexOf(":", 9) + 1;
	      d = a.substring(0, b).trim();
	      k = a.substring(b, l - 1).trim();
	
	      switch (a.charCodeAt(9) * Q) {
	        case 0:
	          break;
	
	        case 45:
	          if (110 !== a.charCodeAt(10)) break;
	
	        default:
	          for (a = k.split((k = "", za)), b = c = 0, l = a.length; c < l; b = 0, ++c) {
	            for (var f = a[c], n = f.split(Aa); f = n[b];) {
	              var e = f.charCodeAt(0);
	              if (1 === Q && (64 < e && 90 > e || 96 < e && 123 > e || 95 === e || 45 === e && 45 !== f.charCodeAt(1))) switch (isNaN(parseFloat(f)) + (-1 !== f.indexOf("("))) {
	                case 1:
	                  switch (f) {
	                    case "infinite":
	                    case "alternate":
	                    case "backwards":
	                    case "running":
	                    case "normal":
	                    case "forwards":
	                    case "both":
	                    case "none":
	                    case "linear":
	                    case "ease":
	                    case "ease-in":
	                    case "ease-out":
	                    case "ease-in-out":
	                    case "paused":
	                    case "reverse":
	                    case "alternate-reverse":
	                    case "inherit":
	                    case "initial":
	                    case "unset":
	                    case "step-start":
	                    case "step-end":
	                      break;
	
	                    default:
	                      f += T;
	                  }
	
	              }
	              n[b++] = f;
	            }
	
	            k += (0 === c ? "" : ",") + n.join(" ");
	          }
	
	      }
	
	      k = d + k + ";";
	      return 1 === w || 2 === w && U(k, 1) ? "-webkit-" + k + k : k;
	    }
	
	    if (0 === w || 2 === w && !U(a, 1)) return a;
	
	    switch (c) {
	      case 1015:
	        return 45 === a.charCodeAt(9) ? "-webkit-" + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return "-webkit-" + a + a;
	
	      case 978:
	        return "-webkit-" + a + "-moz-" + a + a;
	
	      case 1019:
	      case 983:
	        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
	
	      case 883:
	        return 45 === a.charCodeAt(8) ? "-webkit-" + a + a : a;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
	
	          case 115:
	            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
	
	          case 98:
	            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
	        }
	        return "-webkit-" + a + "-ms-" + a + a;
	
	      case 964:
	        return "-webkit-" + a + "-ms-flex-" + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
	        return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
	
	      case 1005:
	        return Ba.test(a) ? a.replace(na, ":-webkit-") + a.replace(na, ":-moz-") + a : a;
	
	      case 1E3:
	        b = a.substring(13).trim();
	        l = b.indexOf("-") + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(l)) {
	          case 226:
	            b = a.replace(aa, "tb");
	            break;
	
	          case 232:
	            b = a.replace(aa, "tb-rl");
	            break;
	
	          case 220:
	            b = a.replace(aa, "lr");
	            break;
	
	          default:
	            return a;
	        }
	
	        return "-webkit-" + a + "-ms-" + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf("sticky", 9)) break;
	
	      case 975:
	        l = (a = b).length - 10;
	        b = (33 === a.charCodeAt(l) ? a.substring(0, l) : a).substring(b.indexOf(":", 7) + 1).trim();
	
	        switch (c = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, "-webkit-" + b) + ";" + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, "-webkit-" + (102 < c ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
	        }
	
	        return a + ";";
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
	
	          case 115:
	            return "-webkit-" + a + "-ms-flex-item-" + a.replace(Ca, "") + a;
	
	          default:
	            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "") + a;
	        }
	        break;
	
	      case 953:
	        if (0 < (l = a.indexOf("-content", 9)) && 109 === a.charCodeAt(l - 3) && 45 !== a.charCodeAt(l - 4)) return b = a.substring(l - 3), "width:-webkit-" + b + "width:-moz-" + b + "width:" + b;
	        break;
	
	      case 962:
	        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === d + k && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(Da, "$1-webkit-$2") + a;
	    }
	
	    return a;
	  }
	
	  function U(b, c) {
	    var d = b.indexOf(1 === c ? ":" : "{"),
	        k = b.substring(0, 3 !== c ? d : 10);
	    d = b.substring(d + 1, b.length - 1);
	    return ba(2 !== c ? k : k.replace(Ea, "$1"), d, c);
	  }
	
	  function sa(b, c) {
	    var d = ja(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return d !== c + ";" ? d.replace(Fa, " or ($1)").substring(4) : "(" + c + ")";
	  }
	
	  function O(b, c, d, k, l, a, f, n, e) {
	    for (var h = 0, q = c, m; h < E; ++h) {
	      switch (m = ca[h].call(F, b, q, d, k, l, a, f, n, e)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          q = m;
	      }
	    }
	
	    switch (q) {
	      case void 0:
	      case !1:
	      case !0:
	      case null:
	      case c:
	        break;
	
	      default:
	        return q;
	    }
	  }
	
	  function da(b) {
	    switch (b) {
	      case void 0:
	      case null:
	        E = ca.length = 0;
	        break;
	
	      default:
	        switch (b.constructor) {
	          case Array:
	            for (var c = 0, d = b.length; c < d; ++c) {
	              da(b[c]);
	            }
	
	            break;
	
	          case Function:
	            ca[E++] = b;
	            break;
	
	          case Boolean:
	            la = !!b | 0;
	        }
	
	    }
	
	    return da;
	  }
	
	  function ea(b) {
	    for (var c in b) {
	      var d = b[c];
	
	      switch (c) {
	        case "keyframe":
	          Q = d | 0;
	          break;
	
	        case "global":
	          Y = d | 0;
	          break;
	
	        case "cascade":
	          z = d | 0;
	          break;
	
	        case "compress":
	          oa = d | 0;
	          break;
	
	        case "semicolon":
	          ka = d | 0;
	          break;
	
	        case "preserve":
	          X = d | 0;
	          break;
	
	        case "prefix":
	          ba = null, d ? "function" !== typeof d ? w = 1 : (w = 2, ba = d) : w = 0;
	      }
	    }
	
	    return ea;
	  }
	
	  function F(b, c) {
	    if (void 0 !== this && this.constructor === F) return fa(b);
	    var d = b,
	        k = d.charCodeAt(0);
	    33 > k && (k = (d = d.trim()).charCodeAt(0));
	    0 < Q && (T = d.replace(Ga, 91 === k ? "" : "-"));
	    k = 1;
	    1 === z ? R = d : K = d;
	    d = [R];
	
	    if (0 < E) {
	      var l = O(-1, c, d, d, I, y, 0, 0, 0);
	      void 0 !== l && "string" === typeof l && (c = l);
	    }
	
	    var a = V(W, d, c, 0, 0);
	    0 < E && (l = O(-2, a, d, d, I, y, a.length, 0, 0), void 0 !== l && "string" !== typeof (a = l) && (k = 0));
	    K = R = T = "";
	    J = 0;
	    y = I = 1;
	    return 0 === oa * k ? a : a.replace(P, "").replace(Ha, "").replace(Ia, "$1").replace(Ja, "$1").replace(Ka, " ");
	  }
	
	  var qa = /^\0+/g,
	      P = /[\0\r\f]/g,
	      na = /: */g,
	      Ba = /zoo|gra/,
	      Da = /([,: ])(transform)/g,
	      za = /,+\s*(?![^(]*[)])/g,
	      Aa = / +\s*(?![^(]*[)])/g,
	      ua = / *[\0] */g,
	      xa = /,\r+?/g,
	      M = /([\t\r\n ])*\f?&/g,
	      ya = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,
	      Ga = /\W+/g,
	      ta = /@(k\w+)\s*(\S*)\s*/,
	      Z = /::(place)/g,
	      wa = /:(read-only)/g,
	      Ha = /\s+(?=[{\];=:>])/g,
	      Ia = /([[}=:>])\s+/g,
	      Ja = /(\{[^{]+?);(?=\})/g,
	      Ka = /\s{2,}/g,
	      va = /([^\(])(:+) */g,
	      aa = /[svh]\w+-[tblr]{2}/,
	      ra = /\(\s*(.*)\s*\)/g,
	      Fa = /([^]*?);/g,
	      Ca = /-self|flex-/g,
	      Ea = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      y = 1,
	      I = 1,
	      J = 0,
	      z = 1,
	      w = 1,
	      Y = 1,
	      oa = 0,
	      ka = 0,
	      X = 0,
	      W = [],
	      ca = [],
	      E = 0,
	      ba = null,
	      la = 0,
	      Q = 1,
	      T = "",
	      K = "",
	      R = "";
	  F.use = da;
	  F.set = ea;
	  void 0 !== ha && ea(ha);
	  return F;
	};
	
	var memoize = function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	};
	var STYLES_KEY = '__emotion_styles';
	var unitless = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  fontWeight: 1,
	  lineClamp: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.memoize = memoize;
	exports.STYLES_KEY = STYLES_KEY;
	exports.unitless = unitless;
	exports.hashString = hashString;
	exports.Stylis = pa;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createEmotion = _interopDefault(__webpack_require__(98));
	
	var context = typeof global !== 'undefined' ? global : {};
	
	var _createEmotion = createEmotion(context);
	var flush = _createEmotion.flush;
	var hydrate = _createEmotion.hydrate;
	var cx = _createEmotion.cx;
	var merge = _createEmotion.merge;
	var getRegisteredStyles = _createEmotion.getRegisteredStyles;
	var injectGlobal = _createEmotion.injectGlobal;
	var keyframes = _createEmotion.keyframes;
	var css = _createEmotion.css;
	var sheet = _createEmotion.sheet;
	var caches = _createEmotion.caches;
	
	exports.flush = flush;
	exports.hydrate = hydrate;
	exports.cx = cx;
	exports.merge = merge;
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.injectGlobal = injectGlobal;
	exports.keyframes = keyframes;
	exports.css = css;
	exports.sheet = sheet;
	exports.caches = caches;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable no-param-reassign */
	var index = function (breakpoints) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      literal = _ref.literal,
	      overlap = _ref.overlap;
	
	  var mq = literal ? breakpoints : ['&'].concat(breakpoints);
	
	  function flatten(obj) {
	    if (typeof obj !== 'object' || obj == null) {
	      return [];
	    }
	
	    if (Array.isArray(obj)) {
	      return obj.map(flatten);
	    }
	
	    return Object.keys(obj).reduce(function (slots, key) {
	      // Check if value is an array, but skip if it looks like a selector.
	      // key.indexOf('&') === 0
	
	      var item = obj[key];
	      if (!Array.isArray(item) && literal) item = [item];
	
	      if ((literal || Array.isArray(item)) && key.charCodeAt(0) !== 38) {
	        var prior = void 0;
	        item.forEach(function (v, index) {
	          // Optimize by removing duplicated media query entries
	          // when they are explicitly known to overlap.
	          if (overlap && prior === v) {
	            return;
	          }
	
	          if (v == null) {
	            // Do not create entries for undefined values as this will
	            // generate empty media media quries
	            return;
	          }
	
	          prior = v;
	
	          if (index === 0 && !literal) {
	            slots[key] = v;
	          } else if (slots[mq[index]] === undefined) {
	            var _slots$mq$index;
	
	            slots[mq[index]] = (_slots$mq$index = {}, _slots$mq$index[key] = v, _slots$mq$index);
	          } else {
	            slots[mq[index]][key] = v;
	          }
	        });
	      } else if (typeof item === 'object') {
	        slots[key] = flatten(item);
	      } else {
	        slots[key] = item;
	      }
	      return slots;
	    }, {});
	  }
	
	  return function () {
	    for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	      values[_key] = arguments[_key];
	    }
	
	    return values.map(flatten);
	  };
	};
	
	module.exports = index;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 169:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1));function createCommonjsModule(e,t){return e(t={exports:{}},t.exports),t.exports}function makeEmptyFunction(e){return function(){return e}}var emptyFunction=function(){};emptyFunction.thatReturns=makeEmptyFunction,emptyFunction.thatReturnsFalse=makeEmptyFunction(!1),emptyFunction.thatReturnsTrue=makeEmptyFunction(!0),emptyFunction.thatReturnsNull=makeEmptyFunction(null),emptyFunction.thatReturnsThis=function(){return this},emptyFunction.thatReturnsArgument=function(e){return e};var emptyFunction_1=emptyFunction;function invariant(e,t,r,n,i,s,o,a){if(!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[r,n,i,s,o,a],u=0;(l=new Error(t.replace(/%s/g,function(){return c[u++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}}var invariant_1=invariant,ReactPropTypesSecret="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",ReactPropTypesSecret_1=ReactPropTypesSecret,factoryWithThrowingShims=function(){function e(e,t,r,n,i,s){s!==ReactPropTypesSecret_1&&invariant_1(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=emptyFunction_1,r.PropTypes=r,r},propTypes=createCommonjsModule(function(e){e.exports=factoryWithThrowingShims()});function cn(e){return e.map(function(e){return!1===e?null:e}).join(" ").replace(/\s+/g," ").trim()}function slideSize(e,t){return 100/e*t/t}function slideTraySize(e,t){return 100*e/t}function pct(e){return e+"%"}var LOADING="loading",SUCCESS="success",ERROR="error",CarouselPropTypes={children:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),direction:propTypes.oneOf(["forward","backward"]),height:function(e,t){var r=e[t];return"vertical"!==e.orientation||null!==r&&"number"==typeof r?null:new Error("Missing required property '"+t+"' when orientation is vertical.  You must supply a number representing the height in pixels")},orientation:propTypes.oneOf(["horizontal","vertical"]),isBgImage:function(e,t){return!0===e[t]&&"img"===e.tag?new Error("HTML img elements should not have a backgroundImage.  Please use "+t+" for other block-level HTML tags, like div, a, section, etc..."):null}},boundedRange=function(e){var t=e.min,r=e.max,n=e.x;return Math.min(r,Math.max(t,n))},s={buttonBack:"_buttonBack_113ph_1"},classCallCheck=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},createClass=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},inherits=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},objectWithoutProperties=function(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r},possibleConstructorReturn=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},toConsumableArray=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},ButtonBack=function(e){function t(e){classCallCheck(this,t);var r=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.handleOnClick=r.handleOnClick.bind(r),r.state={disabled:t.setDisabled(e.disabled,e.currentSlide)},r}return inherits(t,e),createClass(t,null,[{key:"setDisabled",value:function(e,t){return null!==e?e:0===t}}]),createClass(t,[{key:"componentWillReceiveProps",value:function(e){this.setState({disabled:t.setDisabled(e.disabled,e.currentSlide)})}},{key:"handleOnClick",value:function(e){var t=this.props,r=t.carouselStore,n=t.currentSlide,i=t.onClick,s=t.step,o=Math.max(n-s,0);r.setStoreState({currentSlide:o},null!==i&&i.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.className),r=(e.currentSlide,e.disabled,e.onClick,e.step,objectWithoutProperties(e,["carouselStore","className","currentSlide","disabled","onClick","step"])),n=cn([s.buttonBack,"carousel__back-button",t]);return React.createElement("button",_extends({"aria-label":"previous",className:n,onClick:this.handleOnClick,disabled:this.state.disabled},r),this.props.children)}}]),t}(React.Component);ButtonBack.propTypes={carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,step:propTypes.number.isRequired},ButtonBack.defaultProps={className:null,disabled:null,onClick:null};var jkrosoType=createCommonjsModule(function(e,t){var r={}.toString,n="undefined"!=typeof window?window.Node:Function;e.exports=t=function(e){var t=typeof e;if("object"!=t)return t;if(t=i[r.call(e)],"object"==t)return e instanceof Map?"map":e instanceof Set?"set":"object";if(t)return t;if(e instanceof n)switch(e.nodeType){case 1:return"element";case 3:return"text-node";case 9:return"document";case 11:return"document-fragment";default:return"dom-node"}};var i=t.types={"[object Function]":"function","[object Date]":"date","[object RegExp]":"regexp","[object Arguments]":"arguments","[object Array]":"array","[object Set]":"set","[object String]":"string","[object Null]":"null","[object Undefined]":"undefined","[object Number]":"number","[object Boolean]":"boolean","[object Object]":"object","[object Map]":"map","[object Text]":"text-node","[object Uint8Array]":"bit-array","[object Uint16Array]":"bit-array","[object Uint32Array]":"bit-array","[object Uint8ClampedArray]":"bit-array","[object Error]":"error","[object FormData]":"form-data","[object File]":"file","[object Blob]":"blob"}}),jkrosoType_1=jkrosoType.types;function equal(e,t,r){if(e===t)return!0;var n=types[jkrosoType(e)],i=types[jkrosoType(t)];return!(!n||n!==i)&&n(e,t,r)}var types={};function memoGaurd(e){return function(t,r,n){if(!n)return e(t,r,[]);for(var i,s=n.length;i=n[--s];)if(i[0]===t&&i[1]===r)return!0;return e(t,r,n)}}function arrayEqual(e,t,r){var n=e.length;if(n!==t.length)return!1;for(r.push([e,t]);n--;)if(!equal(e[n],t[n],r))return!1;return!0}function objectEqual(e,t,r){if("function"==typeof e.equal)return r.push([e,t]),e.equal(t,r);var n=getEnumerableProperties(e),i=getEnumerableProperties(t),s=n.length;if(s!==i.length)return!1;for(n.sort(),i.sort();s--;)if(n[s]!==i[s])return!1;for(r.push([e,t]),s=n.length;s--;){var o=n[s];if(!equal(e[o],t[o],r))return!1}return!0}function getEnumerableProperties(e){var t=[];for(var r in e)"constructor"!==r&&t.push(r);return t}types.number=function(e,t){return e!=e&&t!=t},types.function=function(e,t,r){return e.toString()===t.toString()&&types.object(e,t,r)&&equal(e.prototype,t.prototype)},types.date=function(e,t){return+e==+t},types.regexp=function(e,t){return e.toString()===t.toString()},types.element=function(e,t){return e.outerHTML===t.outerHTML},types.textnode=function(e,t){return e.textContent===t.textContent},types.arguments=types["bit-array"]=types.array=memoGaurd(arrayEqual),types.object=memoGaurd(objectEqual);var equals=equal,isMergeableObject=function(e){return isNonNullObject(e)&&!isSpecial(e)};function isNonNullObject(e){return!!e&&"object"==typeof e}function isSpecial(e){var t=Object.prototype.toString.call(e);return"[object RegExp]"===t||"[object Date]"===t||isReactElement(e)}var canUseSymbol="function"==typeof Symbol&&Symbol.for,REACT_ELEMENT_TYPE=canUseSymbol?Symbol.for("react.element"):60103;function isReactElement(e){return e.$$typeof===REACT_ELEMENT_TYPE}function emptyTarget(e){return Array.isArray(e)?[]:{}}function cloneIfNecessary(e,t){return t&&!0===t.clone&&isMergeableObject(e)?deepmerge(emptyTarget(e),e,t):e}function defaultArrayMerge(e,t,r){var n=e.slice();return t.forEach(function(t,i){void 0===n[i]?n[i]=cloneIfNecessary(t,r):isMergeableObject(t)?n[i]=deepmerge(e[i],t,r):-1===e.indexOf(t)&&n.push(cloneIfNecessary(t,r))}),n}function mergeObject(e,t,r){var n={};return isMergeableObject(e)&&Object.keys(e).forEach(function(t){n[t]=cloneIfNecessary(e[t],r)}),Object.keys(t).forEach(function(i){isMergeableObject(t[i])&&e[i]?n[i]=deepmerge(e[i],t[i],r):n[i]=cloneIfNecessary(t[i],r)}),n}function deepmerge(e,t,r){var n=Array.isArray(t);return n===Array.isArray(e)?n?((r||{arrayMerge:defaultArrayMerge}).arrayMerge||defaultArrayMerge)(e,t,r):mergeObject(e,t,r):cloneIfNecessary(t,r)}deepmerge.all=function(e,t){if(!Array.isArray(e)||e.length<2)throw new Error("first argument should be an array with at least two elements");return e.reduce(function(e,r){return deepmerge(e,r,t)})};var deepmerge_1=deepmerge,cjs=deepmerge_1;function WithStore(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){return{}},r=function(r){function n(e,r){classCallCheck(this,n);var i=possibleConstructorReturn(this,(n.__proto__||Object.getPrototypeOf(n)).call(this,e,r));return i.state=t(_extends({},r.carouselStore.state)),i.updateStateProps=i.updateStateProps.bind(i),i}return inherits(n,r),createClass(n,[{key:"componentWillMount",value:function(){this.context.carouselStore.subscribe(this.updateStateProps)}},{key:"shouldComponentUpdate",value:function(e,t){return!equals(t,this.state)||!equals(e,this.props)}},{key:"componentWillUnmount",value:function(){this.context.carouselStore.unsubscribe(this.updateStateProps)}},{key:"updateStateProps",value:function(){this.setState(t(_extends({},this.context.carouselStore.state)))}},{key:"render",value:function(){var t=this,r=cjs(this.state,this.props);return React.createElement(e,_extends({ref:function(e){t.instance=e}},r,{carouselStore:{getStoreState:this.context.carouselStore.getStoreState,masterSpinnerError:this.context.carouselStore.masterSpinnerError,masterSpinnerSuccess:this.context.carouselStore.masterSpinnerSuccess,setStoreState:this.context.carouselStore.setStoreState,subscribeMasterSpinner:this.context.carouselStore.subscribeMasterSpinner,unsubscribeAllMasterSpinner:this.context.carouselStore.unsubscribeAllMasterSpinner,unsubscribeMasterSpinner:this.context.carouselStore.unsubscribeMasterSpinner}}),this.props.children)}}]),n}(React.Component);return r.propTypes={children:CarouselPropTypes.children},r.defaultProps={children:null},r.contextTypes={carouselStore:propTypes.object},r}var _class,_temp,_class$1,_temp$1,_class$2,_temp$2,_class$3,_temp$3,_class$4,_temp$4,_class$5,_temp$5,_class$6,_temp$6,index=WithStore(ButtonBack,function(e){return{currentSlide:e.currentSlide,step:e.step}}),s$1={buttonFirst:"_buttonFirst_y31jn_1"},ButtonFirst=(_temp=_class=function(e){function t(){classCallCheck(this,t);var e=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.handleOnClick=e.handleOnClick.bind(e),e}return inherits(t,e),createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props,r=t.carouselStore,n=t.onClick;r.setStoreState({currentSlide:0},null!==n&&n.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.className),r=e.currentSlide,n=e.disabled,i=(e.onClick,e.totalSlides,objectWithoutProperties(e,["carouselStore","className","currentSlide","disabled","onClick","totalSlides"])),s=cn([s$1.buttonFirst,"carousel__first-button",t]),o=null!==n?n:0===r;return React.createElement("button",_extends({"aria-label":"first",className:s,onClick:this.handleOnClick,disabled:o},i),this.props.children)}}]),t}(React.Component),_class.propTypes={carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,totalSlides:propTypes.number.isRequired},_class.defaultProps={className:null,disabled:null,onClick:null},_temp),index$1=WithStore(ButtonFirst,function(e){return{currentSlide:e.currentSlide,totalSlides:e.totalSlides}}),s$2={buttonNext:"_buttonNext_p1bs6_1"},ButtonNext=(_temp$1=_class$1=function(e){function t(e){classCallCheck(this,t);var r=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.handleOnClick=r.handleOnClick.bind(r),r.state={disabled:t.setDisabled(e.disabled,e.currentSlide,e.visibleSlides,e.totalSlides)},r}return inherits(t,e),createClass(t,null,[{key:"setDisabled",value:function(e,t,r,n){return null!==e?e:t>=n-r}}]),createClass(t,[{key:"componentWillReceiveProps",value:function(e){this.setState({disabled:t.setDisabled(e.disabled,e.currentSlide,e.visibleSlides,e.totalSlides)})}},{key:"handleOnClick",value:function(e){var t=this.props,r=t.currentSlide,n=t.onClick,i=t.step,s=t.carouselStore,o=this.props.totalSlides-this.props.visibleSlides,a=Math.min(r+i,o);s.setStoreState({currentSlide:a},null!==n&&n.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.className),r=(e.currentSlide,e.disabled,e.onClick,e.step,e.totalSlides,e.visibleSlides,objectWithoutProperties(e,["carouselStore","className","currentSlide","disabled","onClick","step","totalSlides","visibleSlides"])),n=cn([s$2.buttonNext,"carousel__next-button",t]);return React.createElement("button",_extends({"aria-label":"next",className:n,onClick:this.handleOnClick,disabled:this.state.disabled},r),this.props.children)}}]),t}(React.PureComponent),_class$1.propTypes={carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,step:propTypes.number.isRequired,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired},_class$1.defaultProps={className:null,disabled:null,onClick:null},_temp$1),index$2=WithStore(ButtonNext,function(e){return{currentSlide:e.currentSlide,step:e.step,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides}}),s$3={buttonLast:"_buttonLast_x8dvv_1"},ButtonLast=(_temp$2=_class$2=function(e){function t(){classCallCheck(this,t);var e=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.handleOnClick=e.handleOnClick.bind(e),e}return inherits(t,e),createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props,r=t.carouselStore,n=t.onClick,i=t.totalSlides,s=t.visibleSlides;r.setStoreState({currentSlide:i-s},null!==n&&n.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.className),r=e.currentSlide,n=e.disabled,i=(e.onClick,e.totalSlides),s=e.visibleSlides,o=objectWithoutProperties(e,["carouselStore","className","currentSlide","disabled","onClick","totalSlides","visibleSlides"]),a=cn([s$3.buttonLast,"carousel__last-button",t]),l=null!==n?n:r>=i-s;return React.createElement("button",_extends({"aria-label":"last",className:a,onClick:this.handleOnClick,disabled:l},o),this.props.children)}}]),t}(React.Component),_class$2.propTypes={carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired},_class$2.defaultProps={className:null,disabled:null,onClick:null},_temp$2),index$3=WithStore(ButtonLast,function(e){return{currentSlide:e.currentSlide,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides}}),s$4={buttonNext:"_buttonNext_p1bs6_1"},ButtonPlay=(_temp$3=_class$3=function(e){function t(e){classCallCheck(this,t);var r=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.handleOnClick=r.handleOnClick.bind(r),r}return inherits(t,e),createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props.onClick;this.props.carouselStore.setStoreState({isPlaying:!this.props.isPlaying},null!==t&&t.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.children,e.childrenPaused),r=e.childrenPlaying,n=e.className,i=e.isPlaying,s=(e.onClick,objectWithoutProperties(e,["carouselStore","children","childrenPaused","childrenPlaying","className","isPlaying","onClick"])),o=cn([s$4.buttonNext,"carousel__play-button",n]);return React.createElement("button",_extends({"aria-label":"play",className:o,onClick:this.handleOnClick},s),i&&r,!i&&t,this.props.children)}}]),t}(React.PureComponent),_class$3.propTypes={carouselStore:propTypes.object.isRequired,children:propTypes.node,childrenPaused:propTypes.node,childrenPlaying:propTypes.node,className:propTypes.string,isPlaying:propTypes.bool.isRequired,onClick:propTypes.func},_class$3.defaultProps={children:null,childrenPaused:null,childrenPlaying:null,className:null,onClick:null},_temp$3),index$4=WithStore(ButtonPlay,function(e){return{isPlaying:e.isPlaying}}),isExtendable=function(e){return void 0!==e&&null!==e&&("object"==typeof e||"function"==typeof e)},forIn=function(e,t,r){for(var n in e)if(!1===t.call(r,e[n],n,e))break},hasOwn=Object.prototype.hasOwnProperty,forOwn=function(e,t,r){forIn(e,function(n,i){if(hasOwn.call(e,i))return t.call(r,e[i],i,e)})},object_omit=function(e,t){if(!isExtendable(e))return{};var r,n={};"function"==typeof(t=[].concat.apply([],[].slice.call(arguments,1)))[t.length-1]&&(r=t.pop());var i="function"==typeof r;return t.length||i?(forOwn(e,function(s,o){-1===t.indexOf(o)&&(i?r(s,o,e)&&(n[o]=s):n[o]=s)}),n):e},CarouselProvider$1=(_temp$4=_class$4=function(e){function t(e,r){classCallCheck(this,t);var n=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,r)),i={currentSlide:e.currentSlide,disableAnimation:e.disableAnimation,hasMasterSpinner:e.hasMasterSpinner,imageErrorCount:0,imageSuccessCount:0,interval:e.interval,isPageScrollLocked:e.isPageScrollLocked,isPlaying:e.isPlaying,lockOnWindowScroll:e.lockOnWindowScroll,masterSpinnerThreshold:0,naturalSlideHeight:e.naturalSlideHeight,naturalSlideWidth:e.naturalSlideWidth,orientation:e.orientation,playDirection:e.playDirection,slideSize:slideSize(e.totalSlides,e.visibleSlides),slideTraySize:slideTraySize(e.totalSlides,e.visibleSlides),step:e.step,totalSlides:e.totalSlides,touchEnabled:e.touchEnabled,dragEnabled:e.dragEnabled,visibleSlides:e.visibleSlides};return n.carouselStore=new Store(i),n.disableAnimationTimer=null,n}return inherits(t,e),createClass(t,[{key:"getChildContext",value:function(){return{carouselStore:this.carouselStore}}},{key:"componentWillReceiveProps",value:function(e){var t=this,r={};["disableAnimation","hasMasterSpinner","interval","isPlaying","naturalSlideHeight","naturalSlideWidth","lockOnWindowScroll","orientation","playDirection","step","totalSlides","touchEnabled","dragEnabled","visibleSlides"].forEach(function(n){e[n]!==t.props[n]&&(r[n]=e[n])});var n=this.carouselStore.getStoreState(),i=n.currentSlide,s=n.disableAnimation,o=i!==e.currentSlide,a=r.disableAnimation||s;o&&(r.currentSlide=e.currentSlide),o&&!a&&(r.disableAnimation=!0,window.clearTimeout(this.disableAnimationTimer),this.disableAnimationTimer=window.setTimeout(function(){t.carouselStore.setStoreState({disableAnimation:!1})},160)),this.props.totalSlides===e.totalSlides&&this.props.visibleSlides===e.visibleSlides||(r.slideSize=slideSize(e.totalSlides,e.visibleSlides),r.slideTraySize=slideTraySize(e.totalSlides,e.visibleSlides)),Object.keys(r).length>0&&this.carouselStore.setStoreState(r)}},{key:"componentWillUnmount",value:function(){this.carouselStore.unsubscribeAllMasterSpinner(),window.clearTimeout(this.disableAnimationTimer)}},{key:"getStore",value:function(){return this.carouselStore}},{key:"render",value:function(){var e=this.props.tag,r=object_omit(this.props,Object.keys(t.propTypes)),n=cn(["carousel",this.props.className]);return React.createElement(e,_extends({className:n},r),this.props.children)}}]),t}(React.Component),_class$4.propTypes={children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number,disableAnimation:propTypes.bool,hasMasterSpinner:propTypes.bool,interval:propTypes.number,isPageScrollLocked:propTypes.bool,isPlaying:propTypes.bool,lockOnWindowScroll:propTypes.bool,naturalSlideHeight:propTypes.number.isRequired,naturalSlideWidth:propTypes.number.isRequired,orientation:CarouselPropTypes.orientation,playDirection:CarouselPropTypes.direction,step:propTypes.number,tag:propTypes.string,totalSlides:propTypes.number.isRequired,touchEnabled:propTypes.bool,dragEnabled:propTypes.bool,visibleSlides:propTypes.number},_class$4.defaultProps={className:null,currentSlide:0,disableAnimation:!1,hasMasterSpinner:!1,interval:5e3,isPageScrollLocked:!1,isPlaying:!1,lockOnWindowScroll:!1,orientation:"horizontal",playDirection:"forward",step:1,tag:"div",touchEnabled:!0,dragEnabled:!0,visibleSlides:1},_class$4.childContextTypes={carouselStore:propTypes.object},_temp$4),s$5={dot:"_dot_27k82_1"},Dot$1=(_temp$5=_class$5=function(e){function t(e){classCallCheck(this,t);var r=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.handleOnClick=r.handleOnClick.bind(r),r}return inherits(t,e),createClass(t,[{key:"handleOnClick",value:function(e){var t=this.props,r=t.carouselStore,n=t.onClick,i=t.slide,s=t.totalSlides,o=t.visibleSlides,a=i>=s-o?s-o:i;r.setStoreState({currentSlide:a},null!==n&&n.call(this,e))}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.children,e.className),r=e.currentSlide,n=e.disabled,i=(e.onClick,e.selected),s=e.slide,o=(e.totalSlides,e.visibleSlides),a=objectWithoutProperties(e,["carouselStore","children","className","currentSlide","disabled","onClick","selected","slide","totalSlides","visibleSlides"]),l=s>=r&&s<r+o,c="boolean"==typeof i?i:l,u="boolean"==typeof n?n:!0===l,p=cn([s$5.dot,c&&s$5.dotSelected,"carousel__dot","carousel__dot--"+s,c&&"carousel__dot--selected",t]);return React.createElement("button",_extends({onClick:this.handleOnClick,className:p,disabled:u},a),this.props.children)}}]),t}(React.Component),_class$5.propTypes={carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children.isRequired,className:propTypes.string,currentSlide:propTypes.number.isRequired,disabled:propTypes.bool,onClick:propTypes.func,selected:propTypes.bool,slide:propTypes.number.isRequired,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired},_class$5.defaultProps={className:null,disabled:null,onClick:null,selected:null},_temp$5),Dot=WithStore(Dot$1,function(e){return{currentSlide:e.currentSlide,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides}}),s$6={},DotGroup=(_temp$6=_class$6=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return inherits(t,e),createClass(t,[{key:"renderDots",value:function(){for(var e=this.props,t=e.currentSlide,r=e.totalSlides,n=e.visibleSlides,i=[],s=0;s<r;s+=1){var o=s>=t&&s<t+n,a=s>=r-n?r-n:s;i.push(React.createElement(Dot,{key:s,slide:a,selected:o,disabled:o},React.createElement("span",{className:cn["carousel__dot-group-dot"]},this.props.dotNumbers&&s+1)))}return i}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.children),r=e.className,n=(e.currentSlide,e.dotNumbers,e.totalSlides,e.visibleSlides,objectWithoutProperties(e,["carouselStore","children","className","currentSlide","dotNumbers","totalSlides","visibleSlides"])),i=cn([s$6.DotGroup,"carousel__dot-group",r]);return React.createElement("div",_extends({className:i},n),this.renderDots(),t)}}]),t}(React.Component),_class$6.propTypes={children:CarouselPropTypes.children,className:propTypes.string,currentSlide:propTypes.number.isRequired,carouselStore:propTypes.object.isRequired,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired,dotNumbers:propTypes.bool},_class$6.defaultProps={children:null,className:null,dotNumbers:!1},_temp$6),index$5=WithStore(DotGroup,function(e){return{currentSlide:e.currentSlide,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides}}),s$7={image:"_image_u458c_1"},Image$1=function(e){function t(e){classCallCheck(this,t);var r=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.state={imageStatus:LOADING},r.handleImageLoad=r.handleImageLoad.bind(r),r.handleImageError=r.handleImageError.bind(r),r.image=null,r}return inherits(t,e),createClass(t,null,[{key:"subscribeMasterSpinner",value:function(e){e.hasMasterSpinner&&e.carouselStore.subscribeMasterSpinner(e.src)}},{key:"unsubscribeMasterSpinner",value:function(e){e.hasMasterSpinner&&e.carouselStore.unsubscribeMasterSpinner(e.src)}}]),createClass(t,[{key:"componentDidMount",value:function(){t.subscribeMasterSpinner(this.props),this.initImage()}},{key:"componentWillReceiveProps",value:function(e){e.src!==this.props.src&&(t.unsubscribeMasterSpinner(this.props),t.subscribeMasterSpinner(e),this.initImage())}},{key:"componentWillUnmount",value:function(){t.unsubscribeMasterSpinner(this.props),this.image.removeEventListener("load",this.handleImageLoad),this.image.removeEventListener("error",this.handleImageError),this.image=null}},{key:"initImage",value:function(){if(this.setState({imageStatus:LOADING}),this.image=document.createElement("img"),this.image.addEventListener("load",this.handleImageLoad,!1),this.image.addEventListener("error",this.handleImageError,!1),this.image.src=this.props.src,this.image.readyState||this.image.complete){var e=this.image.src;this.image.src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==",this.image.src=e}}},{key:"handleImageLoad",value:function(e){this.setState({imageStatus:SUCCESS}),this.props.hasMasterSpinner&&this.props.carouselStore.masterSpinnerSuccess(this.props.src),this.props.onLoad&&this.props.onLoad(e)}},{key:"handleImageError",value:function(e){this.setState({imageStatus:ERROR}),this.props.hasMasterSpinner&&this.props.carouselStore.masterSpinnerError(this.props.src),this.props.onError&&this.props.onError(e)}},{key:"tempTag",value:function(){return"img"===this.props.tag?"div":this.props.tag}},{key:"customRender",value:function(e){return"function"==typeof this.props[e]?this.props[e]():this.props.children}},{key:"renderLoading",value:function(e){var t=this.tempTag(),r=cn([s$7.image,s$7.imageLoading,"carousel__image",this.props.isBgImage&&"carousel__image--with-background","carousel__image--loading",this.props.className]);return React.createElement(t,_extends({className:r},e),this.customRender("renderLoading"))}},{key:"renderError",value:function(e){var t=this.tempTag(),r=cn([s$7.image,s$7.imageError,"carousel__image",this.props.isBgImage&&"carousel__image--with-background","carousel__image--error",this.props.className]);return React.createElement(t,_extends({className:r},e),this.customRender("renderError"))}},{key:"renderSuccess",value:function(e){var t=this.props,r=t.style,n=t.tag,i=cn([s$7.image,"carousel__image",this.props.isBgImage&&"carousel__image--with-background","carousel__image--success",this.props.className]),s=_extends({},r),o=e;if("img"!==n){var a=e.src;e.alt;o=objectWithoutProperties(e,["src","alt"]),s=_extends({},r,{backgroundImage:'url("'+a+'")',backgroundSize:"cover"})}return React.createElement(n,_extends({className:i,style:s},o),this.props.children)}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.children,e.className,e.hasMasterSpinner,e.isBgImage,e.onError,e.onLoad,e.renderError,e.renderLoading,e.style,e.tag,objectWithoutProperties(e,["carouselStore","children","className","hasMasterSpinner","isBgImage","onError","onLoad","renderError","renderLoading","style","tag"]));switch(this.state.imageStatus){case LOADING:return this.renderLoading(t);case SUCCESS:return this.renderSuccess(t);case ERROR:return this.renderError(t);default:throw new Error("unknown value for this.state.imageStatus")}}}]),t}(React.Component);Image$1.propTypes={alt:propTypes.string,carouselStore:propTypes.object.isRequired,children:CarouselPropTypes.children,className:propTypes.string,hasMasterSpinner:propTypes.bool.isRequired,isBgImage:CarouselPropTypes.isBgImage,onError:propTypes.func,onLoad:propTypes.func,renderError:propTypes.func,renderLoading:propTypes.func,src:propTypes.string.isRequired,style:propTypes.object,tag:propTypes.string},Image$1.defaultProps={alt:"",children:null,className:null,height:null,isBgImage:!1,onError:null,onLoad:null,renderError:null,renderLoading:null,style:null,tag:"img"};var _class$7,_temp$7,_class$8,_temp$8,_class$9,_temp$9,_class$10,_temp$10,Image=WithStore(Image$1,function(e){return{hasMasterSpinner:e.hasMasterSpinner,orientation:e.orientation}}),s$8={container:"_container_1xog2_1",overlay:"_overlay_1xog2_8",hover:"_hover_1xog2_19",zoom:"_zoom_1xog2_23",loading:"_loading_1xog2_27",imageLoadingSpinnerContainer:"_imageLoadingSpinnerContainer_1xog2_31"},MOUSE_SCALE=2,MAX_TOUCH_SCALE=3,ImageWithZoom=(_temp$7=_class$7=function(e){function t(){classCallCheck(this,t);var e=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.state={isImageLoading:!0,isHovering:!1,isZooming:!1,x:null,y:null,scale:1},e.tpCache={},e.handleImageComplete=e.handleImageComplete.bind(e),e.handleOnMouseMove=e.handleOnMouseMove.bind(e),e.handleOnMouseOut=e.handleOnMouseOut.bind(e),e.handleOnMouseOver=e.handleOnMouseOver.bind(e),e.handleOnTouchEnd=e.handleOnTouchEnd.bind(e),e.handleOnTouchMove=e.handleOnTouchMove.bind(e),e.handleOnTouchStart=e.handleOnTouchStart.bind(e),e}return inherits(t,e),createClass(t,null,[{key:"midpointBetweenTwoTouches",value:function(e){var t=e.x1,r=e.y1;return{x:(t+e.x2)/2,y:(r+e.y2)/2}}},{key:"distanceBetweenTwoTouches",value:function(e){var t=e.x1,r=e.y1,n=e.x2,i=e.y2;return Math.sqrt(Math.pow(n-t,2)+Math.pow(i-r,2))}}]),createClass(t,[{key:"componentDidUpdate",value:function(e,t){!1===t.isZooming&&!0===this.state.isZooming&&this.props.carouselStore.setStoreState({isPageScrollLocked:!0}),!0===t.isZooming&&!1===this.state.isZooming&&this.props.carouselStore.setStoreState({isPageScrollLocked:!1})}},{key:"handleImageComplete",value:function(){this.setState({isImageLoading:!1})}},{key:"handleOnMouseOver",value:function(){this.state.isZooming||this.setState({isHovering:!0,scale:MOUSE_SCALE})}},{key:"handleOnMouseOut",value:function(){this.state.isZooming||this.setState({isHovering:!1,scale:1})}},{key:"handleOnMouseMove",value:function(e){if(!this.state.isZooming){var t=pct(e.nativeEvent.offsetX/e.target.offsetWidth*100),r=pct(e.nativeEvent.offsetY/e.target.offsetHeight*100);this.setState({x:t,y:r})}}},{key:"handleOnTouchStart",value:function(e){var t=this;this.props.isPinchZoomEnabled&&([].concat(toConsumableArray(e.targetTouches)).forEach(function(e){t.tpCache[e.identifier]={clientX:e.clientX,clientY:e.clientY}}),this.setState({isZooming:this.state.isZooming||Object.keys(this.tpCache).length>1}))}},{key:"handleOnTouchMove",value:function(e){var r=this;if(this.state.isZooming){e.persist();var n=[].concat(toConsumableArray(e.targetTouches)).filter(function(e){return r.tpCache[e.identifier]}).slice(0,2);if(2===n.length){e.stopPropagation();var i=e.target.getBoundingClientRect(),s=n[0].identifier,o=n[1].identifier,a={x1:this.tpCache[s].clientX,y1:this.tpCache[s].clientY,x2:this.tpCache[o].clientX,y2:this.tpCache[o].clientY};a.distance=t.distanceBetweenTwoTouches(_extends({},a));var l=t.midpointBetweenTwoTouches(_extends({},a));a.cx=l.x,a.cy=l.y;var c={x1:n[0].clientX,y1:n[0].clientY,x2:n[1].clientX,y2:n[1].clientY};c.distance=t.distanceBetweenTwoTouches(_extends({},c));var u=t.midpointBetweenTwoTouches(_extends({},c));c.cx=u.x,c.cy=u.y;var p=pct(boundedRange({min:0,max:100,x:(c.cx-i.left)/i.width*100})),d=pct(boundedRange({min:0,max:100,x:(c.cy-i.top)/i.height*100})),h=boundedRange({min:1,max:MAX_TOUCH_SCALE,x:this.state.scale+(c.distance-a.distance)/100});this.setState({isZooming:1!==h,scale:h,x:p,y:d})}}}},{key:"handleOnTouchEnd",value:function(e){var t=this;this.props.isPinchZoomEnabled&&([].concat(toConsumableArray(e.changedTouches)).forEach(function(e){delete t.tpCache[e.identifier]}),0===Object.keys(this.tpCache).length&&this.setState({isZooming:!1}))}},{key:"renderLoading",value:function(){return this.state.isImageLoading?React.createElement("div",{className:cn([s$8.imageLoadingSpinnerContainer,"carousel__image-loading-spinner-container"])},React.createElement(Spinner$1,null)):null}},{key:"render",value:function(){var e=this.props,t=(e.carouselStore,e.isPinchZoomEnabled,e.tag),r=e.src,n=objectWithoutProperties(e,["carouselStore","isPinchZoomEnabled","tag","src"]),i=cn([s$8.image,"carousel__zoom-image"]),s=cn([s$8.overlay,"carousel__zoom-image-overlay",this.state.isHovering&&s$8.hover,this.state.isZooming&&s$8.zoom,this.state.isHovering&&"carousel__zoom-image-overlay--hovering",this.state.isZooming&&"carousel__zoom-image-overlay--zooming"]),o={};return(this.state.isHovering||this.state.isZooming)&&(o.transformOrigin=this.state.x+" "+this.state.y,o.transform="scale("+this.state.scale+")"),React.createElement(t,_extends({className:s$8.container},n),React.createElement(Image,{className:i,tag:"div",src:r,isBgImage:!0,onLoad:this.handleImageComplete,onError:this.handleImageComplete}),React.createElement(Image,{className:s,tag:"div",src:r,style:o,isBgImage:!0,onMouseOver:this.handleOnMouseOver,onMouseOut:this.handleOnMouseOut,onMouseMove:this.handleOnMouseMove,onTouchStart:this.handleOnTouchStart,onTouchEnd:this.handleOnTouchEnd,onTouchMove:this.handleOnTouchMove}),this.renderLoading())}}]),t}(React.Component),_class$7.propTypes={carouselStore:propTypes.object.isRequired,src:propTypes.string.isRequired,tag:propTypes.string,isPinchZoomEnabled:propTypes.bool},_class$7.defaultProps={isPinchZoomEnabled:!0,tag:"div"},_temp$7),index$6=WithStore(ImageWithZoom,function(){return{}}),s$9={slideInner:"_slideInner_fhwgk_1",slideHorizontal:"_slideHorizontal_fhwgk_1",slide:"_slide_fhwgk_1",focusRing:"_focusRing_fhwgk_26"},Slide=(_temp$8=_class$8=function(e){function t(e){classCallCheck(this,t);var r=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.handleOnFocus=r.handleOnFocus.bind(r),r.handleOnBlur=r.handleOnBlur.bind(r),r.state={focused:!1},r}return inherits(t,e),createClass(t,[{key:"isVisible",value:function(){var e=this.props,t=e.currentSlide,r=e.index,n=e.visibleSlides;return r>=t&&r<t+n}},{key:"handleOnFocus",value:function(e){var t=this,r=this.props.onFocus;this.setState({focused:!0},function(){null!==r&&r.call(t,e)})}},{key:"handleOnBlur",value:function(e){var t=this,r=this.props.onBlur;this.setState({focused:!1},function(){null!==r&&r.call(t,e)})}},{key:"renderFocusRing",value:function(){return this.state.focused?React.createElement("div",{className:[s$9.focusRing,"carousel__slide-focus-ring"].join(" ")}):null}},{key:"render",value:function(){var e=this,t=this.props,r=(t.carouselStore,t.children,t.className),n=t.classNameHidden,i=t.classNameVisible,s=(t.currentSlide,t.index,t.innerClassName),o=t.innerTag,a=t.naturalSlideHeight,l=t.naturalSlideWidth,c=(t.onBlur,t.onFocus,t.orientation),u=t.slideSize,p=t.style,d=t.tabIndex,h=t.tag,S=t.totalSlides,m=(t.visibleSlides,objectWithoutProperties(t,["carouselStore","children","className","classNameHidden","classNameVisible","currentSlide","index","innerClassName","innerTag","naturalSlideHeight","naturalSlideWidth","onBlur","onFocus","orientation","slideSize","style","tabIndex","tag","totalSlides","visibleSlides"])),y={};"horizontal"===c?(y.width=pct(u),y.paddingBottom=pct(100*a/(l*S))):(y.width=pct(100),y.paddingBottom=pct(100*a/l));var b=_extends({},y,p),g=this.isVisible(),f=cn([s$9.slide,"horizontal"===c&&s$9.slideHorizontal,"carousel__slide",this.state.focused&&"carousel__slide--focused",g&&i,g&&"carousel__slide--visible",!g&&n,!g&&"carousel__slide--hidden",r]),v=cn([s$9.slideInner,"carousel__inner-slide",s]),_=this.isVisible()?0:-1,T="number"==typeof d?d:_;return React.createElement(h,_extends({ref:function(t){e.tagRef=t},tabIndex:T,"aria-hidden":!this.isVisible(),onFocus:this.handleOnFocus,onBlur:this.handleOnBlur,className:f,style:b},m),React.createElement(o,{ref:function(t){e.innerTagRef=t},className:v},this.props.children,this.renderFocusRing()))}}]),t}(React.PureComponent),_class$8.propTypes={carouselStore:propTypes.object,children:CarouselPropTypes.children,className:propTypes.string,classNameHidden:propTypes.string,classNameVisible:propTypes.string,currentSlide:propTypes.number.isRequired,index:propTypes.number.isRequired,innerClassName:propTypes.string,innerTag:propTypes.string,naturalSlideHeight:propTypes.number.isRequired,naturalSlideWidth:propTypes.number.isRequired,onBlur:propTypes.func,onFocus:propTypes.func,orientation:CarouselPropTypes.orientation.isRequired,slideSize:propTypes.number.isRequired,style:propTypes.object,tabIndex:propTypes.number,tag:propTypes.string,totalSlides:propTypes.number.isRequired,visibleSlides:propTypes.number.isRequired},_class$8.defaultProps={carouselStore:null,children:null,className:null,classNameHidden:null,classNameVisible:null,innerClassName:null,innerTag:"div",onBlur:null,onFocus:null,style:{},tabIndex:null,tag:"li"},_temp$8),index$7=WithStore(Slide,function(e){return{currentSlide:e.currentSlide,naturalSlideHeight:e.naturalSlideHeight,naturalSlideWidth:e.naturalSlideWidth,orientation:e.orientation,slideSize:e.slideSize,totalSlides:e.totalSlides,visibleSlides:e.visibleSlides}}),GetScrollParent=function(){function e(){classCallCheck(this,e)}return createClass(e,[{key:"parents",value:function(e,t){return null===e.parentNode?t:this.parents(e.parentNode,t.concat([e]))}},{key:"scrollParent",value:function(t){for(var r=this.parents(t.parentNode,[]),n=0;n<r.length;n+=1)if(e.scroll(r[n]))return r[n];return document.scrollingElement||document.documentElement}},{key:"getScrollParent",value:function(t){return e.isNodeValid(t)?this.scrollParent(t):null}}],[{key:"style",value:function(e,t){return getComputedStyle(e,null).getPropertyValue(t)}},{key:"overflow",value:function(t){return e.style(t,"overflow")+e.style(t,"overflow-y")+e.style(t,"overflow-x")}},{key:"scroll",value:function(t){return/(auto|scroll)/.test(e.overflow(t))}},{key:"isNodeValid",value:function(e){return e instanceof HTMLElement||e instanceof SVGElement}}]),e}(),s$10={horizontalSlider:"_horizontalSlider_9ve3r_1",horizontalSliderTray:"_horizontalSliderTray_9ve3r_1",verticalSlider:"_verticalSlider_9ve3r_11",verticalSliderTray:"_verticalSliderTray_9ve3r_1",verticalTray:"_verticalTray_9ve3r_20",verticalSlideTrayWrap:"_verticalSlideTrayWrap_9ve3r_24",sliderTray:"_sliderTray_9ve3r_28",sliderAnimation:"_sliderAnimation_9ve3r_35",masterSpinnerContainer:"_masterSpinnerContainer_9ve3r_40"},Slider=(_temp$9=_class$9=function(e){function t(){classCallCheck(this,t);var e=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.getSliderRef=e.getSliderRef.bind(e),e.handleDocumentScroll=e.handleDocumentScroll.bind(e),e.handleOnKeyDown=e.handleOnKeyDown.bind(e),e.handleOnTouchCancel=e.handleOnTouchCancel.bind(e),e.handleOnTouchEnd=e.handleOnTouchEnd.bind(e),e.handleOnTouchMove=e.handleOnTouchMove.bind(e),e.handleOnTouchStart=e.handleOnTouchStart.bind(e),e.playBackward=e.playBackward.bind(e),e.playForward=e.playForward.bind(e),e.handleOnMouseDown=e.handleOnMouseDown.bind(e),e.handleOnMouseMove=e.handleOnMouseMove.bind(e),e.handleOnMouseClick=e.handleOnMouseClick.bind(e),e.state={deltaX:0,deltaY:0,startX:0,startY:0,isDocumentScrolling:null,isBeingTouchDragged:!1,isBeingMouseDragged:!1,mouseIsMoving:!1},e.interval=null,e.isDocumentScrolling=null,e.moveTimer=null,e.originalOverflow=null,e.scrollParent=null,e}return inherits(t,e),createClass(t,null,[{key:"slideSizeInPx",value:function(e,t,r,n){return("horizontal"===e?t:r)/n}},{key:"slidesMoved",value:function(e,t,r,n){var i=Math.abs(Math.round(("horizontal"===e?t:r)/n)),s=Math.abs("horizontal"===e?t:r)>=.1*n?1:0;return("horizontal"===e?t:r)<0?Math.max(s,i):-Math.max(i,s)}}]),createClass(t,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.handleDocumentScroll),this.props.isPlaying&&this.play()}},{key:"componentDidUpdate",value:function(e){!e.isPlaying&&this.props.isPlaying&&this.play(),e.isPlaying&&!this.props.isPlaying&&this.stop(),!e.isPageScrollLocked&&this.props.isPageScrollLocked&&this.lockScroll(),e.isPageScrollLocked&&!this.props.isPageScrollLocked&&this.unlockScroll()}},{key:"componentWillUnmount",value:function(){document.documentElement.removeEventListener("scroll",this.handleDocumentScroll),window.cancelAnimationFrame.call(window,this.moveTimer),this.stop(),this.moveTimer=null,this.isDocumentScrolling=null}},{key:"onDragStart",value:function(e,t,r,n){this.props.carouselStore.setStoreState({isPlaying:!1}),window.cancelAnimationFrame.call(window,this.moveTimer),"vertical"===this.props.orientation&&this.props.carouselStore.setStoreState({isPageScrollLocked:!0}),this.setState({isBeingTouchDragged:r,isBeingMouseDragged:n,startX:e,startY:t})}},{key:"onDragMove",value:function(e,t){var r=this;this.moveTimer=window.requestAnimationFrame.call(window,function(){r.setState({deltaX:e-r.state.startX,deltaY:t-r.state.startY,mouseIsMoving:r.state.isBeingMouseDragged})})}},{key:"onDragEnd",value:function(){window.cancelAnimationFrame.call(window,this.moveTimer),this.computeCurrentSlide(),"vertical"===this.props.orientation&&this.props.carouselStore.setStoreState({isPageScrollLocked:!1}),this.setState({deltaX:0,deltaY:0,isBeingTouchDragged:!1,isBeingMouseDragged:!1,mouseIsMoving:!1}),this.isDocumentScrolling=!this.props.lockOnWindowScroll&&null}},{key:"getSliderRef",value:function(e){this.sliderTrayElement=e}},{key:"handleOnMouseDown",value:function(e){this.props.dragEnabled&&(e.preventDefault(),this.onDragStart(e.screenX,e.screenY,!1,!0))}},{key:"handleOnMouseMove",value:function(e){this.props.dragEnabled&&this.state.isBeingMouseDragged&&(e.preventDefault(),e.persist(),this.onDragMove(e.screenX,e.screenY))}},{key:"handleOnMouseClick",value:function(e){this.props.dragEnabled&&this.state.isBeingMouseDragged&&(this.state.mouseIsMoving&&e.preventDefault(),this.onDragEnd())}},{key:"handleOnTouchStart",value:function(e){if(this.props.touchEnabled){"vertical"===this.props.orientation&&(e.preventDefault(),e.stopPropagation());var t=e.targetTouches[0];this.onDragStart(t.screenX,t.screenY,!0,!1)}}},{key:"handleDocumentScroll",value:function(){this.props.touchEnabled&&(this.isDocumentScrolling=!0)}},{key:"handleOnTouchMove",value:function(e){if(!(!this.props.touchEnabled||this.props.lockOnWindowScroll&&this.isDocumentScrolling)){window.cancelAnimationFrame.call(window,this.moveTimer);var t=e.targetTouches[0];this.onDragMove(t.screenX,t.screenY)}}},{key:"forward",value:function(){var e=this.props,t=e.currentSlide,r=e.step,n=e.totalSlides,i=e.visibleSlides;return Math.min(t+r,n-i)}},{key:"backward",value:function(){var e=this.props,t=e.currentSlide,r=e.step;return Math.max(t-r,0)}},{key:"handleOnKeyDown",value:function(e){var t=e.keyCode,r=this.props,n=r.carouselStore,i=r.currentSlide,s=r.totalSlides,o=r.visibleSlides,a={};s<=o||(37===t&&(e.preventDefault(),e.stopPropagation(),this.focus(),a.currentSlide=Math.max(0,i-1),a.isPlaying=!1),39===t&&(e.preventDefault(),e.stopPropagation(),this.focus(),a.currentSlide=Math.min(s-o,i+1),a.isPlaying=!1),n.setStoreState(a))}},{key:"playForward",value:function(){var e=this.props,t=e.carouselStore,r=e.currentSlide;t.setStoreState({currentSlide:this.forward()===r?0:this.forward()})}},{key:"playBackward",value:function(){var e=this.props,t=e.carouselStore,r=e.currentSlide,n=e.totalSlides,i=e.visibleSlides;t.setStoreState({currentSlide:this.backward()===r?n-i:this.backward()})}},{key:"play",value:function(){var e=this.props.playDirection;this.interval=setInterval("forward"===e?this.playForward:this.playBackward,this.props.interval)}},{key:"stop",value:function(){window.clearInterval(this.interval),this.interval=null}},{key:"lockScroll",value:function(){var e=new GetScrollParent;this.scrollParent=e.getScrollParent(this.sliderTrayElement),this.scrollParent&&(this.originalOverflow=this.originalOverflow||this.scrollParent.style.overflow,this.scrollParent.style.overflow="hidden")}},{key:"unlockScroll",value:function(){this.scrollParent&&(this.scrollParent.style.overflow=this.originalOverflow,this.originalOverflow=null,this.scrollParent=null)}},{key:"computeCurrentSlide",value:function(){var e=t.slideSizeInPx(this.props.orientation,this.sliderTrayElement.clientWidth,this.sliderTrayElement.clientHeight,this.props.totalSlides),r=t.slidesMoved(this.props.orientation,this.state.deltaX,this.state.deltaY,e),n=this.props.totalSlides-Math.min(this.props.totalSlides,this.props.visibleSlides),i=boundedRange({min:0,max:n,x:this.props.currentSlide+r});this.props.carouselStore.setStoreState({currentSlide:i})}},{key:"focus",value:function(){this.sliderElement.focus()}},{key:"handleOnTouchEnd",value:function(){this.endTouchMove()}},{key:"handleOnTouchCancel",value:function(){this.endTouchMove()}},{key:"endTouchMove",value:function(){this.props.touchEnabled&&this.onDragEnd()}},{key:"renderMasterSpinner",value:function(){var e=this.props,t=e.hasMasterSpinner,r=e.masterSpinnerFinished;return t&&!r?("function"==typeof this.props.onMasterSpinner&&this.props.onMasterSpinner(),React.createElement("div",{className:cn([s$10.masterSpinnerContainer,"carousel__master-spinner-container"])},React.createElement(Spinner$1,null))):null}},{key:"render",value:function(){var e=this,t=this.props,r=(t.carouselStore,t.children),n=t.className,i=t.classNameAnimation,s=t.classNameTray,o=t.classNameTrayWrap,a=t.currentSlide,l=t.disableAnimation,c=(t.dragEnabled,t.hasMasterSpinner,t.interval,t.isPageScrollLocked,t.isPlaying,t.lockOnWindowScroll,t.masterSpinnerFinished,t.naturalSlideHeight),u=t.naturalSlideWidth,p=(t.onMasterSpinner,t.orientation),d=(t.playDirection,t.slideSize),h=t.slideTraySize,S=t.style,m=t.tabIndex,y=(t.totalSlides,t.touchEnabled,t.trayTag),b=t.visibleSlides,g=objectWithoutProperties(t,["carouselStore","children","className","classNameAnimation","classNameTray","classNameTrayWrap","currentSlide","disableAnimation","dragEnabled","hasMasterSpinner","interval","isPageScrollLocked","isPlaying","lockOnWindowScroll","masterSpinnerFinished","naturalSlideHeight","naturalSlideWidth","onMasterSpinner","orientation","playDirection","slideSize","slideTraySize","style","tabIndex","totalSlides","touchEnabled","trayTag","visibleSlides"]),f=_extends({},S),v={};"vertical"===p&&(v.height=0,v.paddingBottom=pct(100*c*b/u),v.width=pct(100));var _={},T=pct(d*a*-1);(this.state.isBeingTouchDragged||this.state.isBeingMouseDragged||l)&&(_.transition="none"),"vertical"===p?(_.transform="translateY("+T+") translateY("+this.state.deltaY+"px)",_.width=pct(100)):(_.width=pct(h),_.transform="translateX("+T+") translateX("+this.state.deltaX+"px)");var k=cn(["vertical"===p?s$10.verticalSlider:s$10.horizontalSlider,"carousel__slider","vertical"===p?"carousel__slider--vertical":"carousel__slider--horizontal",n]),C=cn([s$10.sliderTrayWrap,"carousel__slider-tray-wrapper","vertical"===p?s$10.verticalSlideTrayWrap:s$10.horizontalTrayWrap,"vertical"===p?"carousel__slider-tray-wrap--vertical":"carousel__slider-tray-wrap--horizontal",o]),O=cn([s$10.sliderTray,i||s$10.sliderAnimation,"carousel__slider-tray","vertical"===p?s$10.verticalTray:s$10.horizontalTray,"vertical"===p?"carousel__slider-tray--vertical":"carousel__slider-tray--horizontal",s]),E=null!==m?m:0;return React.createElement("div",_extends({ref:function(t){e.sliderElement=t},className:k,"aria-live":"polite",style:f,tabIndex:E,onKeyDown:this.handleOnKeyDown,role:"listbox"},g),React.createElement("div",{className:C,style:v},React.createElement(y,{ref:this.getSliderRef,className:O,style:_,onTouchStart:this.handleOnTouchStart,onTouchMove:this.handleOnTouchMove,onTouchEnd:this.handleOnTouchEnd,onTouchCancel:this.handleOnTouchCancel,onMouseDown:this.handleOnMouseDown,onMouseMove:this.handleOnMouseMove,onClick:this.handleOnMouseClick},r),this.renderMasterSpinner()))}}]),t}(React.Component),_class$9.propTypes={carouselStore:propTypes.object.isRequired,children:propTypes.node.isRequired,className:propTypes.string,classNameAnimation:propTypes.string,classNameTray:propTypes.string,classNameTrayWrap:propTypes.string,currentSlide:propTypes.number.isRequired,disableAnimation:propTypes.bool.isRequired,dragEnabled:propTypes.bool.isRequired,hasMasterSpinner:propTypes.bool.isRequired,interval:propTypes.number.isRequired,isPageScrollLocked:propTypes.bool.isRequired,isPlaying:propTypes.bool.isRequired,lockOnWindowScroll:propTypes.bool.isRequired,masterSpinnerFinished:propTypes.bool.isRequired,naturalSlideHeight:propTypes.number.isRequired,naturalSlideWidth:propTypes.number.isRequired,onMasterSpinner:propTypes.func,orientation:CarouselPropTypes.orientation.isRequired,playDirection:CarouselPropTypes.direction.isRequired,slideSize:propTypes.number.isRequired,slideTraySize:propTypes.number.isRequired,step:propTypes.number.isRequired,style:propTypes.object,tabIndex:propTypes.number,totalSlides:propTypes.number.isRequired,touchEnabled:propTypes.bool.isRequired,trayTag:propTypes.string,visibleSlides:propTypes.number},_class$9.defaultProps={className:null,classNameAnimation:null,classNameTray:null,classNameTrayWrap:null,disableAnimation:!1,height:null,onMasterSpinner:null,style:{},tabIndex:null,trayTag:"ul",visibleSlides:1},_temp$9),index$8=WithStore(Slider,function(e){return{currentSlide:e.currentSlide,disableAnimation:e.disableAnimation,dragEnabled:e.dragEnabled,hasMasterSpinner:e.hasMasterSpinner,interval:e.interval,isPageScrollLocked:e.isPageScrollLocked,isPlaying:e.isPlaying,lockOnWindowScroll:e.lockOnWindowScroll,masterSpinnerFinished:e.masterSpinnerFinished,naturalSlideHeight:e.naturalSlideHeight,naturalSlideWidth:e.naturalSlideWidth,orientation:e.orientation,playDirection:e.playDirection,slideSize:e.slideSize,slideTraySize:e.slideTraySize,step:e.step,totalSlides:e.totalSlides,touchEnabled:e.touchEnabled,visibleSlides:e.visibleSlides}}),s$11={spinner:"_spinner_1dguc_1",spin:"_spin_1dguc_1"},Spinner$1=(_temp$10=_class$10=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e=this.props,t=e.className,r=objectWithoutProperties(e,["className"]),n=cn([s$11.spinner,"carousel__spinner",t]);return React.createElement("div",_extends({className:n},r))}}]),t}(React.PureComponent),_class$10.propTypes={className:propTypes.string},_class$10.defaultProps={className:null},_temp$10),deepFreeze=function e(t){return Object.freeze(t),Object.getOwnPropertyNames(t).forEach(function(r){!t.hasOwnProperty(r)||null===t[r]||"object"!=typeof t[r]&&"function"!=typeof t[r]||Object.isFrozen(t[r])||e(t[r])}),t},DEFAULT_STATE={masterSpinnerFinished:!1},Store=function(){function e(t){classCallCheck(this,e),this.state=deepFreeze(cjs(DEFAULT_STATE,t)),this.subscriptions=[],this.masterSpinnerSubscriptions={},this.setStoreState=this.setStoreState.bind(this),this.getStoreState=this.getStoreState.bind(this),this.subscribe=this.subscribe.bind(this),this.unsubscribe=this.unsubscribe.bind(this),this.updateSubscribers=this.updateSubscribers.bind(this),this.subscribeMasterSpinner=this.subscribeMasterSpinner.bind(this),this.unsubscribeMasterSpinner=this.unsubscribeMasterSpinner.bind(this),this.unsubscribeAllMasterSpinner=this.unsubscribeAllMasterSpinner.bind(this),this.masterSpinnerSuccess=this.masterSpinnerSuccess.bind(this),this.masterSpinnerError=this.masterSpinnerError.bind(this)}return createClass(e,[{key:"setStoreState",value:function(e,t){this.state=deepFreeze(cjs(this.state,e)),this.updateSubscribers(t)}},{key:"getStoreState",value:function(){return cjs({},this.state)}},{key:"subscribe",value:function(e){this.subscriptions.push(e)}},{key:"unsubscribe",value:function(e){var t=this.subscriptions.indexOf(e);-1!==t&&this.subscriptions.splice(t,1)}},{key:"updateSubscribers",value:function(e){this.subscriptions.forEach(function(e){return e()}),"function"==typeof e&&e(this.getStoreState())}},{key:"subscribeMasterSpinner",value:function(e){-1===Object.keys(this.masterSpinnerSubscriptions).indexOf(e)&&(this.masterSpinnerSubscriptions[e]={success:!1,error:!1,complete:!1})}},{key:"unsubscribeMasterSpinner",value:function(e){return-1!==Object.keys(this.masterSpinnerSubscriptions).indexOf(e)&&(this.setMasterSpinnerFinished(),delete this.masterSpinnerSubscriptions[e])}},{key:"unsubscribeAllMasterSpinner",value:function(){this.masterSpinnerSubscriptions={},this.setMasterSpinnerFinished()}},{key:"masterSpinnerSuccess",value:function(e){this.masterSpinnerSubscriptions[e].success=!0,this.masterSpinnerSubscriptions[e].complete=!0,this.setMasterSpinnerFinished()}},{key:"masterSpinnerError",value:function(e){this.masterSpinnerSubscriptions[e].error=!0,this.masterSpinnerSubscriptions[e].complete=!0,this.setMasterSpinnerFinished()}},{key:"setMasterSpinnerFinished",value:function(){this.setStoreState({masterSpinnerFinished:this.isMasterSpinnerFinished()})}},{key:"isMasterSpinnerFinished",value:function(){var e=this;return!Object.keys(this.masterSpinnerSubscriptions).find(function(t){return!0!==e.masterSpinnerSubscriptions[t].complete})}}]),e}();exports.ButtonBack=index,exports.ButtonFirst=index$1,exports.ButtonNext=index$2,exports.ButtonLast=index$3,exports.ButtonPlay=index$4,exports.CarouselProvider=CarouselProvider$1,exports.Dot=Dot,exports.DotGroup=index$5,exports.Image=Image,exports.ImageWithZoom=index$6,exports.Slide=index$7,exports.Slider=index$8,exports.Spinner=Spinner$1,exports.Store=Store,exports.WithStore=WithStore;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 366:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var emotion = __webpack_require__(9);
	var createEmotionStyled = _interopDefault(__webpack_require__(97));
	
	var index = createEmotionStyled(emotion, React);
	
	exports['default'] = index;
	Object.keys(emotion).forEach(function (key) { exports[key] = emotion[key]; });
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, at, depth) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							insertRule(content)
						break
					// selector
					case 2:
						if (at === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (at) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + delimiter
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(129)(module)))

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _css = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var image = _ref.image,
	        _ref$left = _ref.left,
	        left = _ref$left === undefined ? true : _ref$left,
	        _ref$backgroundColor = _ref.backgroundColor,
	        backgroundColor = _ref$backgroundColor === undefined ? _css.colors.white : _ref$backgroundColor,
	        _ref$order = _ref.order,
	        order = _ref$order === undefined ? 0 : _ref$order,
	        component = _ref.component,
	        _ref$overrideWidth = _ref.overrideWidth,
	        overrideWidth = _ref$overrideWidth === undefined ? false : _ref$overrideWidth;
	    return _react2.default.createElement(
	        s.wrapper,
	        { backgroundColor: backgroundColor, order: order },
	        _react2.default.createElement(
	            s.customWrapper,
	            { left: left, overrideWidth: overrideWidth },
	            component
	        )
	    );
	};
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'e5wp1p50'
	})('background:', function (props) {
	    return props.backgroundColor;
	}, ';display:flex;', function (props) {
	    return (0, _css.mq)({
	        order: [props.order, props.order, props.order, 0]
	    });
	}, ';', (0, _css.mq)({
	    width: ['100%', '100%', '100%', '50%']
	}), ';');
	
	s.customWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'e5wp1p51'
	})('position:relative;height:100%;margin-left:', function (props) {
	    return props.left ? 0 : 'auto';
	}, ';', (0, _css.mq)({
	    width: ['100%', '100%', '100%', function (props) {
	        return props.overrideWidth ? '100%' : 'calc(100% - ' + (0, _css.rWidth)(160 / 2) + ')';
	    }, function (props) {
	        return props.overrideWidth ? '100%' : 'calc(100% - ' + (0, _css.rWidth)(160 / 2) + ')';
	    }, function (props) {
	        return props.overrideWidth ? '100%' : 'calc(100% - ' + (0, _css.rWidth)(160) + ')';
	    }]
	}), ';');
	module.exports = exports['default'];

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _customBlock = __webpack_require__(234);
	
	Object.defineProperty(exports, 'CustomBlock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_customBlock).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _css = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var _ref$backgroundColor = _ref.backgroundColor,
	        backgroundColor = _ref$backgroundColor === undefined ? _css.colors.white : _ref$backgroundColor,
	        _ref$order = _ref.order,
	        order = _ref$order === undefined ? 0 : _ref$order,
	        _ref$id = _ref.id,
	        id = _ref$id === undefined ? '' : _ref$id;
	    return _react2.default.createElement(s.wrapper, _extends({ id: id }, { backgroundColor: backgroundColor, order: order }));
	};
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'esy11nm0'
	})('background:', function (props) {
	    return props.backgroundColor;
	}, ';padding:0;', function (props) {
	    return (0, _css.mq)({
	        order: [props.order, props.order, props.order, 0]
	    });
	}, ';', (0, _css.mq)({
	    width: ['100%', '100%', '100%', '50%']
	}), ';');
	module.exports = exports['default'];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emptyBlock = __webpack_require__(236);
	
	Object.defineProperty(exports, 'EmptyBlock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_emptyBlock).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _css = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var image = _ref.image,
	        _ref$left = _ref.left,
	        left = _ref$left === undefined ? true : _ref$left,
	        _ref$backgroundColor = _ref.backgroundColor,
	        backgroundColor = _ref$backgroundColor === undefined ? _css.colors.white : _ref$backgroundColor,
	        _ref$order = _ref.order,
	        order = _ref$order === undefined ? 0 : _ref$order,
	        _ref$contain = _ref.contain,
	        contain = _ref$contain === undefined ? false : _ref$contain;
	    return _react2.default.createElement(
	        s.wrapper,
	        { backgroundColor: backgroundColor, order: order, contain: contain },
	        _react2.default.createElement(
	            s.imageWrapper,
	            { left: left },
	            _react2.default.createElement(s.image, { image: image, contain: contain })
	        )
	    );
	};
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'esuhska0'
	})('background:', function (props) {
	    return props.backgroundColor;
	}, ';display:flex;', function (props) {
	    return (0, _css.mq)({
	        order: [props.order, props.order, props.order, 0]
	    });
	}, ';', function (props) {
	    return props.contain ? (0, _css.mq)({
	        height: [400, 400, 600, 'auto'],
	        marginTop: [-50, -50, -50, 50],
	        marginBottom: [50]
	    }) : (0, _css.mq)({
	        height: [400, 400, 400, 'auto'],
	        marginTop: [0],
	        marginBottom: [0]
	    });
	}, ';', (0, _css.mq)({
	    width: ['100%', '100%', '100%', '50%']
	}), ';');
	
	s.imageWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'esuhska1'
	})('position:relative;height:100%;margin-left:', function (props) {
	    return props.left ? 0 : 'auto';
	}, ';', (0, _css.mq)({
	    width: ['100%', '100%', '100%', 'calc(100% - ' + (0, _css.rWidth)(160 / 2) + ')', 'calc(100% - ' + (0, _css.rWidth)(160 / 2) + ')', 'calc(100% - ' + (0, _css.rWidth)(160) + ')']
	}), ';');
	
	s.image = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'esuhska2'
	})('position:absolute;top:0;right:0;bottom:0;left:0;background-image:url(\'', function (props) {
	    return props.image;
	}, '\');background-size:', function (props) {
	    return props.contain ? 'contain' : 'cover';
	}, ';background-position:50% 50%;background-repeat:no-repeat;');
	module.exports = exports['default'];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _imageBlock = __webpack_require__(238);
	
	Object.defineProperty(exports, 'ImageBlock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_imageBlock).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CustomBlock = exports.EmptyBlock = exports.ImageBlock = exports.TextBlock = undefined;
	
	var _textBlock = __webpack_require__(240);
	
	var _imageBlock = __webpack_require__(239);
	
	var _emptyBlock = __webpack_require__(237);
	
	var _customBlock = __webpack_require__(235);
	
	exports.TextBlock = _textBlock.TextBlock;
	exports.ImageBlock = _imageBlock.ImageBlock;
	exports.EmptyBlock = _emptyBlock.EmptyBlock;
	exports.CustomBlock = _customBlock.CustomBlock;

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _textBlock = __webpack_require__(241);
	
	Object.defineProperty(exports, 'TextBlock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_textBlock).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _css = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var heading = _ref.heading,
	        text = _ref.text,
	        _ref$left = _ref.left,
	        left = _ref$left === undefined ? true : _ref$left,
	        _ref$backgroundColor = _ref.backgroundColor,
	        backgroundColor = _ref$backgroundColor === undefined ? _css.colors.white : _ref$backgroundColor,
	        _ref$color = _ref.color,
	        color = _ref$color === undefined ? _css.colors.blue : _ref$color,
	        _ref$order = _ref.order,
	        order = _ref$order === undefined ? 0 : _ref$order,
	        _ref$id = _ref.id,
	        id = _ref$id === undefined ? '' : _ref$id,
	        tinyHeading = _ref.tinyHeading;
	    return _react2.default.createElement(
	        s.wrapper,
	        _extends({ id: id }, { backgroundColor: backgroundColor, left: left, order: order }),
	        _react2.default.createElement(
	            s.heading,
	            { color: color },
	            tinyHeading ? _react2.default.createElement(
	                'h3',
	                null,
	                heading
	            ) : _react2.default.createElement(
	                'h2',
	                null,
	                heading
	            )
	        ),
	        _react2.default.createElement(
	            s.content,
	            { color: color },
	            text
	        )
	    );
	};
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'e10p9gc80'
	})('background:', function (props) {
	    return props.backgroundColor;
	}, ';', function (props) {
	    return (0, _css.mq)({
	        order: [props.order, props.order, props.order, 0]
	    });
	}, ';', function (props) {
	    return props.left ? (0, _css.mq)({
	        paddingLeft: [20, 60, 60, 30, (0, _css.rWidth)(240 / 2), (0, _css.rWidth)(240)],
	        paddingRight: [20, 60, 60, 30, (0, _css.rWidth)(148 / 2), (0, _css.rWidth)(148)]
	    }) : (0, _css.mq)({
	        paddingLeft: [20, 60, 60, 30, (0, _css.rWidth)(148 - 80 / 2), (0, _css.rWidth)(148 - 80)],
	        paddingRight: [20, 60, 60, 30, (0, _css.rWidth)(240 + 80 / 2), (0, _css.rWidth)(240 + 80)]
	    });
	}, ';', (0, _css.mq)({
	    width: ['100%', '100%', '100%', '50%'],
	    paddingTop: [60, 60, 80, 80, 80, 120],
	    paddingBottom: [60, 60, 80, 80, 80, 120]
	}), ';');
	
	s.heading = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'e10p9gc81'
	})('line-height:', (0, _css.lineHeight)(53, 45), ';h2,h3{margin:0 0 1.5em;color:', function (props) {
	    return props.color;
	}, ';text-align:left;', (0, _css.mq)({
	    paddingRight: [20, 20, 20, 0]
	}), ';}h2{letter-spacing:', (0, _css.letterSpacing)(200), ';', (0, _css.mq)({
	    fontSize: [(0, _css.fontSize)(20), (0, _css.fontSize)(25), (0, _css.fontSize)(25), (0, _css.fontSize)(20), (0, _css.fontSize)(30)]
	}), ';}h3{font-weight:600;', (0, _css.mq)({
	    marginLeft: [0, 0, 0, 0, (0, _css.rWidth)(80)],
	    fontSize: [(0, _css.fontSize)(14), (0, _css.fontSize)(16), (0, _css.fontSize)(16), (0, _css.fontSize)(16)]
	}), ';}');
	
	s.content = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'e10p9gc82'
	})('line-height:', (0, _css.lineHeight)(32, 16), ';letter-spacing:', (0, _css.letterSpacing)(11), ';color:', function (props) {
	    return props.color;
	}, ';', (0, _css.mq)({
	    marginLeft: [0, 0, 0, 0, (0, _css.rWidth)(80)],
	    fontSize: [(0, _css.fontSize)(14), (0, _css.fontSize)(16), (0, _css.fontSize)(16), (0, _css.fontSize)(16)]
	}), ';');
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emotion = __webpack_require__(9);
	
	var _common = __webpack_require__(75);
	
	var _our_platform = __webpack_require__(205);
	
	var _our_platform2 = _interopRequireDefault(_our_platform);
	
	var _content = __webpack_require__(57);
	
	var _ecoSystemComponent = __webpack_require__(250);
	
	var _ecoSystemComponent2 = _interopRequireDefault(_ecoSystemComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutUs = function (_PureComponent) {
	    _inherits(AboutUs, _PureComponent);
	
	    function AboutUs() {
	        _classCallCheck(this, AboutUs);
	
	        return _possibleConstructorReturn(this, _PureComponent.call(this));
	    }
	
	    AboutUs.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { id: 'aboutUs', className: s.wrapper },
	            _react2.default.createElement(_common.TextBlock, {
	                heading: _content.aboutUs.aboutUs.heading,
	                text: _content.aboutUs.aboutUs.content,
	                order: 1
	            }),
	            _react2.default.createElement(_common.CustomBlock, {
	                component: _react2.default.createElement(_ecoSystemComponent2.default, null),
	                order: 2
	            })
	        );
	    };
	
	    return AboutUs;
	}(_react.PureComponent);
	
	exports.default = AboutUs;
	
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _emotion.css)('display:flex;flex-direction:row;flex-wrap:wrap;');
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(79);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _emotion = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _css = __webpack_require__(8);
	
	var _expert_knowledge = __webpack_require__(130);
	
	var _expert_knowledge2 = _interopRequireDefault(_expert_knowledge);
	
	var _external_data = __webpack_require__(131);
	
	var _external_data2 = _interopRequireDefault(_external_data);
	
	var _forecast = __webpack_require__(132);
	
	var _forecast2 = _interopRequireDefault(_forecast);
	
	var _historical_data = __webpack_require__(133);
	
	var _historical_data2 = _interopRequireDefault(_historical_data);
	
	var _internal_data = __webpack_require__(134);
	
	var _internal_data2 = _interopRequireDefault(_internal_data);
	
	var _logo = __webpack_require__(135);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _monitoring = __webpack_require__(136);
	
	var _monitoring2 = _interopRequireDefault(_monitoring);
	
	var _rules = __webpack_require__(137);
	
	var _rules2 = _interopRequireDefault(_rules);
	
	var _segmentation = __webpack_require__(138);
	
	var _segmentation2 = _interopRequireDefault(_segmentation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EcoSystem = function (_PureComponent) {
	    _inherits(EcoSystem, _PureComponent);
	
	    function EcoSystem() {
	        _classCallCheck(this, EcoSystem);
	
	        return _possibleConstructorReturn(this, _PureComponent.call(this));
	    }
	
	    EcoSystem.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: s.scaler },
	            _react2.default.createElement(
	                'div',
	                { className: s.wrapper },
	                _react2.default.createElement(_logo2.default, { className: s.logo }),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(s.element, s.expertKnowledge),
	                        'data-tag': 'Expert Knowledge' },
	                    _react2.default.createElement(_expert_knowledge2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(s.element, s.externalData),
	                        'data-tag': 'External Data' },
	                    _react2.default.createElement(_external_data2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(s.element, s.segmentation),
	                        'data-tag': 'Segmentation' },
	                    _react2.default.createElement(_segmentation2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(s.element, s.internalData),
	                        'data-tag': 'Internal Data' },
	                    _react2.default.createElement(_internal_data2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(s.element, s.monitoring),
	                        'data-tag': 'Monitoring' },
	                    _react2.default.createElement(_monitoring2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(s.element, s.forecast),
	                        'data-tag': 'Forecast' },
	                    _react2.default.createElement(_forecast2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)(s.element, s.rules), 'data-tag': 'Rules' },
	                    _react2.default.createElement(_rules2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(s.element, s.historicalData),
	                        'data-tag': 'Historical Data' },
	                    _react2.default.createElement(_historical_data2.default, null)
	                )
	            )
	        );
	    };
	
	    return EcoSystem;
	}(_react.PureComponent);
	
	exports.default = EcoSystem;
	
	
	var s = {};
	
	s.scaler = /*#__PURE__*/(0, _emotion.css)('width:100%;height:100%;position:relative;', (0, _css.mq)({
	    transform: ['scale(0.4)', 'scale(0.6)', 'scale(0.9)', 'scale(0.6)', 'scale(0.7)', 'scale(1)']
	}), ';');
	
	s.wrapper = /*#__PURE__*/(0, _emotion.css)('position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:800px;height:550px;');
	
	s.logo = /*#__PURE__*/(0, _emotion.css)('position:absolute;top:230px;left:50%;transform:translateX(-50%);width:250px;height:100px;');
	
	s.element = /*#__PURE__*/(0, _emotion.css)('position:absolute;width:130px;height:130px;transform:translateX(-50%);&::after{content:attr(data-tag);position:absolute;top:calc(100% + 10px);width:100%;text-align:center;color:', _css.colors.blue, ';font-size:', (0, _css.fontSize)(14), ';}svg{position:absolute;width:100%;height:90%;bottom:0;}');
	
	s.expertKnowledge = /*#__PURE__*/(0, _emotion.css)('top:200px;left:calc(50% - 290px);');
	
	s.externalData = /*#__PURE__*/(0, _emotion.css)('top:30px;left:calc(50% - 170px);svg{/* bottom:-15px;*/}');
	
	s.segmentation = /*#__PURE__*/(0, _emotion.css)('top:0;left:50%;');
	
	s.internalData = /*#__PURE__*/(0, _emotion.css)('top:30px;left:calc(50% + 170px);svg{/* bottom:-15px;*/}');
	
	s.monitoring = /*#__PURE__*/(0, _emotion.css)('top:200px;left:calc(50% + 290px);');
	
	s.forecast = /*#__PURE__*/(0, _emotion.css)('top:370px;left:calc(50% + 170px);');
	
	s.rules = /*#__PURE__*/(0, _emotion.css)('top:400px;left:50%;');
	
	s.historicalData = /*#__PURE__*/(0, _emotion.css)('top:370px;left:calc(50% - 170px);');
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _css = __webpack_require__(8);
	
	var _ecoSystemComplex = __webpack_require__(249);
	
	var _ecoSystemComplex2 = _interopRequireDefault(_ecoSystemComplex);
	
	var _ecoSystemSimple = __webpack_require__(251);
	
	var _ecoSystemSimple2 = _interopRequireDefault(_ecoSystemSimple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EcoSystem = function (_PureComponent) {
	    _inherits(EcoSystem, _PureComponent);
	
	    function EcoSystem() {
	        _classCallCheck(this, EcoSystem);
	
	        return _possibleConstructorReturn(this, _PureComponent.call(this));
	    }
	
	    EcoSystem.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: s.decider },
	            _react2.default.createElement(
	                'div',
	                { className: s.simple },
	                _react2.default.createElement(_ecoSystemSimple2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: s.complex },
	                _react2.default.createElement(_ecoSystemComplex2.default, null)
	            )
	        );
	    };
	
	    return EcoSystem;
	}(_react.PureComponent);
	
	exports.default = EcoSystem;
	
	
	var s = {};
	
	s.decider = /*#__PURE__*/(0, _emotion.css)('position:relative;width:100%;height:100%;> div{position:relative;width:100%;height:100%;}');
	
	s.simple = /*#__PURE__*/(0, _emotion.css)((0, _css.mq)({
	    display: ['block', 'block', 'none', 'block', 'none']
	}), ';');
	
	s.complex = /*#__PURE__*/(0, _emotion.css)((0, _css.mq)({
	    display: ['none', 'none', 'block', 'none', 'block'],
	    minHeight: [0, 0, 600, 0, 600],
	    marginTop: [0, 0, -100, 0, 0]
	}), ';');
	module.exports = exports['default'];

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(79);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _emotion = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _css = __webpack_require__(8);
	
	var _expert_knowledge = __webpack_require__(130);
	
	var _expert_knowledge2 = _interopRequireDefault(_expert_knowledge);
	
	var _external_data = __webpack_require__(131);
	
	var _external_data2 = _interopRequireDefault(_external_data);
	
	var _forecast = __webpack_require__(132);
	
	var _forecast2 = _interopRequireDefault(_forecast);
	
	var _historical_data = __webpack_require__(133);
	
	var _historical_data2 = _interopRequireDefault(_historical_data);
	
	var _internal_data = __webpack_require__(134);
	
	var _internal_data2 = _interopRequireDefault(_internal_data);
	
	var _monitoring = __webpack_require__(136);
	
	var _monitoring2 = _interopRequireDefault(_monitoring);
	
	var _rules = __webpack_require__(137);
	
	var _rules2 = _interopRequireDefault(_rules);
	
	var _segmentation = __webpack_require__(138);
	
	var _segmentation2 = _interopRequireDefault(_segmentation);
	
	var _logo = __webpack_require__(135);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EcoSystem = function (_PureComponent) {
	    _inherits(EcoSystem, _PureComponent);
	
	    function EcoSystem() {
	        _classCallCheck(this, EcoSystem);
	
	        return _possibleConstructorReturn(this, _PureComponent.call(this));
	    }
	
	    EcoSystem.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: s.wrapper },
	            _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(s.element, s.expertKnowledge),
	                    'data-tag': 'Expert Knowledge' },
	                _react2.default.createElement(_expert_knowledge2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(s.element, s.externalData),
	                    'data-tag': 'External Data' },
	                _react2.default.createElement(_external_data2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(s.element, s.segmentation),
	                    'data-tag': 'Segmentation' },
	                _react2.default.createElement(_segmentation2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(s.element, s.internalData),
	                    'data-tag': 'Internal Data' },
	                _react2.default.createElement(_internal_data2.default, null)
	            ),
	            _react2.default.createElement(_logo2.default, { className: s.logo }),
	            _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(s.element, s.monitoring),
	                    'data-tag': 'Monitoring' },
	                _react2.default.createElement(_monitoring2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(s.element, s.forecast), 'data-tag': 'Forecast' },
	                _react2.default.createElement(_forecast2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(s.element, s.rules), 'data-tag': 'Rules' },
	                _react2.default.createElement(_rules2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(s.element, s.historicalData),
	                    'data-tag': 'Historical Data' },
	                _react2.default.createElement(_historical_data2.default, null)
	            )
	        );
	    };
	
	    return EcoSystem;
	}(_react.PureComponent);
	
	exports.default = EcoSystem;
	
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _emotion.css)('position:relative;display:flex;flex-wrap:wrap;justify-content:space-around;align-items:flex-start;overflow:hidden;', (0, _css.mq)({
	    marginTop: [-50, -50, 0, 50, 0],
	    marginBottom: [50]
	}), ';');
	
	s.logo = /*#__PURE__*/(0, _emotion.css)('margin-top:30px;margin-bottom:10px;width:100%;height:50px;');
	
	s.element = /*#__PURE__*/(0, _emotion.css)('position:relative;margin-bottom:20px;', (0, _css.mq)({
	    marginLeft: [10, 20],
	    marginRight: [10, 20],
	    width: ['calc(50% - 20px)', 'calc(25% - 40px)'],
	    height: [150]
	}), ';&::after{content:attr(data-tag);position:absolute;top:calc(95%);left:50%;transform:translateX(-50%);width:110%;text-align:center;color:', _css.colors.blue, ';', (0, _css.mq)({
	    fontSize: [(0, _css.fontSize)(12), (0, _css.fontSize)(12)]
	}), ';}svg{position:absolute;width:100%;height:90%;bottom:0;left:50%;transform:translateX(-50%);', (0, _css.mq)({
	    maxWidth: [100]
	}), ';}');
	
	s.expertKnowledge = /*#__PURE__*/(0, _emotion.css)();
	
	s.externalData = /*#__PURE__*/(0, _emotion.css)('svg{bottom:-15px;}');
	
	s.segmentation = /*#__PURE__*/(0, _emotion.css)();
	
	s.internalData = /*#__PURE__*/(0, _emotion.css)('svg{bottom:-15px;}');
	
	s.monitoring = /*#__PURE__*/(0, _emotion.css)();
	
	s.forecast = /*#__PURE__*/(0, _emotion.css)();
	
	s.rules = /*#__PURE__*/(0, _emotion.css)();
	
	s.historicalData = /*#__PURE__*/(0, _emotion.css)();
	module.exports = exports['default'];

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M3.85 48.23a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0m-.733-27.757a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0M34.408 6.417a6.234 6.234 0 1 0 12.467 0 6.234 6.234 0 0 0-12.467 0m28.618 14.056a6.234 6.234 0 1 0 12.467 0 6.234 6.234 0 0 0-12.467 0m.228 27.757a6.234 6.234 0 1 0 12.467 0 6.234 6.234 0 0 0-12.467 0M36.72 35.007s-5.133 11.367 1.772 16.44c0 0 9.045-.672 8.19-15.157 0 0-2.75.978-5.011.367-2.262-.611-4.951-1.65-4.951-1.65",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  d: "M38.401 26.887a9.396 9.396 0 0 1 4.797 2.29c.452.403 2.536 2.621 3.216 5.377.31 1.256.53 2.625.53 4.12 0 4.825-1.949 9.042-4.86 11.397.51 5.997 7.36 10.32 13.532 12.437 6.417 2.2 5.318 10.817 5.318 10.817m-48.331 0s-1.1-8.617 5.317-10.817c6.173-2.117 13.022-6.44 13.534-12.437-2.913-2.355-4.861-6.572-4.861-11.398 0-6.957 4.035-11.375 9.196-11.87m-4.336 23.268s5.156 3.452 10.63 0",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M26.67 37.084s3.25-4.446 9.73-2.124c6.477 2.323 8.174 2.17 10.25.948M28.335 56.641l4.95 4.95 3.117-3.117 3.3 3.3 5.5-5.5",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M38.93 39.42a2.52 2.52 0 1 0 5.042 0 2.52 2.52 0 0 0-5.042 0zm-8.299 0a2.521 2.521 0 1 0 5.043-.002 2.521 2.521 0 0 0-5.043.001zm8.299 0s-1.645-1.166-3.257 0m-5.042 0l-4.178-1.77m17.601 1.375l2.658-1.467M.917 48.23a6.234 6.234 0 1 0 12.467 0 6.234 6.234 0 0 0-12.467 0zM.183 20.473a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0zM31.474 6.417a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0zm28.618 14.056a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0zm.228 27.757a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0zm-35.446-9.177l-12.146 6.15m36.714-6.15l11.683 6.059M24.874 27.868l-12.651-4.706m37.219 4.706l11.306-4.522m-23.071.336V12.834M6.234 41.827V26.952m5.194-10.268L31.351 7.15m12.713.49l17.724 8.433m4.216 25.754v-15.12",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 76 73",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("defs", null, _react2.default.createElement("path", {
	  id: "a",
	  d: "M0 55.546h82.839V0H0z"
	}));
	
	var _ref2 = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M46.857 21.328a6.605 6.605 0 0 0-1.049-.485l-.367-.136.13-.242c.897-1.693.107-3.521-2.06-4.774-3.21-1.856-8.424-1.856-11.617 0l-.469.271-.4-.304a3.325 3.325 0 0 0-.4-.277 6.012 6.012 0 0 0-5.446 0c-1.51.897-1.506 2.285 0 3.154l13.277 7.668a9.292 9.292 0 0 0 8.418 0c2.308-1.343 2.296-3.532-.017-4.875",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  d: "M46.874 26.203a9.292 9.292 0 0 1-8.418 0L25.18 18.535c-1.506-.869-1.512-2.257 0-3.154a6.012 6.012 0 0 1 5.445 0c.14.082.274.175.401.277l.4.304.47-.271c3.192-1.856 8.406-1.856 11.616 0 2.167 1.253 2.957 3.081 2.06 4.774l-.13.242.367.136c.363.131.714.293 1.05.485 2.312 1.343 2.324 3.532.016 4.875",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  d: "M28.305 39.083s5.094 2.721 5.932 9.84c.754 6.412-2.47 6.68-3.909 6.35-1.292-.297-24.049-13.404-24.702-13.817C3.363 40.023.183 37.062.183 31.058c0-6.908 5.094-5.233 6.211-4.466 1.116.768 21.911 12.491 21.911 12.491zm20.111-12.88a9.292 9.292 0 0 1-8.418 0L26.72 18.535c-1.506-.869-1.512-2.257 0-3.154a6.012 6.012 0 0 1 5.445 0c.14.082.274.175.4.277l.4.304.47-.271c3.193-1.856 8.407-1.856 11.617 0 2.167 1.253 2.957 3.081 2.059 4.774l-.13.242.368.136c.363.131.714.293 1.049.485 2.313 1.343 2.325 3.532.017 4.875z",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}), _react2.default.createElement("mask", {
	  id: "b",
	  fill: "#fff"
	}, _react2.default.createElement("use", {
	  xlinkHref: "#a"
	})), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  mask: "url(#b)",
	  d: "M69.641 35.249h7.476v-7.006h-7.476z"
	}), _react2.default.createElement("path", {
	  d: "M76.144 25.445a2.765 2.765 0 0 0-5.531 0v2.856M1.924 26.345L46.252.573s1.836-.986 3.914.18c1.733.973 22.11 12.868 22.11 12.868s4.161 2.327 5.431 7.828M66.282 35.343L33.216 54.507",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  mask: "url(#b)"
	}), _react2.default.createElement("path", {
	  d: "M82.656 29.483a9.104 9.104 0 1 1-18.208 0 9.104 9.104 0 0 1 18.208 0zM5.63 30.806c1.117.768 21.911 12.491 21.911 12.491M5.63 34.086c1.117.768 21.911 12.491 21.911 12.491M5.63 37.366c1.117.768 21.911 12.491 21.911 12.491",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  mask: "url(#b)"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 83 56",
	    xmlnsXlink: "http://www.w3.org/1999/xlink",
	    width: "1em",
	    height: "1em"
	  }, props), _ref, _ref2);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("defs", null, _react2.default.createElement("path", {
	  id: "a",
	  d: "M.392.206h57.346v70.611H.392z"
	}));
	
	var _ref2 = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("g", {
	  transform: "translate(27 -.023)"
	}, _react2.default.createElement("mask", {
	  id: "b",
	  fill: "#fff"
	}, _react2.default.createElement("use", {
	  xlinkHref: "#a"
	})), _react2.default.createElement("path", {
	  d: "M8.226 14.422s-5.134 8.3-4.772 12.605c.266 3.187 2.208 1.995 2.208 4.416 0 2.421-5.27 7.05-5.27 9.187 0 2.137 4.343 3.418 4.343 3.418s.308 2.611-.498 3.704c0 0 .285 1.804 1.234 1.804 0 0-1.14.997 0 1.9 0 0 1.377 2.657 0 4.652-1.377 1.994-.76 4.653 2.659 4.653 3.418 0 13.16-2.49 16.245 5.344 2.142 5.434 18.654 7.171 24.775-.248 2.702-3.276-1.042-20.313-1.042-20.313S71.181 17.555 45.9 4.95C20.618-7.656 12.142 8.154 8.225 14.422",
	  fill: "#BEFFFC",
	  mask: "url(#b)"
	})), _react2.default.createElement("path", {
	  d: "M25.124 27.004c.267 3.187 2.207 1.994 2.207 4.415 0 2.422-5.27 7.051-5.27 9.188 0 2.136 4.344 3.418 4.344 3.418s.309 2.611-.498 3.704c0 0 .284 1.803 1.235 1.803 0 0-1.14.997 0 1.9 0 0 1.377 2.658 0 4.652-1.377 1.994-.76 4.653 2.658 4.653 3.419 0 13.16-2.49 16.246 5.344 2.14 5.435 18.652 7.171 24.773-.248 2.702-3.275-1.042-20.312-1.042-20.312s23.075-27.99-2.208-40.595C42.287-7.68 33.812 8.131 29.895 14.4c0 0-2.111 3.413-3.53 6.998",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M30.34 29.618s-.62 1.69.226 2.281c.844.592 3.21-.59 3.21-.59s-1.464-1.775-3.436-1.69z",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M42.412 23.328a1.295 1.295 0 1 0 2.59.001 1.295 1.295 0 0 0-2.59 0m4.634 4.395a1.295 1.295 0 1 0 2.59 0 1.295 1.295 0 0 0-2.59 0m4.464-7.769a1.295 1.295 0 1 0 2.59 0 1.295 1.295 0 0 0-2.59 0m5.587 3.339a1.295 1.295 0 1 0 2.59 0 1.295 1.295 0 0 0-2.59 0",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M37.915 23.496c0 7.454 6.043 13.498 13.498 13.498 7.455 0 13.498-6.044 13.498-13.498 0-7.455-6.043-13.498-13.498-13.498-7.455 0-13.498 6.043-13.498 13.498z",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M40.21 23.581c.018-.326.049-.649.094-.967.77-5.44 5.459-9.639 11.109-9.639M40.462 27.5a11.13 11.13 0 0 1-.44-2.423m11.391 10.338c-3.274 0-6.226-1.41-8.278-3.654m16.324 2.294l6.753 6.753v-.001l.024.025a1.84 1.84 0 1 0 2.605-2.603c-.008-.01-.018-.016-.027-.025l.002-.001-6.753-6.752m-18.841-7.955a1.41 1.41 0 1 0 2.819.001 1.41 1.41 0 0 0-2.82 0zm15.016 0a1.41 1.41 0 1 0 2.82.001 1.41 1.41 0 0 0-2.82 0zm-10.307 4.361a1.411 1.411 0 1 0 2.823 0 1.411 1.411 0 0 0-2.822 0zm4.39-7.697a1.411 1.411 0 1 0 2.823-.001 1.411 1.411 0 0 0-2.823 0zm-9.099 3.336h-4.047m-2.789 0h-.733",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M32.684 23.496h-7.42",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "1.484,2.968,1.484,2.968"
	}), _react2.default.createElement("path", {
	  d: "M23.78 23.496H11.906",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "1.484,2.968,1.484,2.968,1.484,2.968"
	}), _react2.default.createElement("path", {
	  d: "M10.423 23.496H9.69m60.542 0h-4.047m-2.755 0h-2.37m-15.463 1.029l2.48 2.48m2.233-.275l2.894-5.265m1.819-.578l3.28 1.984m-58.12.993a4.572 4.572 0 1 0 9.145 0 4.572 4.572 0 0 0-9.144 0z",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 85 71",
	    xmlnsXlink: "http://www.w3.org/1999/xlink",
	    width: "1em",
	    height: "1em"
	  }, props), _ref, _ref2);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  fill: "#BEFFFC",
	  d: "M3.762 62.84h5.522v-8.6H3.762zm9.91 0h5.522V50.2h-5.522zm9.91 0h5.522V46.161h-5.522zm9.911 0h5.522V42.382h-5.522zm9.909 0h5.522V37.821h-5.522z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M4.739 62.84h5.522v-8.6H4.739zm9.91 0h5.522V50.2h-5.522zm9.911 0h5.522V46.161H24.56zm9.91 0h5.522V42.382H34.47zm9.91 0h5.522V37.821H44.38zm15.432-.243v.244h-.245"
	}), _react2.default.createElement("path", {
	  d: "M58.976 62.84h-1.48",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.296,0.592,0.296,0.592"
	}), _react2.default.createElement("path", {
	  d: "M57.199 62.84h-2.37",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.296,0.592,0.296,0.592,0.296,0.592"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M54.534 62.84h-.244v-.243"
	}), _react2.default.createElement("path", {
	  d: "M54.29 61.571V59.01",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.512,1.025,0.512,1.025"
	}), _react2.default.createElement("path", {
	  d: "M54.29 58.497V31.341",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.512,1.025,0.512,1.025,0.512,1.025"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M54.29 30.828v-.244h.244"
	}), _react2.default.createElement("path", {
	  d: "M55.127 30.584h1.48",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.296,0.592,0.296,0.592"
	}), _react2.default.createElement("path", {
	  d: "M56.903 30.584h2.369",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.296,0.592,0.296,0.592,0.296,0.592"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M59.567 30.584h.245v.244"
	}), _react2.default.createElement("path", {
	  d: "M59.812 31.854v2.562",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.512,1.025,0.512,1.025"
	}), _react2.default.createElement("path", {
	  d: "M59.812 34.928v27.156",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.512,1.025,0.512,1.025,0.512,1.025"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M69.722 62.597v.244h-.245"
	}), _react2.default.createElement("path", {
	  d: "M68.886 62.84h-1.48",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.296,0.592,0.296,0.592"
	}), _react2.default.createElement("path", {
	  d: "M67.109 62.84h-2.37",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.296,0.592,0.296,0.592,0.296,0.592"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M64.444 62.84H64.2v-.243"
	}), _react2.default.createElement("path", {
	  d: "M64.2 61.657v-2.349",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.47,0.9390000000000001,0.47,0.9389999999999999"
	}), _react2.default.createElement("path", {
	  d: "M64.2 58.839V21.265",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.47,0.9390000000000001,0.47,0.9390000000000001,0.47,0.9389999999999999"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M64.2 20.795v-.244h.244"
	}), _react2.default.createElement("path", {
	  d: "M65.037 20.55h1.48",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.296,0.592,0.296,0.592"
	}), _react2.default.createElement("path", {
	  d: "M66.813 20.55h2.369",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.296,0.592,0.296,0.592,0.296,0.592"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M69.478 20.55h.245v.245"
	}), _react2.default.createElement("path", {
	  d: "M69.722 21.734v2.35",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.47,0.9390000000000001,0.47,0.9389999999999999"
	}), _react2.default.createElement("path", {
	  d: "M69.722 24.553v37.574",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.47,0.9390000000000001,0.47,0.9390000000000001,0.47,0.9389999999999999"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M.213 67.87H75.95V.003"
	}), _react2.default.createElement("path", {
	  d: "M7.794 48.015l9.927-5.054 9.386-4.332 9.927-1.263 9.747-5.595 9.928-5.957 9.385-11.01",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "1.466,2.932,1.466,2.932,1.466,2.932"
	}), _react2.default.createElement("path", {
	  d: "M64.989 12.91a2.647 2.647 0 1 0 5.294 0 2.647 2.647 0 0 0-5.294 0zM78.718.184h-5.596M.183 65.072v5.595",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 79 71",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("defs", null, _react2.default.createElement("path", {
	  id: "a",
	  d: "M0 64.222h75.453V0H0z"
	}));
	
	var _ref2 = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M15.767 7.986l.24 10.35 8.544-4.333s-1.324-6.017-8.784-6.017m40.847 27.992a2.371 2.371 0 1 0 4.742 0 2.371 2.371 0 0 0-4.742 0m1.263-22.291a2.371 2.371 0 1 0 4.742 0 2.371 2.371 0 0 0-4.742 0",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("mask", {
	  id: "b",
	  fill: "#fff"
	}, _react2.default.createElement("use", {
	  xlinkHref: "#a"
	})), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  mask: "url(#b)",
	  d: "M3 49h69V6H3zM2 6h71V1H2z"
	}), _react2.default.createElement("path", {
	  d: "M6.921 19.376a8.183 8.183 0 1 0 16.367 0 8.183 8.183 0 0 0-16.367 0z",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  mask: "url(#b)"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  mask: "url(#b)",
	  d: "M9.268 24.927l5.866-5.235 7.175-3.52m-7.205-4.978v8.499V11.4m14.079 2.2h3.31v-3.309h-3.31zm0 5.923h3.31v-3.309h-3.31zm0 5.922h3.31v-3.309h-3.31zm6.077-14.974h10.77M35.26 13.36h8.152m-8.152 2.887h10.77m-10.77 2.889h8.152m-8.152 2.888h10.77m-10.77 2.887h8.152M8.426 41.697a2.166 2.166 0 1 0 4.333 0 2.166 2.166 0 0 0-4.333 0zM17.57 44.2a2.166 2.166 0 1 0 4.333-.001 2.166 2.166 0 0 0-4.332 0zm10.15-8.01a2.166 2.166 0 1 0 4.332 0 2.166 2.166 0 0 0-4.333 0zm9.225 1.638a2.166 2.166 0 1 0 4.332 0 2.166 2.166 0 0 0-4.332 0zM59.506 13.6a2.166 2.166 0 1 0 4.333 0 2.166 2.166 0 0 0-4.333 0zM29.834 52h15.071v-3H29.834zm-17.317-9.385l5.054 1.083m4.016-.677l6.543-5.55m3.881-.857l4.918.948M60.383 15.45L40.584 36.254m17.75-.351a2.166 2.166 0 1 0 4.332 0 2.166 2.166 0 0 0-4.332 0zm-4.603 3.358V42.6h3.339m0-13.357h-3.34v3.34m13.357 0v-3.34h-3.339m0 13.357h3.34v-3.339M48.146 64.14L42.337 52h-9.709l-5.742 12.14"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  mask: "url(#b)",
	  d: "M30.056 23.697l.722.586.932-1.255"
	}), _react2.default.createElement("path", {
	  d: "M61.312 18.636v11.973",
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  strokeDasharray: "0.489,2.444,0.489,2.444,0.489,2.444",
	  mask: "url(#b)"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 75 64",
	    xmlnsXlink: "http://www.w3.org/1999/xlink",
	    width: "1em",
	    height: "1em"
	  }, props), _ref, _ref2);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("path", {
	  fill: "#2e368f",
	  d: "M14.32 26.89a6.4 6.4 0 0 1-2.59.56 6 6 0 0 1-3.07-.81 5.84 5.84 0 0 1-2.19-2.22 6.33 6.33 0 0 1 0-6.16 5.78 5.78 0 0 1 2.19-2.2 6.12 6.12 0 0 1 5.71-.18 6.79 6.79 0 0 1 2.26 1.73l2-2.53a9.25 9.25 0 0 0-3.17-2.14 9.69 9.69 0 0 0-3.79-.77 9.8 9.8 0 0 0-4.84 1.21A9.3 9.3 0 0 0 3.38 26.1a9.09 9.09 0 0 0 3.4 3.37 9.47 9.47 0 0 0 4.77 1.23 9.24 9.24 0 0 0 3.81-.84 10.27 10.27 0 0 0 3.3-2.28l-2-2.27a7.48 7.48 0 0 1-2.34 1.58zM46 26.63l1.6 3.82h3.71l-7.81-18h-3.63l-7.87 18h3.58l1.6-3.82zm-4.43-10.55l3.14 7.58h-6.34zm28.27-3.68h-3.45v18.05h11.24v-3.13h-7.79V12.4zM104 26.89a6.4 6.4 0 0 1-2.59.56 6 6 0 0 1-3.07-.81 5.84 5.84 0 0 1-2.19-2.22 6.33 6.33 0 0 1 0-6.16 5.78 5.78 0 0 1 2.19-2.2 6.12 6.12 0 0 1 5.71-.18 6.79 6.79 0 0 1 2.26 1.73l2-2.53a9.25 9.25 0 0 0-3.17-2.14 10 10 0 0 0-8.62.44 9.24 9.24 0 0 0-.07 16.09 9.47 9.47 0 0 0 4.77 1.23 9.32 9.32 0 0 0 3.82-.84 10.49 10.49 0 0 0 3.3-2.28l-2-2.27a7.48 7.48 0 0 1-2.34 1.58zm25.58-14.49l-7.91 18h3.58l1.6-3.82h8.82l1.59 3.82H141l-7.81-18zm-1.49 11.26l3.19-7.58 3.15 7.58zm38.03-2.75a4 4 0 0 0 3.14-4 3.87 3.87 0 0 0-1.66-3.3 7.58 7.58 0 0 0-4.55-1.21h-8v18h8.25a8.11 8.11 0 0 0 4.89-1.33 4.31 4.31 0 0 0 1.81-3.6 4.54 4.54 0 0 0-1-3 4.62 4.62 0 0 0-2.88-1.56zm-7.64-5.52h4.39a3.32 3.32 0 0 1 2.1.54 1.87 1.87 0 0 1 .76 1.6 2 2 0 0 1-.76 1.65 3.38 3.38 0 0 1-2.1.59h-4.39zm7 11.45a4.28 4.28 0 0 1-2.57.61h-4.39v-4.77h4.39a4.43 4.43 0 0 1 2.57.61 2 2 0 0 1 .93 1.74 2.09 2.09 0 0 1-.97 1.81zm18.03-14.44h3.45v18.05h-3.45zM215 22.48a5.32 5.32 0 0 0-2-1.6 22.55 22.55 0 0 0-3-1.08 22 22 0 0 1-2.08-.71 3.84 3.84 0 0 1-1.26-.83 1.67 1.67 0 0 1-.56-1.26 1.45 1.45 0 0 1 .73-1.29 3.58 3.58 0 0 1 2-.46 8.57 8.57 0 0 1 2.56.46A13.05 13.05 0 0 1 214.2 17l1.39-3a11.68 11.68 0 0 0-3.05-1.39 12.16 12.16 0 0 0-3.47-.52 9.14 9.14 0 0 0-3.55.65 5.36 5.36 0 0 0-2.37 1.82 4.57 4.57 0 0 0-.84 2.74 4.31 4.31 0 0 0 .83 2.75 5.33 5.33 0 0 0 2 1.56 25.7 25.7 0 0 0 3 1.05c.89.26 1.59.49 2.11.7a3.9 3.9 0 0 1 1.28.81 1.76 1.76 0 0 1 .5 1.28 1.73 1.73 0 0 1-.83 1.51 4 4 0 0 1-2.27.55 8.23 8.23 0 0 1-3.17-.72 10.41 10.41 0 0 1-3.06-2l-1.45 2.94a11.62 11.62 0 0 0 3.51 2.1 11.09 11.09 0 0 0 4.12.79 9.28 9.28 0 0 0 3.57-.64 5.61 5.61 0 0 0 2.45-1.87 4.74 4.74 0 0 0 .89-2.88 4.38 4.38 0 0 0-.79-2.75zM30.03 40.88h23.15v1.03H30.03zm143.64 0h23.15v1.03h-23.15zM30.03.96h23.15v1.03H30.03zm143.64.07h23.15v1.03h-23.15z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    "data-name": "Layer 1",
	    viewBox: "0 0 216.5 43.26",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("defs", null, _react2.default.createElement("path", {
	  id: "a",
	  d: "M0 .018h8.104v1H0z"
	}));
	
	var _ref2 = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("g", {
	  transform: "translate(0 27.196)"
	}, _react2.default.createElement("mask", {
	  id: "b",
	  fill: "#fff"
	}, _react2.default.createElement("use", {
	  xlinkHref: "#a"
	})), _react2.default.createElement("path", {
	  d: "M8.104.018H0",
	  stroke: "#2E388E",
	  strokeWidth: 0.4,
	  mask: "url(#b)"
	})), _react2.default.createElement("path", {
	  d: "M21.3 26.88a2.592 2.592 0 1 0 5.184 0 2.592 2.592 0 0 0-5.185 0m9.279 8.801a2.593 2.593 0 1 0 5.187 0 2.593 2.593 0 0 0-5.187 0m8.939-15.557a2.593 2.593 0 1 0 5.186 0 2.593 2.593 0 0 0-5.186 0m11.19 6.686a2.593 2.593 0 1 0 5.187 0 2.593 2.593 0 0 0-5.187 0",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  d: "M11.167 27.214c0 14.93 12.102 27.031 27.031 27.031 14.93 0 27.031-12.102 27.031-27.03C65.23 12.284 53.127.182 38.2.182c-14.93 0-27.032 12.102-27.032 27.031z",
	  stroke: "#2E388E",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M15.762 27.384c.035-.653.099-1.299.188-1.936C17.494 14.551 26.883 6.144 38.199 6.144M16.268 35.23a22.355 22.355 0 0 1-.882-4.85m22.813 20.703c-6.558 0-12.467-2.823-16.578-7.317m33.023 4.927l13.189 13.19.003-.002c.017.017.03.035.048.052a3.688 3.688 0 1 0 5.215-5.216l-.053-.047.003-.002-13.235-13.236M21.793 27.214a2.824 2.824 0 1 0 5.649.001 2.824 2.824 0 0 0-5.649 0zm30.072 0a2.825 2.825 0 1 0 5.65 0 2.825 2.825 0 0 0-5.65 0zm-20.639 8.733a2.825 2.825 0 1 0 5.65 0 2.825 2.825 0 0 0-5.65 0zm8.791-15.414a2.825 2.825 0 1 0 5.65 0 2.825 2.825 0 0 0-5.65 0zm-18.224 6.681H13.69m62.196 0h-8.104m-5.52 0h-4.747M26.55 29.275l4.968 4.967m4.471-.552l5.796-10.542m3.642-1.16l6.568 3.974",
	  stroke: "#2E388E",
	  strokeWidth: 0.4
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 76 63",
	    xmlnsXlink: "http://www.w3.org/1999/xlink",
	    width: "1em",
	    height: "1em"
	  }, props), _ref, _ref2);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("defs", null, _react2.default.createElement("path", {
	  id: "a",
	  d: "M.148.138H27.01V27H.15z"
	}));
	
	var _ref2 = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("g", {
	  transform: "translate(26 50.669)"
	}, _react2.default.createElement("mask", {
	  id: "b",
	  fill: "#fff"
	}, _react2.default.createElement("use", {
	  xlinkHref: "#a"
	})), _react2.default.createElement("path", {
	  d: "M.148 13.569C.148 20.987 6.161 27 13.58 27c7.418 0 13.43-6.014 13.43-13.432 0-7.416-6.013-13.43-13.43-13.43S.15 6.152.15 13.568",
	  fill: "#BEFFFC",
	  mask: "url(#b)"
	})), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M28.778 63.902H1V1h44.111v46.54M6.947 20.796h31.241M6.947 32.39h31.241M6.947 43.986h31.241M17.239 55.58h10.213"
	}), _react2.default.createElement("path", {
	  d: "M32.648 63.903c0 6.908 5.601 12.509 12.51 12.509 6.908 0 12.51-5.601 12.51-12.51 0-6.908-5.602-12.51-12.51-12.51-6.909 0-12.51 5.602-12.51 12.51zM5.627 55.03a3.264 3.264 0 1 0 6.529 0 3.264 3.264 0 1 0-6.53 0z",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.4,
	  d: "M40.614 70.399h9.729v-9.117h-9.729z"
	}), _react2.default.createElement("path", {
	  d: "M48.343 57.565a2.868 2.868 0 0 0-2.865-2.864 2.868 2.868 0 0 0-2.864 2.864v3.718h-.734M15.633 14.986l-5.92-4.927-5.92 4.927V1h11.84v6.895z",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 58 78",
	    xmlnsXlink: "http://www.w3.org/1999/xlink",
	    width: "1em",
	    height: "1em"
	  }, props), _ref, _ref2);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M31.357 33.887a6.562 6.562 0 1 0 13.124 0 6.562 6.562 0 0 0-13.124 0",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  d: "M24.65 33.887c0 8.346 6.766 15.112 15.112 15.112s15.112-6.766 15.112-15.112-6.766-15.112-15.112-15.112S24.65 25.54 24.65 33.887z",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M33.2 33.887a6.562 6.562 0 1 0 13.124 0 6.562 6.562 0 0 0-13.124 0zM1.949 8.468L39.994 34.45M6.986 11.915L.358 15.229l9.147 6.363 6.677-3.38m-9.16-6.303l.754-7.372 9.188 6.303-.754 7.372m33.163 4.043l10.837-9.842m11.533-5.27a6.959 6.959 0 0 0-6.96-6.96 6.958 6.958 0 0 0-6.96 6.96 6.958 6.958 0 0 0 6.96 6.959 6.959 6.959 0 0 0 6.96-6.96zm11.284 26.694a6.96 6.96 0 1 0-13.92.001 6.96 6.96 0 0 0 13.92 0zM46.688 69.728a6.958 6.958 0 0 0-6.959-6.959 6.958 6.958 0 0 0-6.959 6.96 6.958 6.958 0 0 0 6.959 6.958 6.958 6.958 0 0 0 6.959-6.959zm8.186-35.841h14.185M39.762 49v13.67",
	  stroke: "#28348A",
	  strokeWidth: 0.4
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 83 77",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _aboutUs = __webpack_require__(248);
	
	Object.defineProperty(exports, 'AboutUs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_aboutUs).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.weEmulatePeople = exports.ourVirtualExperts = exports.ourPlatform = exports.aboutUs = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weEmulatePeople = {
	    weEmulatePeople: {
	        heading: 'We emulate people',
	        content: [_react2.default.createElement(
	            'p',
	            { key: '1' },
	            'With our artificial intelligence platform, we create virtual experts who efficiently automate and handle manual tasks in organisations.'
	        ), _react2.default.createElement(
	            'p',
	            { key: '2' },
	            'Calcabis\u2019s customised artificial intelligence solution is based on cutting edge technologies and always in close collaboration with your experts, senior management and IT department. We build on your existing IT infrastructure and supply an individually adapted version of our platform.'
	        ), _react2.default.createElement(
	            'p',
	            { key: '3' },
	            'In short, our focus is to help any type of organisation to become more efficient on a day-to-day basis, and to be able to handle ever more regulatory requirements and increasing societal expectations in relation to compliance.'
	        )]
	    }
	};
	
	var aboutUs = {
	    aboutUs: {
	        heading: 'About us',
	        content: [_react2.default.createElement(
	            'p',
	            { key: '1' },
	            'Calcabis has its origins in the Fin- and RegTech environment in Copenhagen and consist of a highly experienced team, comprising seasoned finance professionals, pioneer developers with more than 15 years\u2019 experience in AI and people with international experience in the fields of hardware and international business development.'
	        ), _react2.default.createElement(
	            'p',
	            { key: '2' },
	            'In Calcabis, we have come together to utilise artificial intelligence to solve the challenges of companies and organisations in terms of automating, quality-assuring, safeguarding compliance with less resources and supporting business-critical manual processes.'
	        ), _react2.default.createElement(
	            'p',
	            { key: '3' },
	            'At Calcabis, our ambition is to give organisations the optimal opportunities and utmost agility in a single, efficient AI platform. We have succeeded in this, and today we offer a platform that handles a wide range of manual tasks and encapsulates and cooperates with human knowledge and involvement.'
	        )]
	    }
	};
	
	var ourPlatform = {
	    platform: {
	        heading: 'Our platform',
	        content: [_react2.default.createElement(
	            'p',
	            { key: '1' },
	            'In real time, Calcabis Virtual Expert Platform constantly monitors your existing clients and ongoing cases across departments, verticals and fields. We integrate and work with all data sources, data sets and any human expert knowledge you possess. This is the case whether the data is structured or unstructured - and no matter which language the data or knowledge comes from.'
	        ), _react2.default.createElement(
	            'p',
	            { key: '2' },
	            'Our virtual experts collect, read, analyse, interpret, conclude and describe details from all processes. That means we can proactively anticipate relevant trends and increase your chances of tracing and documenting fraud and irregularities.'
	        ), _react2.default.createElement(
	            'p',
	            { key: '3' },
	            'Just as in the real world, our platform always enlists the most suitable specialists/virtual experts to solve a specific problem. On the basis of the specific database and existing knowledge in the organisation, Calcabis\u2019s virtual experts devise the optimal process for any given issue.'
	        )]
	    }
	};
	
	var ourVirtualExperts = {
	    virtualExperts: {
	        heading: 'Our virtual experts',
	        content: [_react2.default.createElement(
	            'p',
	            { key: '1' },
	            'By combining multiple AI components, we bridge human knowledge and expertise with real AI.'
	        ), _react2.default.createElement(
	            'p',
	            { key: '2' },
	            'Virtual experts can be customised to all processes and are able to manage and automate complex work processes, while at the same time supporting manual tasks via an integrated and customised neural network of virtual experts. It all happens proactively and across time and space, thereby ensuring you always use the optimum processes and arrive at the correct conclusions fully documented, logged and with full transparency, thereby providing you 100% control of the virtual experts and processes.'
	        )]
	    },
	    transparent: {
	        heading: 'Full transparency',
	        content: _react2.default.createElement(
	            'p',
	            null,
	            'We know the importance of being able to document and report issues in order to comply with regulations and legislation. This is why we offer a fully transparent platform where all steps, data layers and expert knowledge is logged and documented. Based on the level of intelligence in the AI, we not only provide the correct answer to a given problem, we also explain the reasoning behind the conclusion, as well recommend what to do in order to solve it most effectively. This gives you a platform that helps you with any aspect of your daily work, and makes sure that you are always in good and competent hands.'
	        )
	    },
	    control: {
	        heading: 'Full automation',
	        content: _react2.default.createElement(
	            'p',
	            null,
	            'Calcabis Virtual Expert Platform can fully optimise and automate complex work processes. The reason is that our platform works consistently and without hindrance until it finds the right solution. Full automation may require additional knowledge or the setting up of additional virtual experts. On the basis of sufficient data and expert knowledge, we can eliminate the need for manual resources.'
	        )
	    },
	    scalability: {
	        heading: 'Control &amp; scalability',
	        content: [_react2.default.createElement(
	            'p',
	            { key: '1' },
	            'When using Calcabis Virtual Expert Platform, changes do not require comprehensive, expensive system changes, new codes or the like. Our basic principle is that it must be easy to maintain your investment in Calcabis and easy to train your virtual experts.'
	        ), _react2.default.createElement(
	            'p',
	            { key: '2' },
	            'For this reason, we have ensured that you will be able to develop your virtual experts in the future; for example, when new knowledge becomes available in specific areas. Or in case of legislation changes. And if knowledge is missing in an area, you will be alerted and you can add new knowledge to already existing virtual experts, or create an entirely new virtual expert for your \u201Cexpert panel\u201D on an ongoing basis.'
	        ), _react2.default.createElement(
	            'p',
	            { key: '3' },
	            'This makes our platform a future-proof solution for the optimisation of your complex work processes.'
	        )]
	    },
	    areas: {
	        heading: 'Areas of expertise',
	        content: [_react2.default.createElement(
	            'p',
	            { key: '1' },
	            'We have helped our customers get transparency and control with numerous processes such as the below:'
	        ), _react2.default.createElement(
	            'ul',
	            { key: '2' },
	            _react2.default.createElement(
	                'li',
	                null,
	                'KYC'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'AML'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Tax reporting'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'GDPR'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Fraud prevention'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Due diligence'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Risk assessment & management'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Data cleansing'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'M&A'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Analytics calculations'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Patterns & trends'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Optimisation & predictions'
	            )
	        ), _react2.default.createElement(
	            'h4',
	            { key: '3' },
	            'Our platform can be customized to all processess.'
	        )]
	    }
	};
	
	exports.aboutUs = aboutUs;
	exports.ourPlatform = ourPlatform;
	exports.ourVirtualExperts = ourVirtualExperts;
	exports.weEmulatePeople = weEmulatePeople;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/comply_advantage.66218dcb.png";

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _comply_advantage = __webpack_require__(507);
	
	var _comply_advantage2 = _interopRequireDefault(_comply_advantage);
	
	var _lti = __webpack_require__(508);
	
	var _lti2 = _interopRequireDefault(_lti);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	    title: 'Comply Advantage',
	    image: _comply_advantage2.default,
	    content: [_react2.default.createElement(
	        'p',
	        { key: '1' },
	        'ComplyAdvantage helps firms make intelligent choices when complying with regulations relating to sanctions, money laundering and terrorist financing.'
	    ), _react2.default.createElement(
	        'p',
	        { key: '2' },
	        'We combine Artificial Intelligence and machine learning with industry expertise to allow firms to tailor a risk-based approach to their compliance obligations. Our solutions enable companies to improve how they onboard and monitor clients, screen payments and monitor transactions by reducing false positives and speeding up processes, all delivered by flexible, RESTful APIs.'
	    ), _react2.default.createElement(
	        'p',
	        { key: '3' },
	        'Founded in 2014 with offices in London and New York, ComplyAdvantage works globally with some 350 firms in the financial markets and and other regulated high-risk sectors.'
	    )]
	}, {
	    title: "LTI, Let's Solve",
	    image: _lti2.default,
	    content: [_react2.default.createElement(
	        'p',
	        { key: '1' },
	        'LTI (NSE: LTI, BSE: 540005) is a global technology consulting and digital solutions Company helping more than 300 clients succeed in a converging world. With operations in 27 countries, we go the extra mile for our clients and accelerate their digital transformation with LTI\u2019s Mosaic platform enabling their mobile, social, analytics, IoT and cloud journeys.'
	    ), _react2.default.createElement(
	        'p',
	        { key: '2' },
	        'Founded 20 years ago as a subsidiary of Larsen & Toubro Limited, our unique heritage gives us unrivaled real-world expertise to solve the most complex challenges of enterprises across all industries.'
	    ), _react2.default.createElement(
	        'p',
	        { key: '3' },
	        'Each day, our team of more than 24,000 LTItes enable our clients to improve the effectiveness of their business and technology operations, and deliver value to their customers, employees and shareholders. Find more at',
	        _react2.default.createElement(
	            'a',
	            { href: 'https://www.Lntinfotech.com' },
	            ' www.Lntinfotech.com'
	        ),
	        '.'
	    )]
	}];
	module.exports = exports['default'];

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/areas_of_expertise.6e1ba69a.jpg";

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/our_platform.1ed35e44.jpg";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/we_emulate_people.77cae658.jpg";

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Partners = exports.OurVirtualExperts = exports.OurPlatform = exports.AboutUs = exports.WeEmulatePeople = undefined;
	
	var _weEmulatePeople = __webpack_require__(273);
	
	var _aboutUs = __webpack_require__(252);
	
	var _ourPlatform = __webpack_require__(255);
	
	var _ourVirtualExperts = __webpack_require__(258);
	
	var _partners = __webpack_require__(270);
	
	exports.WeEmulatePeople = _weEmulatePeople.WeEmulatePeople;
	exports.AboutUs = _aboutUs.AboutUs;
	exports.OurPlatform = _ourPlatform.OurPlatform;
	exports.OurVirtualExperts = _ourVirtualExperts.OurVirtualExperts;
	exports.Partners = _partners.Partners;

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ourPlatform = __webpack_require__(256);
	
	Object.defineProperty(exports, 'OurPlatform', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ourPlatform).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _css = __webpack_require__(8);
	
	var _common = __webpack_require__(75);
	
	var _content = __webpack_require__(57);
	
	var _our_platform = __webpack_require__(205);
	
	var _our_platform2 = _interopRequireDefault(_our_platform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OurPlatform = function (_PureComponent) {
	    _inherits(OurPlatform, _PureComponent);
	
	    function OurPlatform() {
	        _classCallCheck(this, OurPlatform);
	
	        return _possibleConstructorReturn(this, _PureComponent.call(this));
	    }
	
	    OurPlatform.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { className: s.wrapper },
	            _react2.default.createElement(_common.ImageBlock, {
	                backgroundColor: _css.colors.blue,
	                image: _our_platform2.default
	            }),
	            _react2.default.createElement(_common.TextBlock, {
	                heading: _content.ourPlatform.platform.heading,
	                text: _content.ourPlatform.platform.content,
	                backgroundColor: _css.colors.blue,
	                color: _css.colors.white,
	                left: false,
	                id: 'ourPlatform'
	            })
	        );
	    };
	
	    return OurPlatform;
	}(_react.PureComponent);
	
	exports.default = OurPlatform;
	
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _emotion.css)('display:flex;flex-direction:row;flex-wrap:wrap;');
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M75.773 85.755a5.27 5.27 0 1 0 10.54-.002 5.27 5.27 0 0 0-10.54.002m49.808-52.032a5.268 5.268 0 1 0 10.537.002 5.268 5.268 0 0 0-10.537-.002",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  d: "M12.36 46.365c0 10.04 8.14 18.182 18.181 18.182s18.18-8.141 18.18-18.182c0-10.041-8.139-18.182-18.18-18.182-10.042 0-18.182 8.14-18.182 18.182z",
	  stroke: "#2B3787",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  stroke: "#2B3787",
	  strokeWidth: 0.4,
	  d: "M17.573 58.698l13.034-11.631 16.62-7.568M30.54 28.183v18.884-18.424m31.283 4.888h7.353v-7.353h-7.353zm0 13.16h7.353v-7.354h-7.353zm0 13.159h7.353v-7.353h-7.353zm13.503-33.271h23.93m-23.93 6.417H93.44m-18.114 6.417h23.93m-23.93 6.417H93.44m-18.114 6.417h23.93m-23.93 6.417H93.44M15.701 95.963a4.813 4.813 0 1 0 9.627-.001 4.813 4.813 0 0 0-9.627 0zm20.32 5.559a4.811 4.811 0 0 0 4.812 4.812 4.812 4.812 0 1 0 0-9.624 4.811 4.811 0 0 0-4.812 4.812zM58.57 83.726a4.812 4.812 0 1 0 9.625.002 4.812 4.812 0 0 0-9.625-.002zm20.5 3.64a4.812 4.812 0 1 0 9.624 0 4.812 4.812 0 0 0-9.624 0zm59.757-53.836a4.813 4.813 0 1 0-9.627.001 4.813 4.813 0 0 0 9.627 0M24.792 98.002l11.229 2.406m8.924-1.504l14.538-12.333m8.623-1.905l10.93 2.106m52.114-49.129L87.157 83.864"
	}), _react2.default.createElement("path", {
	  d: "M134.047 41.495V79.16m-40.136 6.944h31.752",
	  stroke: "#2B3787",
	  strokeWidth: 0.4,
	  strokeDasharray: "1,5,1,5,1,5"
	}), _react2.default.createElement("path", {
	  d: "M3.213 64.175v55.178c0 5.436 4.407 9.844 9.844 9.844h138.596c5.437 0 9.844-4.408 9.844-9.843v-95.31c0-5.436-4.407-9.844-9.844-9.844H13.057c-5.437 0-9.844 4.408-9.844 9.844v40.132zm158.071 50.2H3m52.032 36.111c9.4 0 9.182-7.87 9.182-7.87v-12.9m35.418 0v12.9s-.22 7.87 9.183 7.87",
	  stroke: "#2B3787",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M126.107 85.922a5.268 5.268 0 1 0 10.536 0 5.268 5.268 0 0 0-10.536 0",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  d: "M129.346 85.92a4.811 4.811 0 0 0 4.812 4.813 4.812 4.812 0 1 0 0-9.624 4.811 4.811 0 0 0-4.812 4.812zm-10.229 7.462v7.42h7.42m0-29.679h-7.42v7.42m29.679 0v-7.42h-7.42m.001 29.678h7.419v-7.42m-12.111-9.595l-4.375 4.375m4.375-.001l-4.375-4.374M67.934 54.078l-4.374 4.375m4.374 0l-4.374-4.375M86.267 85.41l-4.374 4.376m4.374 0l-4.374-4.375m54.375-53.666l-4.375 4.375m4.375 0l-4.375-4.375M67.81 27.828l-4.376 4.375m4.376 0l-4.376-4.375m.146 15.167l1.75 1.666 2.333-3.583",
	  stroke: "#2B3787",
	  strokeWidth: 0.4
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 165 165",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _css = __webpack_require__(8);
	
	var _answer = __webpack_require__(214);
	
	var _answer2 = _interopRequireDefault(_answer);
	
	var _reason = __webpack_require__(215);
	
	var _reason2 = _interopRequireDefault(_reason);
	
	var _solution = __webpack_require__(216);
	
	var _solution2 = _interopRequireDefault(_solution);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Flow = function (_PureComponent) {
	    _inherits(Flow, _PureComponent);
	
	    function Flow() {
	        _classCallCheck(this, Flow);
	
	        return _possibleConstructorReturn(this, _PureComponent.call(this));
	    }
	
	    Flow.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: s.wrapper },
	            _react2.default.createElement(
	                'div',
	                { className: s.flow },
	                _react2.default.createElement(
	                    'div',
	                    { className: s.svgWrapper, 'data-text': 'Answer' },
	                    _react2.default.createElement(_answer2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: s.svgWrapper, 'data-text': 'Reason' },
	                    _react2.default.createElement(_reason2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: s.svgWrapper, 'data-text': 'Solution' },
	                    _react2.default.createElement(_solution2.default, null)
	                )
	            )
	        );
	    };
	
	    return Flow;
	}(_react.PureComponent);
	
	exports.default = Flow;
	
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _emotion.css)('top:50%;width:100%;transform:translateY(-50%);background:', _css.colors.white, ';', (0, _css.mq)({
	    position: ['relative', 'relative', 'relative', 'absolute', 'relative'],
	    paddingLeft: [20, 60, 60, 30, 0],
	    paddingRight: [20, 60, 60, 100],
	
	    paddingTop: [0, 0, 0, 80, 80, 120],
	    paddingBottom: [60, 60, 80, 80, 80, 120]
	}), ';display:flex;flex-direction:column;');
	
	s.quote = /*#__PURE__*/(0, _emotion.css)('h4{color:', _css.colors.blue, ';font-weight:300;', (0, _css.mq)({
	    fontSize: [(0, _css.fontSize)(20), (0, _css.fontSize)(20), (0, _css.fontSize)(24), (0, _css.fontSize)(24), (0, _css.fontSize)(32)],
	    marginBottom: [40, 40, 40, 60],
	    marginTop: [0, 0, 0, '2em', '1.5em']
	}), ';}');
	
	s.flow = /*#__PURE__*/(0, _emotion.css)('display:flex;justify-content:space-between;align-items:center;', (0, _css.mq)({
	    flexDirection: ['column', 'column', 'row', 'column', 'column', 'row']
	}), ';');
	
	s.svgWrapper = /*#__PURE__*/(0, _emotion.css)((0, _css.mq)({
	    width: ['50%', '50%', '25%']
	}), ';margin-bottom:30px;height:100%;svg{width:100%;height:100%;}&::after{content:attr(data-text);display:block;text-align:center;width:100%;font-size:', (0, _css.fontSize)(12), ';font-weight:500;color:', _css.colors.blue, ';}');
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  fill: "#BEFFFC",
	  d: "M99.789 80.175h12.044V68.13H99.789zm0 21.557h12.044V89.687H99.789zM24.338 68.664a9.604 9.604 0 1 0 19.209 0 9.604 9.604 0 0 0-19.209 0"
	}), _react2.default.createElement("path", {
	  d: "M31.305 68.36a8.773 8.773 0 0 0 8.773 8.772 8.772 8.772 0 0 0 8.773-8.773 8.773 8.773 0 0 0-17.546 0zM12.66 81.96v13.525h13.526m-.001-54.101H12.66v13.525m54.102 0V41.384H53.237m-.001 54.101h13.525V81.96m35.278-23.343h12.044V46.572h-12.044zm0 21.558h12.044V68.13h-12.044zm0 21.557h12.044V89.687h-12.044zm22.119-54.502h39.2m-39.2 10.511h29.674m-29.674 10.512h39.2m-39.2 10.511h29.674m-29.674 10.512h39.2m-39.2 10.512h29.674",
	  stroke: "#2B3787",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M57.278 121.247c0 8.017 6.498 14.514 14.514 14.514 8.015 0 14.513-6.497 14.513-14.514 0-8.016-6.498-14.514-14.513-14.514-8.016 0-14.514 6.498-14.514 14.514",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  stroke: "#2B3787",
	  strokeWidth: 0.4,
	  d: "M59.364 123.891H1.2v-95.69h74.799v78.811"
	}), _react2.default.createElement("path", {
	  d: "M59.14 121.57c0 8.12 6.582 14.7 14.7 14.7 8.118 0 14.7-6.58 14.7-14.7 0-8.118-6.582-14.699-14.7-14.699-8.118 0-14.7 6.581-14.7 14.7zm21.549-7.616L66.553 128.09m14.136 0l-14.136-14.136m44.707-21.518l-6.067 6.067m6.067.001l-6.067-6.067m6.067-21.421l-6.067 6.067m6.067.001l-6.067-6.067m-.419-18.962l2.615 2.615 4.394-4.394",
	  stroke: "#2B3787",
	  strokeWidth: 0.4
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 165 165",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M19.108 116.87a4.676 4.676 0 1 0 9.351 0 4.676 4.676 0 0 0-9.351 0M2.543 56.196H26.07V32.668H2.543zm113.625 60.959a4.42 4.42 0 1 0 8.84-.002 4.42 4.42 0 0 0-8.84.002",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  d: "M92.31 118.783c1.048 15.695 14.11 28.102 30.073 28.102 16.646 0 30.14-13.495 30.14-30.14 0-16.061-12.562-29.188-28.397-30.091m-4.516.076c-14.806 1.351-26.517 13.409-27.324 28.365m6.443-.253c.901-11.308 9.765-20.408 20.967-21.676",
	  stroke: "#2B3787",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M124.52 93.11c12.086 1.085 21.59 11.272 21.59 23.635 0 13.084-10.643 23.727-23.727 23.727-12.261 0-22.38-9.346-23.605-21.29m40.936 22.661l16.132 16.132a4.404 4.404 0 1 0 6.228-6.228l-15.956-15.956",
	  stroke: "#2B3787",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M117.867 116.805a4.415 4.415 0 1 0 8.83-.001 4.415 4.415 0 0 0-8.83.001zm-8.583 6.438v6.805h6.805m.001-27.221h-6.806v6.805m27.221-.001v-6.805H129.7m0 27.221h6.805v-6.805",
	  stroke: "#2B3787",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M115.627 37.397a5.119 5.119 0 1 0 10.238-.002 5.119 5.119 0 0 0-10.238.002",
	  fill: "#BEFFFC"
	}), _react2.default.createElement("path", {
	  stroke: "#2B3787",
	  strokeWidth: 0.4,
	  d: "M5.209 56.196h23.527V32.668H5.209zM38.914 37.34H87.96m-49.046 6.5H76.71m-37.796 6.5H84.71M1.2 111.468a4.676 4.676 0 1 0 9.352 0 4.676 4.676 0 0 0-9.352 0zm19.742 5.402a4.676 4.676 0 1 0 9.352 0 4.676 4.676 0 0 0-9.352 0zm28.413-30.893a4.676 4.676 0 1 0 9.352 0 4.676 4.676 0 0 0-9.352 0zm19.917 3.535a4.675 4.675 0 1 0 9.352 0 4.677 4.677 0 0 0-9.352 0zM127.33 37.21a4.676 4.676 0 1 0-9.353 0 4.676 4.676 0 0 0 9.352 0m28.667-27.333a4.676 4.676 0 1 0-9.353-.002 4.676 4.676 0 0 0 9.353.002M10.032 113.449l10.91 2.338m8.67-1.461L50.243 88.74m8.377-1.85l10.619 2.046m50.631-47.731L77.13 86.11"
	}), _react2.default.createElement("path", {
	  d: "M122.084 42.43v69.538",
	  stroke: "#2B3787",
	  strokeWidth: 0.4,
	  strokeDasharray: "1,5,1,5,1,5"
	}), _react2.default.createElement("path", {
	  d: "M23.395 38.006L11.08 50.321m0-12.315l12.315 12.315m103.148-15.52l21.332-22.333m-124.166 102.5l3.938 3.938m-3.938 0l3.938-3.938m93.229-79.875l3.938 3.938m-3.938-.001l3.938-3.937m-4.23 79.625l3.938 3.938m-3.938 0l3.938-3.938",
	  stroke: "#2B3787",
	  strokeWidth: 0.4
	}), _react2.default.createElement("path", {
	  d: "M30.294 116.87h87.04",
	  stroke: "#2B3787",
	  strokeWidth: 0.4,
	  strokeDasharray: "1,5,1,5,1,5"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 165 165",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ourVirtualExperts = __webpack_require__(259);
	
	Object.defineProperty(exports, 'OurVirtualExperts', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ourVirtualExperts).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _css = __webpack_require__(8);
	
	var _common = __webpack_require__(75);
	
	var _content = __webpack_require__(57);
	
	var _areas_of_expertise = __webpack_require__(509);
	
	var _areas_of_expertise2 = _interopRequireDefault(_areas_of_expertise);
	
	var _flow = __webpack_require__(257);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _steps = __webpack_require__(269);
	
	var _steps2 = _interopRequireDefault(_steps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Industries = function (_PureComponent) {
	    _inherits(Industries, _PureComponent);
	
	    function Industries() {
	        _classCallCheck(this, Industries);
	
	        return _possibleConstructorReturn(this, _PureComponent.call(this));
	    }
	
	    Industries.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'section',
	                { key: 'ourVirtualExperts', className: s.wrapper },
	                _react2.default.createElement(_common.TextBlock, {
	                    heading: _content.ourVirtualExperts.virtualExperts.heading,
	                    text: _content.ourVirtualExperts.virtualExperts.content,
	                    id: 'ourVirtualExperts',
	                    backgroundColor: _css.colors.cyan,
	                    order: 1,
	                    color: _css.colors.blue
	                }),
	                _react2.default.createElement(_common.CustomBlock, {
	                    component: _react2.default.createElement(_steps2.default, null),
	                    backgroundColor: _css.colors.cyan,
	                    order: 2
	                })
	            ),
	            _react2.default.createElement(
	                'section',
	                { key: 'controlAndScalability', className: s.wrapper },
	                _react2.default.createElement(_common.TextBlock, {
	                    heading: _content.ourVirtualExperts.transparent.heading,
	                    order: 1,
	                    tinyHeading: true,
	                    text: _content.ourVirtualExperts.transparent.content,
	                    backgroundColor: _css.colors.white,
	                    color: _css.colors.blue,
	                    left: true
	                }),
	                _react2.default.createElement(_common.CustomBlock, {
	                    overrideWidth: true,
	                    component: _react2.default.createElement(_flow2.default, null),
	                    backgroundColor: _css.colors.white,
	                    order: 2
	                })
	            ),
	            _react2.default.createElement(
	                'section',
	                { key: 'transparencyAndAutomation', className: s.wrapper },
	                _react2.default.createElement(_common.TextBlock, {
	                    heading: _react2.default.createElement('span', {
	                        dangerouslySetInnerHTML: {
	                            __html: _content.ourVirtualExperts.scalability.heading
	                        }
	                    }),
	                    tinyHeading: true,
	                    text: _content.ourVirtualExperts.scalability.content,
	                    backgroundColor: _css.colors.blue,
	                    color: _css.colors.white
	                }),
	                _react2.default.createElement(_common.TextBlock, {
	                    heading: _content.ourVirtualExperts.control.heading,
	                    tinyHeading: true,
	                    text: _content.ourVirtualExperts.control.content,
	                    backgroundColor: _css.colors.blue,
	                    color: _css.colors.white,
	                    left: false
	                })
	            ),
	            _react2.default.createElement(
	                'section',
	                { key: 'areasOfExpertise', className: s.wrapper },
	                _react2.default.createElement(_common.ImageBlock, {
	                    backgroundColor: _css.colors.cyan,
	                    image: _areas_of_expertise2.default,
	                    order: 4
	                }),
	                _react2.default.createElement(_common.TextBlock, {
	                    heading: _content.ourVirtualExperts.areas.heading,
	                    id: 'areasOfExpertise',
	                    text: _content.ourVirtualExperts.areas.content,
	                    backgroundColor: _css.colors.cyan,
	                    color: _css.colors.blue,
	                    left: false,
	                    order: 3
	                })
	            )
	        );
	    };
	
	    return Industries;
	}(_react.PureComponent);
	
	exports.default = Industries;
	
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _reactEmotion.css)('display:flex;flex-direction:row;flex-wrap:wrap;');
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("path", {
	  stroke: "#28348A",
	  d: "M16.98 33L1 17.01 17 1",
	  fill: "none"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 18 34",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _slide1Component = __webpack_require__(261);
	
	Object.defineProperty(exports, 'Slide1', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slide1Component).default;
	  }
	});
	
	var _slide2Component = __webpack_require__(262);
	
	Object.defineProperty(exports, 'Slide2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slide2Component).default;
	  }
	});
	
	var _slide3Component = __webpack_require__(263);
	
	Object.defineProperty(exports, 'Slide3', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slide3Component).default;
	  }
	});
	
	var _slide4Component = __webpack_require__(264);
	
	Object.defineProperty(exports, 'Slide4', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slide4Component).default;
	  }
	});
	
	var _slide5Component = __webpack_require__(265);
	
	Object.defineProperty(exports, 'Slide5', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slide5Component).default;
	  }
	});
	
	var _slide6Component = __webpack_require__(266);
	
	Object.defineProperty(exports, 'Slide6', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slide6Component).default;
	  }
	});
	
	var _slide7Component = __webpack_require__(267);
	
	Object.defineProperty(exports, 'Slide7', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slide7Component).default;
	  }
	});
	
	var _slide8Component = __webpack_require__(268);
	
	Object.defineProperty(exports, 'Slide8', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slide8Component).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pureReactCarousel = __webpack_require__(19);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slideStyles = __webpack_require__(22);
	
	var _slideStyles2 = _interopRequireDefault(_slideStyles);
	
	var _slide_ = __webpack_require__(218);
	
	var _slide_2 = _interopRequireDefault(_slide_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var index = _ref.index;
	    return _react2.default.createElement(
	        _pureReactCarousel.Slide,
	        { className: _slideStyles2.default.slideWrapper, index: index },
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.imageWrapper },
	            _react2.default.createElement(_slide_2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.textWrapper },
	            _react2.default.createElement(
	                'p',
	                null,
	                'A virtual expert is a composition or combination of data, cognitive knowledge, processes and AI components.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    'Here illustrated as building blocks.'
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pureReactCarousel = __webpack_require__(19);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slideStyles = __webpack_require__(22);
	
	var _slideStyles2 = _interopRequireDefault(_slideStyles);
	
	var _slide_ = __webpack_require__(219);
	
	var _slide_2 = _interopRequireDefault(_slide_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var index = _ref.index;
	    return _react2.default.createElement(
	        _pureReactCarousel.Slide,
	        { className: _slideStyles2.default.slideWrapper, index: index },
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.imageWrapper },
	            _react2.default.createElement(_slide_2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.textWrapper },
	            _react2.default.createElement(
	                'p',
	                null,
	                'You define the skillset of the virtual experts, by the information you feed in to them, such as inputting human knowledge from your existing expert employees.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    'Here illustrated as building blocks.'
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pureReactCarousel = __webpack_require__(19);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slideStyles = __webpack_require__(22);
	
	var _slideStyles2 = _interopRequireDefault(_slideStyles);
	
	var _slide_ = __webpack_require__(220);
	
	var _slide_2 = _interopRequireDefault(_slide_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var index = _ref.index;
	    return _react2.default.createElement(
	        _pureReactCarousel.Slide,
	        { className: _slideStyles2.default.slideWrapper, index: index },
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.imageWrapper },
	            _react2.default.createElement(_slide_2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.textWrapper },
	            _react2.default.createElement(
	                'p',
	                null,
	                'The composition and combination of data, cognitive knowledge, processes, and AI components is customized to the specific task each building block is designed to do.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    'It can be any task or level of expertise.'
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pureReactCarousel = __webpack_require__(19);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slideStyles = __webpack_require__(22);
	
	var _slideStyles2 = _interopRequireDefault(_slideStyles);
	
	var _slide_ = __webpack_require__(221);
	
	var _slide_2 = _interopRequireDefault(_slide_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var index = _ref.index;
	    return _react2.default.createElement(
	        _pureReactCarousel.Slide,
	        { className: _slideStyles2.default.slideWrapper, index: index },
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.imageWrapper },
	            _react2.default.createElement(_slide_2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.textWrapper },
	            _react2.default.createElement(
	                'p',
	                null,
	                'All the virtual experts can be paired and put together to handle your specific requirements be it tasks, processes or expertise.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    'Everything fully documented and transparent.'
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pureReactCarousel = __webpack_require__(19);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slideStyles = __webpack_require__(22);
	
	var _slideStyles2 = _interopRequireDefault(_slideStyles);
	
	var _slide_ = __webpack_require__(222);
	
	var _slide_2 = _interopRequireDefault(_slide_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var index = _ref.index;
	    return _react2.default.createElement(
	        _pureReactCarousel.Slide,
	        { className: _slideStyles2.default.slideWrapper, index: index },
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.imageWrapper },
	            _react2.default.createElement(_slide_2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.textWrapper },
	            _react2.default.createElement(
	                'p',
	                null,
	                'The neural network of virtual experts communicates across departments, each\u2019s field and leven of expertise just as in the real world where humans combine skills, knowledge, and know-how to reach the correct solution.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    'All virtual experts combine forces to find the correct conclusion.'
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pureReactCarousel = __webpack_require__(19);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slideStyles = __webpack_require__(22);
	
	var _slideStyles2 = _interopRequireDefault(_slideStyles);
	
	var _slide_ = __webpack_require__(223);
	
	var _slide_2 = _interopRequireDefault(_slide_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var index = _ref.index;
	    return _react2.default.createElement(
	        _pureReactCarousel.Slide,
	        { className: _slideStyles2.default.slideWrapper, index: index },
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.imageWrapper },
	            _react2.default.createElement(_slide_2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.textWrapper },
	            _react2.default.createElement(
	                'p',
	                null,
	                'A decision log is created, displaying each step of how the conclusion was reached, and how each virtual expert was constructed.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    '100% transparency of all data giving a fully documented process.'
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pureReactCarousel = __webpack_require__(19);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slideStyles = __webpack_require__(22);
	
	var _slideStyles2 = _interopRequireDefault(_slideStyles);
	
	var _slide_ = __webpack_require__(224);
	
	var _slide_2 = _interopRequireDefault(_slide_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var index = _ref.index;
	    return _react2.default.createElement(
	        _pureReactCarousel.Slide,
	        { className: _slideStyles2.default.slideWrapper, index: index },
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.imageWrapper },
	            _react2.default.createElement(_slide_2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.textWrapper },
	            _react2.default.createElement(
	                'p',
	                null,
	                'If required each conclusion can be reviewed by your employees to validate the output.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'If there are any discrepancies or mistakes, the employee can go through the decision log to identify the root cause within a specific virtual expert and change the faulted information to ensure a correct outcome in the future.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    'Easy to scale and maintain. '
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pureReactCarousel = __webpack_require__(19);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slideStyles = __webpack_require__(22);
	
	var _slideStyles2 = _interopRequireDefault(_slideStyles);
	
	var _slide_ = __webpack_require__(225);
	
	var _slide_2 = _interopRequireDefault(_slide_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var index = _ref.index;
	    return _react2.default.createElement(
	        _pureReactCarousel.Slide,
	        { className: _slideStyles2.default.slideWrapper, index: index },
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.imageWrapper },
	            _react2.default.createElement(_slide_2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _slideStyles2.default.textWrapper },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Hvis computeren ikke kan komme frem til et svar, p\xE5 basis af den viden den har, vil platformen pege p\xE5 de steder der mangler data eller viden, for at komme frem til det korrekte svar.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    'Here illustrated as building blocks.'
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(17);
	
	var _css = __webpack_require__(8);
	
	var s = {};
	s.slideWrapper = /*#__PURE__*/(0, _reactEmotion.css)('display:flex;flex-direction:column;.carousel__inner-slide{display:flex;flex-direction:column;}');
	
	s.imageWrapper = /*#__PURE__*/(0, _reactEmotion.css)((0, _css.mq)({
	    paddingTop: [0, 0, 0, 40, 60]
	}), ';flex-grow:1;display:flex;justify-content:center;align-items:center;svg{max-width:440px;', (0, _css.mq)({
	    width: ['90%', '90%', '60%', '80%']
	}), ';width:90%;height:100%;}');
	
	s.textWrapper = /*#__PURE__*/(0, _reactEmotion.css)((0, _css.mq)({
	    height: [200, 190, 200, 190, 200]
	}), ';display:flex;flex-direction:column;justify-content:flex-start;align-items:center;p{', (0, _css.mq)({
	    width: ['100%', '100%', 300]
	}), ';margin:0 0 20px;color:', _css.colors.blue, ';font-size:', (0, _css.fontSize)(12), ';line-height:', (0, _css.lineHeight)(24, 16), ';}em{font-style:normal;font-weight:600;}');
	
	exports.default = s;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("defs", null, _react2.default.createElement("path", {
	  id: "a",
	  d: "M0 .322h40.037v30.244H0z"
	}));
	
	var _ref2 = _react2.default.createElement("g", {
	  id: "slide_1",
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("g", {
	  id: "Group",
	  transform: "translate(88 57)"
	}, _react2.default.createElement("path", {
	  d: "M.347 82.71c0 6.169 7.796 11.17 17.414 11.17 9.617 0 17.414-5.001 17.414-11.17 0-6.167-7.797-11.168-17.414-11.168-9.618 0-17.414 5-17.414 11.169",
	  id: "Fill-1",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M3.762 84.662c0 6.168 7.796 11.169 17.414 11.169 9.617 0 17.414-5.001 17.414-11.169s-7.797-11.169-17.414-11.169c-9.618 0-17.414 5.001-17.414 11.169z",
	  id: "Stroke-3",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M3.762 84.662v10.329c0 6.168 7.796 11.169 17.414 11.169 9.617 0 17.414-5.001 17.414-11.169V84.662",
	  id: "Stroke-5",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  id: "Fill-7",
	  fill: "#FFC5C5",
	  d: "M3.677 239.355l-1.75-12.75 14.5-7.5 18.75 5 1.5 11.75-13.25 9.79z"
	}), _react2.default.createElement("path", {
	  id: "Stroke-9",
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M6.594 240.022l-.747-12.75 13.497-7.5 18.75 5 1.5 11.75-13.25 10.31z"
	}), _react2.default.createElement("path", {
	  id: "Stroke-11",
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M39.597 236.353v9.668l-13.003 10.311-19.75-6.81-.25-9.5"
	}), _react2.default.createElement("path", {
	  d: "M26.344 246.832l.25 9.5",
	  id: "Stroke-13",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M23.86 0S2.648 15.322 3.417 15.322l23.702 17.981L23.86 0z",
	  id: "Fill-15",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M26.706 2.135S5.494 17.457 6.264 17.457l23.702 17.98-3.26-33.302z",
	  id: "Stroke-17",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  id: "Stroke-19",
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M29.965 35.438V45.52L6.264 27.539V17.457v7.177"
	}), _react2.default.createElement("g", {
	  id: "Group-23",
	  transform: "translate(0 140.754)"
	}, _react2.default.createElement("mask", {
	  id: "b",
	  fill: "#fff"
	}, _react2.default.createElement("use", {
	  xlinkHref: "#a"
	})), _react2.default.createElement("path", {
	  id: "Fill-21",
	  fill: "#EBFFC0",
	  mask: "url(#b)",
	  d: "M0 16.432l18.237 14.134 21.8-15.956L21.829.322z"
	})), _react2.default.createElement("path", {
	  id: "Stroke-24",
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M3.52 157.186l18.236 14.134 21.8-15.956-18.207-14.288z"
	}), _react2.default.createElement("path", {
	  d: "M44.07 155.495l.027 11.66c-.127.055-22.058 16.018-22.058 16.018",
	  id: "Stroke-26",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  id: "Stroke-28",
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M3.028 156.993v11.379l18.729 14.327v-11.473"
	})), _react2.default.createElement("text", {
	  id: "Data",
	  fontFamily: "Montserrat-Light, Montserrat",
	  fontSize: 12,
	  fontWeight: 300,
	  fill: "#28348A"
	}, _react2.default.createElement("tspan", {
	  x: 154,
	  y: 149
	}, "Data")), _react2.default.createElement("text", {
	  id: "Process",
	  fontFamily: "Montserrat-Light, Montserrat",
	  fontSize: 12,
	  fontWeight: 300,
	  letterSpacing: -0.311,
	  fill: "#28348A"
	}, _react2.default.createElement("tspan", {
	  x: 153,
	  y: 223
	}, "P"), _react2.default.createElement("tspan", {
	  x: 160.957,
	  y: 223,
	  letterSpacing: -0.169
	}, "r"), _react2.default.createElement("tspan", {
	  x: 165.348,
	  y: 223
	}, "o"), _react2.default.createElement("tspan", {
	  x: 172.788,
	  y: 223,
	  letterSpacing: -0.108
	}, "c"), _react2.default.createElement("tspan", {
	  x: 179.232,
	  y: 223
	}, "ess")), _react2.default.createElement("text", {
	  id: "Cognitive-knowledge-",
	  fontFamily: "Montserrat-Light, Montserrat",
	  fontSize: 12,
	  fontWeight: 300,
	  letterSpacing: -0.288,
	  fill: "#28348A"
	}, _react2.default.createElement("tspan", {
	  x: 153,
	  y: 76
	}, "C"), _react2.default.createElement("tspan", {
	  x: 161.016,
	  y: 76
	}, "ogniti"), _react2.default.createElement("tspan", {
	  x: 195.756,
	  y: 76,
	  letterSpacing: -0.18
	}, "v"), _react2.default.createElement("tspan", {
	  x: 201.732,
	  y: 76
	}, "e"), _react2.default.createElement("tspan", {
	  x: 211.98,
	  y: 76,
	  letterSpacing: -0.108
	}, "k"), _react2.default.createElement("tspan", {
	  x: 218.82,
	  y: 76,
	  letterSpacing: 0.013
	}, "n"), _react2.default.createElement("tspan", {
	  x: 226.921,
	  y: 76,
	  letterSpacing: -0.182
	}, "o"), _react2.default.createElement("tspan", {
	  x: 233.999,
	  y: 76
	}, "wledge")), _react2.default.createElement("text", {
	  id: "AI-Components",
	  fontFamily: "Montserrat-Light, Montserrat",
	  fontSize: 12,
	  fontWeight: 300,
	  fill: "#28348A"
	}, _react2.default.createElement("tspan", {
	  x: 153,
	  y: 296
	}, "AI"), _react2.default.createElement("tspan", {
	  x: 168.084,
	  y: 296,
	  letterSpacing: -0.288
	}, "C"), _react2.default.createElement("tspan", {
	  x: 176.1,
	  y: 296
	}, "ompo"), _react2.default.createElement("tspan", {
	  x: 211.848,
	  y: 296,
	  letterSpacing: 0.012
	}, "n"), _react2.default.createElement("tspan", {
	  x: 219.948,
	  y: 296
	}, "ents")));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 370 370",
	    xmlnsXlink: "http://www.w3.org/1999/xlink",
	    width: "1em",
	    height: "1em"
	  }, props), _ref, _ref2);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M170.717 155.948c0 4.333 5.477 7.846 12.233 7.846s12.234-3.513 12.234-7.846-5.478-7.846-12.234-7.846-12.233 3.513-12.233 7.846",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M173.115 157.318c0 4.333 5.478 7.847 12.233 7.847 6.757 0 12.234-3.514 12.234-7.847s-5.477-7.846-12.234-7.846c-6.755 0-12.233 3.513-12.233 7.846z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M173.115 157.318v7.256c0 4.333 5.478 7.846 12.233 7.846 6.757 0 12.234-3.513 12.234-7.846v-7.256",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  fill: "#FFF",
	  d: "M153.32 104.021h35.602V89H153.32z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M206.667 145.658l4.144-5.04-6.247-12.972m5.18 10.539l3.949-5.254-6.726-9.61"
	}), _react2.default.createElement("path", {
	  d: "M212.271 130.934l2.143-7.972-27.747-13.694s-1.8-.6-2.042-3.362l-27.267.03s-2.28 4.653-2.28 18.106c0 20.023 12.252 23.374 12.732 35.434 0 0 5.343-.655 5.343-9.423 0-6.538-3.422-8.113-3.422-8.113s3.003-5.886 14.054-5.886c11.05 0 16.575 10.69 16.575 10.69s-3.362 9.608-.6 15.135l8.047-12.972-5.765-15.256m-48.722-27.749h35.602V90.881H153.32zm32.937 155.931l-50.638-38.554 48.645-37.036 50.638 38.554z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M234.901 243.401l-48.645 37.036-50.637-38.554m99.282-17.086v18.604m-99.282-20.121v18.604m50.638 19.949v19.162"
	}), _react2.default.createElement("path", {
	  d: "M206.912 208.15s-12.202 8.814-11.76 8.814l13.635 10.344-1.875-19.158z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M208.55 209.378s-12.203 8.814-11.761 8.814l13.636 10.344-1.875-19.158z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M210.425 228.536v5.8l-13.636-10.344v-5.8 4.13"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M150.382 220.268l8.4 6.51 10.042-7.35-8.386-6.582z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M152.003 220.268l8.4 6.51 10.043-7.35-8.387-6.582zm18.679-.779l.013 5.37c-.059.027-10.16 7.38-10.16 7.38"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M151.776 220.179v5.242l8.628 6.6v-5.285"
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M175.116 242.563l-.966-7.039 8.005-4.14 10.351 2.761.827 6.486-7.314 5.404z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M176.726 242.931l-.412-7.038 7.45-4.14 10.351 2.76.828 6.486-7.315 5.692z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M194.945 240.906v5.337l-7.178 5.692-10.903-3.759-.138-5.245m10.903 3.759l.139 5.245"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 370 370",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M262.245 236.268c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M263.414 236.937c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.67-3.826-5.965-3.826c-3.296 0-5.965 1.713-5.965 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M263.414 236.937v3.538c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M272.773 282.335l-38.737-29.493 37.212-28.332 38.736 29.493z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M309.984 267.901l-37.211 28.332-38.737-29.493m.859-163.775v14.23m-.859 135.646v14.231m38.737 15.263v13.898"
	}), _react2.default.createElement("path", {
	  d: "M262.245 149.662c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M263.414 150.33c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.67-3.826-5.965-3.826c-3.296 0-5.965 1.713-5.965 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M263.414 150.33v3.538c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M272.773 195.728l-38.737-29.493 37.212-28.332 38.736 29.493z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M309.984 181.628l-37.211 28.332-38.737-29.493m0-14.231v14.23m38.737 15.262v14.658"
	}), _react2.default.createElement("path", {
	  d: "M187.155 85.23c0 2.113 2.67 3.826 5.966 3.826 3.295 0 5.965-1.713 5.965-3.826s-2.67-3.826-5.965-3.826-5.966 1.713-5.966 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M188.325 85.898c0 2.113 2.67 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.671-3.826-5.965-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M188.325 85.898v3.538c0 2.113 2.67 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M197.683 131.296l-38.736-29.493 37.211-28.332 38.737 29.493z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M234.895 117.196l-37.212 28.332-38.736-29.493M310 254v14.231M158.947 101.803v14.231m38.736 15.262v14.658"
	}), _react2.default.createElement("path", {
	  d: "M104.245 142.995c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M105.415 143.663c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.295 0-5.965 1.713-5.965 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M105.415 143.663v3.54c0 2.111 2.67 3.825 5.965 3.825s5.966-1.714 5.966-3.826v-3.539",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M114.773 189.062l-38.737-29.493 37.212-28.332 38.736 29.493z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M151.984 174.961l-37.211 28.332L76.036 173.8m75.948-13.07v14.23m-75.948-15.391v14.23m38.737 15.263v14.658"
	}), _react2.default.createElement("path", {
	  d: "M196.41 209.366c0 2.113 2.672 3.826 5.967 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M197.58 210.035c0 2.113 2.671 3.826 5.966 3.826 3.296 0 5.966-1.713 5.966-3.826s-2.67-3.826-5.965-3.826c-3.296 0-5.966 1.713-5.966 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M197.58 210.035v3.538c0 2.113 2.671 3.826 5.966 3.826 3.296 0 5.966-1.713 5.966-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M179.66 194.616c0 2.113 2.672 3.826 5.967 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M180.83 195.285c0 2.113 2.671 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.67-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M180.83 195.285v3.538c0 2.113 2.671 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M190.189 240.683l-38.736-29.493 37.212-28.332L227.4 212.35z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M227.4 226.582l-37.211 28.332-38.736-29.493M227.4 212.35v14.232m-75.947-15.392v14.23m38.736 15.263v14.658"
	}), _react2.default.createElement("path", {
	  d: "M72.791 240.425c0 2.113 2.671 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.67-3.826-5.965-3.826-5.966 1.713-5.966 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M73.961 241.093c0 2.113 2.671 3.826 5.965 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.67-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M73.961 241.093v3.538c0 2.113 2.671 3.826 5.965 3.826 3.295 0 5.966-1.713 5.966-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M98.356 271.668l-38.737-29.493 37.212-28.331 38.737 29.492zm37.212-28.332v14.231"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M59.605 242.175v14.23h.014L98.356 285.9l37.212-28.332m-37.212 14.1V285.9"
	}), _react2.default.createElement("path", {
	  d: "M98.373 247.338s-7.48 5.401-7.208 5.401l8.357 6.34-1.15-11.742z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M99.376 248.09s-7.479 5.402-7.208 5.402l8.357 6.34-1.149-11.742z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M100.526 259.832v3.555l-8.357-6.34v-3.554 2.53"
	}), _react2.default.createElement("path", {
	  d: "M115.873 235.838s-7.48 5.401-7.208 5.401l8.357 6.34-1.15-11.742z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M116.876 236.59s-7.479 5.402-7.208 5.402l8.357 6.34-1.149-11.742z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M118.026 248.332v3.555l-8.357-6.34v-3.554 2.53"
	}), _react2.default.createElement("path", {
	  d: "M99.207 222.171s-7.48 5.402-7.208 5.402l8.356 6.34-1.149-11.742z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M100.21 222.923s-7.48 5.403-7.208 5.403l8.356 6.34-1.149-11.743z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M101.359 234.665v3.555l-8.356-6.34v-3.555 2.531"
	}), _react2.default.createElement("path", {
	  d: "M130.373 151.004s-7.48 5.402-7.207 5.402l8.356 6.34-1.15-11.742z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M131.376 151.757s-7.479 5.402-7.208 5.402l8.357 6.34-1.149-11.742z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M132.526 163.499v3.555l-8.357-6.34v-3.555 2.53"
	}), _react2.default.createElement("path", {
	  d: "M173.373 202.004s-7.48 5.402-7.207 5.402l8.356 6.34-1.15-11.742z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M174.376 202.756s-7.479 5.403-7.208 5.403l8.357 6.34-1.149-11.743z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M175.526 214.499v3.555l-8.357-6.34v-3.555 2.53"
	}), _react2.default.createElement("path", {
	  d: "M180.207 93.338s-7.48 5.402-7.208 5.402l8.356 6.34-1.148-11.742z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M181.21 94.09s-7.48 5.402-7.208 5.402l8.356 6.34-1.149-11.742z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M182.359 105.832v3.555l-8.356-6.34v-3.554 2.53"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M87.776 155.324l6.169 4.781 7.374-5.397-6.16-4.834z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M88.966 155.324l6.17 4.781 7.373-5.397-6.159-4.834zm13.717-.571l.009 3.944c-.043.019-7.461 5.418-7.461 5.418"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M88.8 155.259v3.849l6.335 4.847v-3.881"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M181.442 221.324l6.169 4.781 7.374-5.397-6.158-4.834z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M182.632 221.324l6.17 4.781 7.374-5.397-6.159-4.834zm13.718-.571l.01 4.048-7.463 5.418"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M182.466 221.259v3.849l6.336 4.847v-3.881"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M246.442 251.99l6.169 4.782 7.374-5.397-6.158-4.833z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M247.632 251.99l6.17 4.782 7.374-5.397-6.159-4.833zm13.718-.57l.01 3.943c-.044.02-7.463 5.418-7.463 5.418"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M247.466 251.925v3.85l6.336 4.846v-3.88"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M248.109 165.324l6.169 4.781 7.374-5.397-6.16-4.834z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M249.3 165.324l6.168 4.781 7.374-5.397-6.159-4.834zm13.716-.571l.01 3.944c-.044.019-7.462 5.418-7.462 5.418"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M249.133 165.259v3.849l6.335 4.847v-3.881"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M280.859 164.574l6.169 4.781 7.374-5.397-6.16-4.834z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M282.05 164.574l6.168 4.781 7.374-5.397-6.159-4.834zm13.716-.571l.01 3.944c-.044.019-7.462 5.418-7.462 5.418"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M281.883 164.509v3.849l6.335 4.847v-3.881"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M207.609 101.49l6.169 4.782 7.374-5.397-6.16-4.833z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M208.8 101.49l6.168 4.782 7.374-5.397-6.159-4.833zm13.716-.57l.01 3.943c-.044.02-7.462 5.418-7.462 5.418"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M208.633 101.425v3.85l6.335 4.846v-3.88"
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M266.154 178.87l-.632-4.6 5.23-2.705 6.763 1.804.54 4.237-4.778 3.532z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M267.206 179.11l-.27-4.6 4.869-2.705 6.762 1.804.54 4.238-4.778 3.72z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M279.109 177.786v3.487l-4.69 3.72-7.123-2.457-.09-3.427m7.123 2.457l.09 3.426M310 168v14.231"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 370 370",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M136.828 144.857c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M137.998 145.525c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M137.998 145.525v3.538c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M147.356 190.923L108.62 161.43l37.212-28.332 38.736 29.493z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M184.567 176.823l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m75.948 55.122v13.52m-75.948-14.682v14.231m38.737-52.93v14.658"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M184.567 190.073l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m38.737 15.261v14.658"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M184.567 203.323l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m38.737 15.261v14.658"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M184.567 216.573l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m38.737 15.261v14.658"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M184.567 230.823l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m38.737 15.261v14.658m0 12.824l-38.737-29.493m38.737 15.261v14.658m0 12.824l-38.737-29.493m0-14.232v14.232m38.737 15.261v14.658m0 12.824l-38.737-29.493m0-14.232v14.232m38.737 15.261v14.658"
	}), _react2.default.createElement("path", {
	  d: "M177.738 256.24c0 2.114 2.671 3.827 5.966 3.827 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M178.908 256.909c0 2.113 2.67 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.671-3.826-5.965-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M178.908 256.909v3.538c0 2.113 2.67 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M185.997 300.064l-38.737-27.622 37.212-28.33 38.737 27.62z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M223.209 285.964l-37.212 28.332-38.737-29.493m38.737 15.261v14.658"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M223.209 299.714l-37.212 28.332-38.737-29.493m38.737 15.261v14.658"
	}), _react2.default.createElement("path", {
	  d: "M231.744 186.023c0 2.113 2.67 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M232.914 186.692c0 2.113 2.67 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M232.914 186.692v3.538c0 2.113 2.67 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M215.66 173.023c0 2.113 2.672 3.826 5.967 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.671-3.826-5.965-3.826c-3.295 0-5.966 1.713-5.966 3.826",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M216.83 173.692c0 2.113 2.672 3.826 5.967 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.671-3.826-5.965-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M216.83 173.692v3.538c0 2.113 2.672 3.826 5.967 3.826 3.294 0 5.965-1.713 5.965-3.826v-3.538",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M223.44 219.566l-38.737-29.493 37.211-28.332 38.737 29.493z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M260.651 204.008l-37.212 28.996-38.736-29.493m38.737 16.055v10.432"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M260.651 216.576L223.44 245.57l-38.736-28.998m38.736 12.768v14.658"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M260.651 229.24l-37.212 30.332-38.736-28.788m38.737 12.556v14.658m37.211-14.758l-37.212 28.332m.001-14.232v14.658m37.211-14.758l-37.212 28.332m.001-14.232v14.658m37.211-14.758l-37.212 28.332m.001-14.232v14.658"
	}), _react2.default.createElement("path", {
	  d: "M196.08 117.641c0 8.716 7.066 15.782 15.782 15.782 8.716 0 15.782-7.066 15.782-15.782 0-8.716-7.066-15.782-15.782-15.782-8.716 0-15.782 7.067-15.782 15.782",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M209.578 116.111l6.373 6.374 11.79-11.79m-28.488 6.36H165.57v-74.68h53.488V97.63m-37.214-45.036h21.95m-30.276 14.002h36.71m-36.71 13.624h36.71m-36.71 13.624h36.71m-24.616 13.624h12.001"
	}), _react2.default.createElement("path", {
	  d: "M203.719 117.247c0 8.118 6.58 14.7 14.698 14.7 8.119 0 14.7-6.582 14.7-14.7 0-8.118-6.581-14.699-14.7-14.699-8.118 0-14.698 6.581-14.698 14.7zm-31.751-10.426a3.835 3.835 0 1 0 7.67 0 3.835 3.835 0 0 0-7.67 0z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M146.572 163.9s-7.479 5.401-7.207 5.401l8.356 6.34-1.149-11.742z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M147.576 164.652s-7.48 5.402-7.208 5.402l8.357 6.34-1.15-11.742z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M148.725 176.393v3.555l-8.357-6.34v-3.555 2.531"
	}), _react2.default.createElement("path", {
	  d: "M203.239 263.232s-7.479 5.402-7.208 5.402l8.357 6.34-1.149-11.742z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M204.243 263.985s-7.48 5.402-7.208 5.402l8.356 6.34-1.148-11.742z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M205.391 275.727v3.555l-8.356-6.34v-3.555 2.53"
	}), _react2.default.createElement("path", {
	  d: "M187.572 274.9s-7.479 5.401-7.207 5.401l8.356 6.34-1.149-11.742z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M188.576 275.652s-7.48 5.402-7.208 5.402l8.357 6.34-1.15-11.742z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M189.725 287.393v3.555l-8.357-6.34v-3.555 2.531"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M154.141 158.72l6.17 4.78 7.373-5.397-6.158-4.833z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M155.332 158.72l6.17 4.78 7.374-5.397-6.16-4.833zm13.716-.573l.01 3.944c-.042.02-7.462 5.418-7.462 5.418"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M155.166 158.654v3.849l6.336 4.847v-3.881"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M198.141 188.886l6.17 4.781 7.373-5.397-6.158-4.834z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M199.332 188.886l6.17 4.781 7.374-5.397-6.16-4.834zm13.716-.572l.01 3.944c-.042.019-7.462 5.418-7.462 5.418"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M199.166 188.82v3.85l6.336 4.846v-3.881"
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M122.364 161.777l-.601-4.373 4.974-2.572 6.431 1.715.513 4.03-4.544 3.357z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M123.364 162.005l-.256-4.373 4.629-2.572 6.431 1.715.514 4.03-4.545 3.536z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M134.683 160.747v3.316l-4.46 3.536-6.773-2.336-.086-3.258m6.773 2.336l.086 3.258"
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M217.364 202.777l-.601-4.373 4.974-2.572 6.431 1.715.513 4.03-4.544 3.357z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M218.364 203.005l-.256-4.373 4.629-2.572 6.431 1.715.514 4.03-4.545 3.536z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M229.683 201.747v3.316l-4.46 3.536-6.773-2.336-.086-3.258m6.773 2.336l.086 3.258M261 191v80"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 370 370",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  fill: "#FFF",
	  d: "M248.703 161.533h-7.438l-.263-11.632-11.37 11.632h-31.53v31.86h30.923l11.713 11.713v-11.713h7.965z"
	}), _react2.default.createElement("path", {
	  fill: "#FFF",
	  d: "M188.72 185.74H171.1l-10.538-10.538v10.538h-7.774v31.86h7.965v11.713l11.713-11.713h30.923v-31.714zm66.32-159.037c0 1.384 1.749 2.506 3.907 2.506 2.157 0 3.906-1.122 3.906-2.506 0-1.384-1.75-2.506-3.906-2.506-2.158 0-3.907 1.122-3.907 2.506"
	}), _react2.default.createElement("path", {
	  d: "M255.805 27.141c0 1.384 1.75 2.506 3.907 2.506 2.158 0 3.907-1.122 3.907-2.506 0-1.384-1.749-2.506-3.907-2.506-2.157 0-3.907 1.122-3.907 2.506z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M255.805 27.141v2.317c0 1.384 1.75 2.506 3.907 2.506 2.158 0 3.907-1.122 3.907-2.506v-2.317",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M272.09 48.831l-26.366-20.075 25.329-19.285 26.368 20.075zm25.33 10.621l-25.33 19.285-26.366-20.075m-.001-29.906v9.687m51.697 57.74v9.203m-51.697-9.994v9.687m26.367-56.248v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M297.42 68.471l-25.33 19.285-26.366-20.075m51.696-8.897v9.687m-51.697-30.696v29.906M272.09 78.07v9.977"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M297.42 49.929l-25.33 19.285-26.366-20.075m51.696.122v9.687m-25.33 9.598v9.977"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M297.42 40.406L272.09 59.69l-26.366-20.076m51.696-10.067v19.878m-25.33 9.598V69m25.33 8.49l-25.33 19.285L245.725 76.7m51.695-8.897v9.687m-51.697-10.477V76.7m26.367 10.389v9.977"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M297.42 86.51l-25.33 19.284-26.366-20.075m51.696-8.896v9.687m-51.697-10.478v9.688m26.367 10.388v9.977"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M297.42 96.21l-25.33 19.284-26.366-20.075m51.696-8.897v9.687m-51.697-10.477v9.688m26.367 10.387v9.977m0 8.729l-26.366-20.075m26.366 10.388v9.978m0 8.728l-26.366-20.075m-.001-9.687v9.688m26.367 10.388v9.977m0 8.729l-26.366-20.075m-.001-9.687v9.686m26.367 10.388v9.978"
	}), _react2.default.createElement("path", {
	  d: "M293.227 112.734c0 1.438 1.817 2.604 4.061 2.604 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.244 0-4.06 1.166-4.06 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M294.023 113.19c0 1.437 1.818 2.603 4.061 2.603 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M294.023 113.19v2.407c0 1.44 1.818 2.605 4.061 2.605 2.242 0 4.06-1.166 4.06-2.605v-2.408",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M298.393 143.341l-26.367-18.802 25.33-19.284 26.366 18.801z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M323.722 133.743l-25.329 19.285-26.367-20.075m26.367 10.388v9.977"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M323.722 143.102l-25.329 19.285-26.367-20.075m26.367 10.388v9.977m25.487-74.13l-26.367-20.076 25.329-19.284 26.367 20.075z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M349.209 77.957l-25.33 19.737-26.366-20.075M349 69v55.494m-25.12-35.947v7.101"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M349.209 86.511l-25.33 19.738-26.366-19.74M323.88 95.2v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M349.209 95.132l-25.33 20.646-26.366-19.595m26.367 8.547v9.977m25.329-10.046l-25.33 19.285m.001-9.687v9.978m25.329-10.047l-25.33 19.286m.001-9.687v9.977m25.329-10.046l-25.33 19.286m.001-9.688v9.978m-157.868 53.34h20.607m-20.607 5.622h29.518m-29.518 5.622h29.518m38.887-29.829h-29.518m29.518-5.963h-29.518m29.518 11.585h-29.518"
	}), _react2.default.createElement("path", {
	  d: "M56.832 274.104c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M57.628 274.559c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M57.628 274.559v2.409c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604v-2.41",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M63.998 305.46L37.63 285.387 62.96 266.1l26.368 20.075z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M89.328 295.863l-25.33 19.285-26.367-20.076m51.697-8.897v9.688M37.63 285.385v9.688m51.698.745v9.203m-25.33.439v9.979"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M89.328 304.882l-25.33 19.285-26.367-20.076m51.697-8.896v9.688M37.63 294.404v9.688m26.368 10.388v9.978m25.33-57.019v9.687m0-.668v9.687m0 .013v9.688m-25.33 28.303L37.63 304.074m26.368 29.094L37.63 313.093m0-9.687v9.686m26.368 10.388v9.979m0 8.728L37.63 322.112m0-9.687v9.687M63.998 332.5v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M89.263 304.89l26.366 18.8L90.3 342.977l-26.367-18.801"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M115.63 333.378L90.3 352.663l-26.367-20.075M90.3 342.976v9.977"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M115.63 342.738L90.3 362.022l-26.367-20.075M90.3 352.336v9.977"
	}), _react2.default.createElement("path", {
	  d: "M110.492 256.502c0 1.438 1.818 2.604 4.061 2.604s4.06-1.166 4.06-2.604c0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.061 1.166-4.061 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M111.289 256.956c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M111.289 256.956v2.41c0 1.437 1.817 2.603 4.06 2.603 2.243 0 4.06-1.166 4.06-2.604v-2.409",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M115.787 288.182L89.42 268.106l25.329-19.284 26.367 20.075z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M141.116 277.592l-25.329 19.737-26.367-20.075m51.696-8.357v6.811m-25.329 12.474v7.101"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M141.116 286.147l-25.329 19.737-26.367-19.74m51.696-10.594v10.597m-25.329 8.688v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M141.116 294.767l-25.329 20.646-26.367-19.595m51.696-10.738v9.687m-25.329 9.598v9.977m25.329-10.045l-25.329 19.285m25.329-28.972v9.687m-25.329 9.597v9.978m25.329-10.046l-25.329 19.285m25.329-28.972v9.687m-25.329 9.598v9.977m25.329-10.045l-25.329 19.285m25.329-28.972v9.687m-25.329 9.597v9.978m192.176-70.818l-26.367-20.075 25.329-19.285 26.367 20.076z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M333.292 262.516l-25.33 19.285-26.366-20.076m51.696-8.897v9.688m-51.696-10.478v9.687m26.367 10.388v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M333.292 271.535l-25.33 19.285-26.366-20.076m51.696-8.897v9.688m-51.696-10.478v9.687m26.367 10.389v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M333.292 280.554l-25.33 19.285-26.366-20.076m51.696-8.897v9.689m-51.696-10.479v9.687m26.367 10.389v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M333.292 289.573l-25.33 19.285-26.366-20.076m51.696-8.897v9.689m-51.696-10.478v9.687m26.367 10.387v9.979"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M333.292 299.273l-25.33 19.285-26.366-20.076m51.696-8.897v9.688m-51.696-10.478v9.687m26.367 10.388v9.978"
	}), _react2.default.createElement("path", {
	  d: "M261.868 268.778c0 1.438 1.818 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M262.664 269.233c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M262.664 269.233v2.408c0 1.44 1.818 2.605 4.06 2.605 2.244 0 4.06-1.166 4.06-2.605v-2.408",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M250.92 259.93c0 1.437 1.818 2.603 4.062 2.603 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.244 0-4.061 1.166-4.061 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M251.717 260.385c0 1.438 1.818 2.603 4.06 2.603 2.243 0 4.06-1.166 4.06-2.603 0-1.438-1.817-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.603z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M251.717 260.385v2.408c0 1.438 1.818 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604v-2.409",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M256.215 291.61l-26.367-20.075 25.329-19.285 26.367 20.075z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M281.544 281.02l-25.33 19.737-26.366-20.075m51.696-8.357v6.81m-25.329 12.475v7.101"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M281.544 289.575l-25.33 19.737-26.366-19.738m51.696-10.596v10.596m-25.329 8.689v9.978m25.329-19.733v9.687m-25.329 9.598v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M229.847 271.535v27.71l26.367 19.596 25.33-20.646M98.728 117.086L72.361 97.01l25.33-17.4 26.367 19.73z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M149.669 88.695l-50.94 38.078-26.368-20.075m0-9.688v9.688m26.367 10.388v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M124.058 116.507l-25.33 19.285-26.367-20.076m0-9.686v9.686m26.367 10.389v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M124.058 125.526l-25.33 19.285-26.367-20.076m0-9.686v9.687m26.367 10.388v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M124.058 134.545l-25.33 19.285-26.367-20.076m26.367 10.389v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M124.058 144.245l-25.33 19.285-26.367-20.076m0-9.687v9.687m26.367 10.389v9.688"
	}), _react2.default.createElement("path", {
	  d: "M143.845 114.255c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M144.64 114.71c0 1.438 1.818 2.604 4.061 2.604s4.06-1.166 4.06-2.604c0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M144.64 114.71v2.408c0 1.439 1.818 2.605 4.061 2.605s4.06-1.166 4.06-2.605v-2.408",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M84.873 95.208c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M85.669 95.663c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M85.669 95.663v2.408c0 1.439 1.818 2.605 4.06 2.605 2.244 0 4.06-1.166 4.06-2.605v-2.408",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M101.492 96.249c0 1.438 1.818 2.604 4.061 2.604s4.061-1.166 4.061-2.604c0-1.438-1.818-2.604-4.061-2.604s-4.061 1.166-4.061 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M102.289 96.704c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M102.289 96.704v2.408c0 1.439 1.817 2.605 4.06 2.605 2.243 0 4.06-1.166 4.06-2.605v-2.408m40.108 39.878l-26.367-20.075 25.33-19.285 26.366 20.075z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M175.846 125.992l-25.328 19.737-26.368-20.075m51.696-8.356v6.81m-25.329 12.474v7.101"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M175.846 134.547l-25.328 19.737-26.368-19.739m51.696-10.595v10.597m-25.329 8.688v9.978"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M175.846 143.167l-25.328 20.646-26.368-19.595m51.696-10.738v9.688m-25.329 9.597v10.67m-.75-92.143l-25.33 19.285-26.635-20.075m51.965 9.485l-25.33 19.737m25.33-28.432v6.81m0-.157v10.596m-25.33 2.036l-.262 53.89m25.592-56.993v9.688m-129.225 19.59v9.009m0-.668v9.687m0 .012v9.687"
	}), _react2.default.createElement("path", {
	  d: "M51.497 114.489c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M52.294 114.944c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M52.294 114.944v2.41c0 1.437 1.817 2.603 4.06 2.603 2.243 0 4.06-1.166 4.06-2.604v-2.409",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M30.4 114.66c0 1.438 1.817 2.604 4.06 2.604 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M31.195 115.115c0 1.438 1.818 2.604 4.061 2.604s4.06-1.166 4.06-2.604c0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M31.195 115.115v2.408c0 1.439 1.818 2.605 4.061 2.605s4.06-1.166 4.06-2.605v-2.408",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M41.73 123.28c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M42.526 123.735c0 1.438 1.817 2.604 4.061 2.604 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.244 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M42.526 123.735v2.408c0 1.44 1.817 2.605 4.061 2.605 2.242 0 4.06-1.166 4.06-2.605v-2.408",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M42.12 106.968c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.605-4.06-2.605-2.242 0-4.06 1.167-4.06 2.605",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M42.917 107.423c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.605-4.06-2.605-2.243 0-4.06 1.167-4.06 2.605z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M42.917 107.423v2.408c0 1.44 1.817 2.605 4.06 2.605 2.243 0 4.06-1.166 4.06-2.605v-2.408",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M47 135.383l-26.366-18.642 25.329-19.284L72.33 115.97z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M72.33 126.227L47 145.964l-26.366-20.075"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M72.33 134.781L47 154.518 20.635 134.78m51.695-10.595v10.597m-25.33.601v18.064"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M72.33 143.402L47 164.048l-26.366-19.595m51.696-10.738v9.687M47 153v9.977m50.69-92.475v9.109"
	}), _react2.default.createElement("path", {
	  d: "M117.765 59.654c0 1.438 1.817 2.603 4.061 2.603 2.242 0 4.06-1.165 4.06-2.603 0-1.439-1.818-2.605-4.06-2.605-2.244 0-4.06 1.166-4.06 2.605",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M118.561 60.109c0 1.438 1.818 2.604 4.061 2.604 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M118.561 60.109v2.409c0 1.438 1.818 2.604 4.061 2.604 2.242 0 4.06-1.166 4.06-2.604v-2.41",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M124.437 81.981L97.802 61.906 123.4 42.621l26.368 20.075zm25.33-19.284v6.81m0-.157v10.596m-25.33 2.035l-.262 53.891M97.69 61.906v9.109m147.972 90.518h-7.44l-.262-11.632-11.37 11.632h-31.53v31.86h30.923l11.713 11.713v-11.713h7.966z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M190.7 185.74h-17.622l-10.538-10.538v10.538h-7.773v31.86h7.965v11.713l11.713-11.713h30.923v-19.54"
	}), _react2.default.createElement("path", {
	  d: "M74.158 280.23s-5.078 3.668-4.894 3.668l5.674 4.305-.78-7.973z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M75.423 280.741s-5.078 3.668-4.894 3.668l5.674 4.305-.78-7.973z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M76.203 288.714v2.414l-5.674-4.305v-2.414 1.72"
	}), _react2.default.createElement("path", {
	  d: "M102.992 261.814s-5.079 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M104.257 262.325s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M105.037 270.298v2.414l-5.675-4.305v-2.414 1.718"
	}), _react2.default.createElement("path", {
	  d: "M254.992 273.564s-5.079 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M256.257 274.075s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M257.037 282.048v2.414l-5.675-4.305v-2.414 1.718"
	}), _react2.default.createElement("path", {
	  d: "M295.242 247.064s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M296.507 247.575s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M297.287 255.548v2.414l-5.675-4.305v-2.414 1.718"
	}), _react2.default.createElement("path", {
	  d: "M306.242 255.564s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M307.507 256.075s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M308.287 264.048v2.414l-5.675-4.305v-2.414 1.718"
	}), _react2.default.createElement("path", {
	  d: "M269.992 32.064s-5.079 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M271.257 32.574s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M272.037 40.548v2.414l-5.675-4.305v-2.414 1.718"
	}), _react2.default.createElement("path", {
	  d: "M77.158 318.397s-5.078 3.668-4.894 3.668l5.674 4.305-.78-7.973z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M78.423 318.908s-5.078 3.668-4.894 3.668l5.674 4.305-.78-7.973z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M79.203 326.88v2.415l-5.674-4.305v-2.414 1.719"
	}), _react2.default.createElement("path", {
	  d: "M100.242 317.814s-5.079 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M101.507 318.325s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M102.287 326.298v2.414l-5.675-4.305v-2.414 1.718"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M43.394 283.399l4.908 3.804 5.866-4.294-4.899-3.846z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M45.342 283.399l4.908 3.804 5.866-4.294-4.9-3.846zm10.913-.455l.008 3.138c-.035.015-5.937 4.31-5.937 4.31"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M45.209 283.346v3.063l5.04 3.855v-3.087"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M81.311 313.649l4.908 3.804 5.866-4.294-4.9-3.846z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M83.342 313.649l4.908 3.804 5.866-4.294-4.9-3.846zm10.913-.455l.008 3.138c-.035.015-5.937 4.31-5.937 4.31"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M83.209 313.596v3.063l5.04 3.855v-3.087"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M120.061 267.565l4.908 3.804 5.866-4.294-4.9-3.845z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M122.342 267.565l4.908 3.804 5.866-4.294-4.9-3.845zm10.913-.455l.008 3.138c-.035.015-5.937 4.311-5.937 4.311"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M122.209 267.513v3.062l5.04 3.856v-3.087"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M108.394 275.899l4.908 3.804 5.866-4.294-4.899-3.846z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M110.675 275.899l4.908 3.804 5.867-4.294-4.9-3.846zm10.913-.455l.008 3.138c-.034.015-5.937 4.31-5.937 4.31"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M110.543 275.846v3.063l5.04 3.855v-3.087"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M316.727 56.315l4.908 3.804 5.867-4.294-4.9-3.845z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M317.675 56.315l4.908 3.804 5.867-4.294-4.9-3.845zm10.913-.455l.008 3.138c-.034.015-5.937 4.311-5.937 4.311"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M317.543 56.263v3.062l5.04 3.856v-3.087"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M329.061 66.649l4.908 3.804 5.866-4.294-4.9-3.846z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M330.009 66.649l4.907 3.804 5.867-4.294-4.9-3.846zm10.913-.455l.007 3.138c-.034.015-5.937 4.31-5.937 4.31"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M329.876 66.596v3.063l5.04 3.855v-3.087"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M279.477 122.065l4.908 3.804 5.867-4.294-4.9-3.845z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M280.425 122.065l4.908 3.804 5.867-4.294-4.9-3.845zm10.913-.455l.008 3.138c-.034.015-5.937 4.311-5.937 4.311"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M280.293 122.013v3.062l5.04 3.856v-3.087"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M291.811 132.399l4.908 3.804 5.866-4.294-4.9-3.846z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M292.759 132.399l4.907 3.804 5.867-4.294-4.9-3.846zm10.913-.455l.007 3.138c-.034.015-5.937 4.31-5.937 4.31"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M292.626 132.346v3.063l5.04 3.855v-3.087"
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M307.696 69.35l-.496-3.61 4.107-2.126 5.311 1.417.425 3.328-3.753 2.772z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M308.522 69.54l-.212-3.613 3.823-2.124 5.311 1.416.425 3.328-3.753 2.921z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M317.87 68.5v2.738l-3.684 2.921-5.593-1.93-.071-2.69m5.594 1.929l.07 2.691"
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M301.967 243.767l-.496-3.611 4.107-2.125 5.31 1.417.426 3.328-3.753 2.773z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M302.793 243.956l-.212-3.611 3.823-2.125 5.31 1.417.426 3.328-3.753 2.92z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M312.14 242.917v2.738l-3.683 2.92-5.594-1.928-.07-2.691m5.594 1.929l.07 2.69"
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M266.362 21.35l-.495-3.61 4.106-2.126 5.312 1.417.425 3.328-3.753 2.772z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M267.188 21.54l-.21-3.613 3.821-2.124 5.312 1.416.425 3.328-3.753 2.921z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M276.537 20.5v2.738l-3.684 2.921-5.593-1.93-.072-2.69m5.595 1.929l.07 2.691"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 370 370",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M71.958 54.336c0 4.928 6.23 8.923 13.912 8.923 7.684 0 13.913-3.995 13.913-8.923s-6.229-8.923-13.913-8.923c-7.683 0-13.912 3.995-13.912 8.923",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M74.686 55.895c0 4.928 6.229 8.923 13.913 8.923s13.912-3.995 13.912-8.923-6.228-8.923-13.912-8.923c-7.684 0-13.913 3.995-13.913 8.923z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M74.686 55.895v8.252c0 4.928 6.229 8.923 13.913 8.923s13.912-3.995 13.912-8.923v-8.252",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M76.862 155.05l-1.397-10.186 11.584-5.991 14.978 3.994 1.198 9.388-10.584 7.82z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M79.192 155.583l-.597-10.186 10.784-5.992 14.979 3.995 1.198 9.387-10.585 8.237z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M105.559 152.652v7.725l-10.39 8.237-15.777-5.44-.2-7.59m15.778 5.44l.2 7.59"
	}), _react2.default.createElement("path", {
	  d: "M95.57 88.096s-16.947 12.241-16.333 12.241l18.937 14.365-2.605-26.606z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M97.843 89.802s-16.947 12.24-16.332 12.24l18.936 14.365-2.604-26.605z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M100.447 116.407v8.056L81.51 110.097v-8.054 5.733"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M190.567 256.375H51.376v-229h179v188.606M121.375 60.709h80m-80 46.25h80m-80 46.25h80m-79.987 53.583h82"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M248.911 261.366h9.25v-9.25h-9.25z"
	}), _react2.default.createElement("path", {
	  fill: "#DFC0FF",
	  d: "M226.857 289.605l7.793-11.226 7.793 11.226z"
	}), _react2.default.createElement("path", {
	  d: "M210.092 268.754a5.305 5.305 0 1 0 10.61-.002 5.305 5.305 0 0 0-10.61.002",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M189.366 269.44c0 30.538 24.757 55.295 55.296 55.295 30.538 0 55.295-24.757 55.295-55.296 0-30.539-24.757-55.295-55.295-55.295-30.539 0-55.296 24.756-55.296 55.295z",
	  stroke: "#2E388E",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M198.766 269.787c.072-1.336.202-2.657.387-3.961 3.156-22.29 22.362-39.488 45.509-39.488m-44.862 59.5a45.879 45.879 0 0 1-1.803-9.922m46.665 42.35c-13.413 0-25.502-5.774-33.913-14.968m67.354 9.878l27.183 27.182.004-.005c.035.035.064.073.098.108a7.544 7.544 0 0 0 10.669-10.67c-.034-.034-.072-.063-.107-.097l.005-.005-27.182-27.182m-77.669-33.067a5.779 5.779 0 1 0 11.558 0 5.779 5.779 0 0 0-11.558 0zm0 0h-16.578m99.363 0h-9.711m-63.344 4.214l10.662 10.795m8.25-.917l12.252-22.412",
	  stroke: "#2E388E",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M228.217 289.605l7.793-11.226 7.794 11.226z"
	}), _react2.default.createElement("path", {
	  stroke: "#2E388E",
	  strokeWidth: 0.75,
	  d: "M250.206 261.366h9.25v-9.25h-9.25z"
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M270.208 273.197l-.69-6.859 5.733-2.966 7.415 1.978.594 8.083-5.24 3.764z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M271.363 275.081l-.296-8.479 5.337-2.966 7.416 1.977.594 8.084-5.24 4.077z"
	}), _react2.default.createElement("path", {
	  d: "M259.45 258.75l12.104 7.365",
	  stroke: "#2E388E",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M74.627 201.284l14.102 10.929 16.856-12.338-14.079-11.048z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M77.349 201.284l14.102 10.929 16.856-12.338-14.08-11.048zm31.354-1.308l.021 9.016c-.098.043-17.056 12.385-17.056 12.385"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M76.968 201.135v8.798l14.482 11.079v-8.871"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 370 370",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M133.69 274.264c0 18.77 15.217 33.987 33.988 33.987 18.77 0 33.988-15.217 33.988-33.987 0-18.772-15.218-33.988-33.988-33.988s-33.988 15.216-33.988 33.988m149.465-169.235s-17.565 38.894 6.064 56.25c0 0 30.948-2.3 28.02-51.86 0 0-9.41 3.346-17.146 1.256-7.738-2.09-16.938-5.646-16.938-5.646",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M366.003 219.203s3.765-12.548-18.192-20.076c-21.122-7.242-44.555-22.034-46.305-42.555 9.963-8.057 16.63-22.485 16.63-38.997 0-5.114-.754-9.797-1.814-14.092-2.325-9.432-9.46-17.018-11-18.398a32.172 32.172 0 0 0-13.751-7.289c-.876-.218-1.763-.4-2.662-.547 0 0-3.215-.887-8.943-.29-17.655 1.697-31.462 16.813-31.462 40.616 0 16.512 6.666 30.94 16.631 38.997-1.752 20.52-24.688 36.968-46.306 42.555-17.096 4.417-15.682 18.561-15.682 18.561m61.988-61.116s17.64 11.813 36.37 0",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M248.77 112.138s11.121-15.211 33.287-7.265c22.166 7.945 27.968 7.422 35.078 3.24m-62.672 70.94l16.938 16.937 10.664-10.664 11.292 11.292 18.82-18.82",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M290.717 120.126a8.625 8.625 0 0 0 8.625 8.625 8.625 8.625 0 1 0 0-17.25 8.626 8.626 0 0 0-8.625 8.625zm-28.394 0a8.625 8.625 0 0 0 8.625 8.625 8.626 8.626 0 1 0-8.625-8.625zm28.394 0s-5.626-3.983-11.142 0m-17.252 0l-13.73-5.813m59.297 4.662l10.081-5.562",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M22.508 135.428c0 4.823 6.096 8.732 13.615 8.732 7.52 0 13.614-3.91 13.614-8.732 0-4.822-6.095-8.731-13.614-8.731-7.52 0-13.615 3.909-13.615 8.731",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M25.178 136.954c0 4.822 6.096 8.731 13.614 8.731 7.52 0 13.615-3.909 13.615-8.731 0-4.823-6.096-8.732-13.615-8.732-7.518 0-13.614 3.91-13.614 8.732z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M25.178 136.954v8.074c0 4.823 6.096 8.732 13.614 8.732 7.52 0 13.615-3.909 13.615-8.732v-8.074",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  fill: "#FFC5C5",
	  d: "M27.308 187.664l-1.369-9.967 11.336-5.864 14.658 3.91 1.173 9.185-10.359 7.653z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M29.588 188.185l-.585-9.967 10.552-5.864 14.659 3.909 1.172 9.186-10.359 8.06z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M55.388 185.318v7.558l-10.166 8.061-15.44-5.324-.194-7.427m15.44 5.324l.194 7.427"
	}), _react2.default.createElement("path", {
	  d: "M42.025 69.141S25.442 81.12 26.043 81.12l18.53 14.057-2.548-26.036z",
	  fill: "#DFC0FF"
	}), _react2.default.createElement("path", {
	  d: "M44.25 70.81S27.667 82.788 28.268 82.788l18.53 14.057L44.25 70.81z",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M46.798 96.846v7.882L28.268 90.67v-7.882V88.4"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M138.574 280.456H2.367V56.367h175.161v184.56M70.866 88.985h78.284m-78.284 51.619h78.284m-78.284 45.258h78.284m-76.968 53.25h76.327"
	}), _react2.default.createElement("path", {
	  d: "M138.051 275.02c0 19.012 15.411 34.423 34.424 34.423 19.01 0 34.421-15.411 34.421-34.423 0-19.01-15.411-34.422-34.421-34.422-19.013 0-34.424 15.411-34.424 34.422z",
	  stroke: "#2E388E",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M149.094 274.68l16.439 16.439 30.411-30.411"
	}), _react2.default.createElement("path", {
	  fill: "#EBFFC0",
	  d: "M26.425 233.722l13.8 10.694 16.493-12.073-13.776-10.811z"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M29.089 233.722l13.8 10.694 16.493-12.073-13.776-10.811zm30.681-1.28l.021 8.823c-.096.042-16.69 12.12-16.69 12.12"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M28.716 233.575v8.61l14.171 10.841v-8.68"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 370 370",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref = _react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M41.827 263.633c0 5.833 4.73 10.563 10.563 10.563s10.563-4.73 10.563-10.563-4.73-10.563-10.563-10.563c-5.834 0-10.563 4.73-10.563 10.563M4.408 126.572h53.148V73.424H4.408zm256.678 137.705c0 5.513 4.469 9.982 9.98 9.982 5.515 0 9.984-4.47 9.984-9.982 0-5.513-4.47-9.981-9.983-9.981-5.512 0-9.981 4.468-9.981 9.98",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  d: "M207.19 267.954c2.367 35.457 31.876 63.483 67.933 63.483 37.603 0 68.087-30.483 68.087-68.086 0-36.281-28.378-65.934-64.148-67.974m-10.202.172c-33.447 3.05-59.902 30.29-61.724 64.077m14.554-.573c2.036-25.544 22.06-46.1 47.364-48.965",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M279.951 209.963c27.303 2.448 48.772 25.458 48.772 53.388 0 29.556-24.043 53.6-53.6 53.6-27.696 0-50.556-21.113-53.322-48.092m92.473 51.188l36.442 36.442c3.885 3.885 10.184 3.885 14.07 0 3.884-3.885 3.884-10.183 0-14.068l-36.045-36.043",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M264.924 263.487c0 5.507 4.464 9.972 9.972 9.972 5.507 0 9.97-4.465 9.97-9.972s-4.463-9.972-9.97-9.972c-5.508 0-9.972 4.465-9.972 9.972zm-19.39 14.542v15.373h15.373m0-61.492h-15.373v15.373m61.492 0V231.91h-15.373m0 61.492h15.373v-15.373",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M259.862 84.105c0 6.386 5.177 11.562 11.562 11.562s11.562-5.176 11.562-11.562c0-6.385-5.177-11.562-11.562-11.562s-11.562 5.177-11.562 11.562",
	  fill: "#FFF"
	}), _react2.default.createElement("path", {
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  d: "M10.432 126.572h53.147V73.424H10.432zM86.57 83.977h110.791M86.57 98.66h85.378M86.57 113.343h103.45M1.375 251.431c0 5.833 4.729 10.563 10.563 10.563 5.833 0 10.562-4.73 10.562-10.563s-4.729-10.563-10.562-10.563c-5.834 0-10.563 4.73-10.563 10.563zm44.597 12.202c0 5.833 4.729 10.563 10.563 10.563 5.833 0 10.562-4.73 10.562-10.563s-4.73-10.563-10.562-10.563c-5.834 0-10.563 4.73-10.563 10.563zm64.184-69.785c0 5.833 4.73 10.563 10.563 10.563s10.562-4.73 10.562-10.563c0-5.834-4.729-10.563-10.562-10.563-5.834 0-10.563 4.73-10.563 10.563zm44.992 7.986c0 5.833 4.728 10.563 10.563 10.563 5.832 0 10.561-4.73 10.561-10.563s-4.728-10.563-10.561-10.563c-5.835 0-10.564 4.73-10.564 10.563zM286.297 83.683c0-5.833-4.73-10.563-10.563-10.563s-10.562 4.73-10.562 10.563 4.729 10.563 10.562 10.563c5.834 0 10.563-4.73 10.563-10.563m64.758-61.745c0-5.833-4.73-10.563-10.563-10.563s-10.562 4.73-10.562 10.563c0 5.832 4.729 10.563 10.562 10.563 5.834 0 10.563-4.73 10.563-10.563M21.326 255.906l24.646 5.28m19.586-3.3l46.604-57.795m18.924-4.181l23.986 4.62M269.45 92.709l-96.554 101.44"
	}), _react2.default.createElement("path", {
	  d: "M274.45 95.477V252.56",
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  strokeDasharray: "2,5,2,5,2,5"
	}), _react2.default.createElement("path", {
	  d: "M51.513 85.484l-27.82 27.82m-.001-27.82l27.82 27.82M284.52 78.243l48.192-50.45M52.223 259.338l8.895 8.895m-8.895-.001l8.895-8.895M271.72 78.902l8.895 8.895m-8.895 0l8.895-8.895m-9.555 179.871l8.895 8.895m-8.895-.001l8.895-8.895",
	  stroke: "#28348A",
	  strokeWidth: 0.75
	}), _react2.default.createElement("path", {
	  d: "M67.097 263.633h196.622",
	  stroke: "#28348A",
	  strokeWidth: 0.75,
	  strokeDasharray: "2,5,2,5,2,5"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 370 370",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(79);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _emotion = __webpack_require__(9);
	
	var _pureReactCarousel = __webpack_require__(19);
	
	__webpack_require__(366);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _css = __webpack_require__(8);
	
	var _arrow = __webpack_require__(217);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _slides = __webpack_require__(260);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Steps = function (_PureComponent) {
	    _inherits(Steps, _PureComponent);
	
	    function Steps() {
	        _classCallCheck(this, Steps);
	
	        var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	        _this.state = {
	            breakpoint: 0
	        };
	
	        _this.resize = _this.resize.bind(_this);
	        return _this;
	    }
	
	    Steps.prototype.componentDidMount = function componentDidMount() {
	        window.addEventListener('resize', this.resize.bind(this));
	        this.resize();
	    };
	
	    Steps.prototype.componentWillUnmount = function componentWillUnmount() {
	        window.removeEventListener('resize', this.resize.bind(this));
	    };
	
	    Steps.prototype.resize = function resize() {
	        var w = window.innerWidth;
	        if (w < 480) {
	            this.setState(function () {
	                return { breakpoint: 0 };
	            });
	            return;
	        }
	        if (w < 768) {
	            this.setState(function () {
	                return { breakpoint: 480 };
	            });
	            return;
	        }
	        if (w < 992) {
	            this.setState(function () {
	                return { breakpoint: 768 };
	            });
	            return;
	        }
	        if (w < 1200) {
	            this.setState(function () {
	                return { breakpoint: 992 };
	            });
	            return;
	        }
	        if (w < 1400) {
	            this.setState(function () {
	                return { breakpoint: 1200 };
	            });
	            return;
	        }
	        if (w < 1600) {
	            this.setState(function () {
	                return { breakpoint: 1400 };
	            });
	            return;
	        }
	        if (w < 3000) {
	            this.setState(function () {
	                return { breakpoint: 1600 };
	            });
	            return;
	        }
	    };
	
	    Steps.prototype.getSlideHeight = function getSlideHeight() {
	        var breakpoint = this.state.breakpoint;
	
	        switch (breakpoint) {
	            case 0:
	                return 150;
	            case 480:
	                return 150;
	            case 768:
	                return 100;
	            case 992:
	                return 140;
	            case 1200:
	                return 130;
	            case 1400:
	                return 120;
	            case 1600:
	                return 102;
	        }
	    };
	
	    Steps.prototype.render = function render() {
	        return _react2.default.createElement(
	            _pureReactCarousel.CarouselProvider,
	            {
	                className: s.wrapper,
	                naturalSlideWidth: 100,
	                naturalSlideHeight: this.getSlideHeight(),
	                totalSlides: 7 },
	            _react2.default.createElement(
	                _pureReactCarousel.ButtonBack,
	                { className: s.button },
	                _react2.default.createElement(_arrow2.default, null)
	            ),
	            _react2.default.createElement(
	                _pureReactCarousel.Slider,
	                { className: s.sliderWrapper },
	                _react2.default.createElement(_slides.Slide1, { index: 0 }),
	                _react2.default.createElement(_slides.Slide2, { index: 1 }),
	                _react2.default.createElement(_slides.Slide3, { index: 2 }),
	                _react2.default.createElement(_slides.Slide4, { index: 3 }),
	                _react2.default.createElement(_slides.Slide5, { index: 4 }),
	                _react2.default.createElement(_slides.Slide6, { index: 5 }),
	                _react2.default.createElement(_slides.Slide7, { index: 6 })
	            ),
	            _react2.default.createElement(
	                _pureReactCarousel.ButtonNext,
	                { className: (0, _classnames2.default)(s.button, s.buttonNext) },
	                _react2.default.createElement(_arrow2.default, null)
	            ),
	            _react2.default.createElement(_pureReactCarousel.DotGroup, { className: s.dotGroup })
	        );
	    };
	
	    return Steps;
	}(_react.PureComponent);
	
	exports.default = Steps;
	
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _emotion.css)('position:relative;width:100%;height:100%;');
	
	s.sliderWrapper = /*#__PURE__*/(0, _emotion.css)('margin-bottom:10px;', (0, _css.mq)({
	    marginLeft: [20, 60, 80],
	    marginRight: [20, 60, 80]
	}), ';');
	
	s.button = /*#__PURE__*/(0, _emotion.css)('position:absolute;transform:translateY(-50%);background:none;border:none;height:40px;width:40px;border-radius:100%;outline:none;svg{width:100%;height:100%;}&[disabled]{opacity:0.2;}z-index:22;', (0, _css.mq)({
	    left: [0, 20, 40],
	    top: ['30%', '50%']
	}), ';');
	
	s.buttonNext = /*#__PURE__*/(0, _emotion.css)('transform:translateY(-50%) rotate(180deg);left:auto;', (0, _css.mq)({
	    right: [0, 20, 40]
	}), ';');
	
	s.dotGroup = /*#__PURE__*/(0, _emotion.css)('position:relative;width:100%;text-align:center;left:50%;transform:translateX(-50%);', (0, _css.mq)({
	    marginBottom: [40, 40, 80]
	}), ';button{background:none;border:1px solid ', _css.colors.blue, ';border-radius:100%;height:15px;width:15px;padding:0;margin:0 4px;&.carousel__dot--selected{background:', _css.colors.blue, ';}}');
	module.exports = exports['default'];

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _partners = __webpack_require__(272);
	
	Object.defineProperty(exports, 'Partners', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_partners).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _css = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Partner = function (_PureComponent) {
	    _inherits(Partner, _PureComponent);
	
	    function Partner() {
	        _classCallCheck(this, Partner);
	
	        var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	        _this.state = {
	            visible: false
	        };
	        _this.toggleText = _this.toggleText.bind(_this);
	        return _this;
	    }
	
	    Partner.prototype.toggleText = function toggleText() {
	        this.setState(function (prevState) {
	            return {
	                visible: !prevState.visible
	            };
	        });
	    };
	
	    Partner.prototype.render = function render() {
	        var _props = this.props,
	            content = _props.content,
	            image = _props.image,
	            title = _props.title;
	        var visible = this.state.visible;
	
	        return _react2.default.createElement(
	            s.partner,
	            null,
	            _react2.default.createElement(
	                s.partnerImage,
	                { onClick: this.toggleText },
	                _react2.default.createElement('img', { src: image, alt: title })
	            ),
	            visible && _react2.default.createElement(
	                s.partnerText,
	                null,
	                content
	            )
	        );
	    };
	
	    return Partner;
	}(_react.PureComponent);
	
	exports.default = Partner;
	
	
	var s = {};
	
	s.partner = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'es3bhlb0'
	})('position:relative;display:flex;flex-direction:column;', (0, _css.mq)({
	    width: ['100%', '50%', '50%', '25%']
	}), ';img{align-self:center;margin-bottom:20px;width:200px;', (0, _css.mq)({
	    width: [100, 120, 200]
	}), ';}');
	
	s.partnerImage = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'es3bhlb1'
	})('min-height:180px;display:flex;justify-content:center;');
	
	s.partnerText = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'es3bhlb2'
	})('padding:20px;display block;p{font-size:', (0, _css.fontSize)(12), ';line-height:', (0, _css.lineHeight)(24, 16), ';}');
	module.exports = exports['default'];

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _css = __webpack_require__(8);
	
	var _partners = __webpack_require__(253);
	
	var _partners2 = _interopRequireDefault(_partners);
	
	var _partner = __webpack_require__(271);
	
	var _partner2 = _interopRequireDefault(_partner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Patners = function (_PureComponent) {
	    _inherits(Patners, _PureComponent);
	
	    function Patners() {
	        _classCallCheck(this, Patners);
	
	        return _possibleConstructorReturn(this, _PureComponent.call(this));
	    }
	
	    Patners.prototype.renderPartners = function renderPartners() {
	        return _partners2.default.map(function (partner) {
	            var content = partner.content,
	                image = partner.image,
	                title = partner.title;
	
	            return _react2.default.createElement(_partner2.default, _extends({
	                key: partner.title
	            }, {
	                content: content,
	                image: image,
	                title: title
	            }));
	        });
	    };
	
	    Patners.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { className: s.wrapper, id: 'partners' },
	            _react2.default.createElement(
	                s.heading,
	                null,
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Partners'
	                )
	            ),
	            _react2.default.createElement(
	                s.partners,
	                null,
	                this.renderPartners()
	            )
	        );
	    };
	
	    return Patners;
	}(_react.PureComponent);
	
	exports.default = Patners;
	
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _reactEmotion.css)('background:', _css.colors.white, ';width:100%;', (0, _css.mq)({
	    paddingLeft: [20, 60, 60, 30, (0, _css.rWidth)(240 / 2), (0, _css.rWidth)(240)],
	    paddingRight: [20, 60, 60, 30, (0, _css.rWidth)(240 / 2), (0, _css.rWidth)(240)],
	    paddingTop: [60, 60, 80, 80, 80, 120],
	    paddingBottom: [60, 60, 80, 80, 80, 120]
	}), ';');
	
	s.heading = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'e27qr1q0'
	})('width:100%;line-height:', (0, _css.lineHeight)(53, 45), ';letter-spacing:', (0, _css.letterSpacing)(200), ';h2{color:', _css.colors.blue, ';margin:0 0 1.5em;}', (0, _css.mq)({
	    paddingRight: [20, 20, 20, 0],
	    textAlign: ['right', 'right', 'right', 'left'],
	    fontSize: [(0, _css.fontSize)(20), (0, _css.fontSize)(25), (0, _css.fontSize)(25), (0, _css.fontSize)(20), (0, _css.fontSize)(30)]
	}), ';');
	
	s.partners = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'e27qr1q1'
	})('display:flex;width:100%;justify-content:space-around;flex-wrap:wrap;');
	module.exports = exports['default'];

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _weEmulatePeople = __webpack_require__(274);
	
	Object.defineProperty(exports, 'WeEmulatePeople', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_weEmulatePeople).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _css = __webpack_require__(8);
	
	var _content = __webpack_require__(57);
	
	var _we_emulate_people = __webpack_require__(510);
	
	var _we_emulate_people2 = _interopRequireDefault(_we_emulate_people);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WeEmulatePeople = function (_PureComponent) {
	    _inherits(WeEmulatePeople, _PureComponent);
	
	    function WeEmulatePeople() {
	        _classCallCheck(this, WeEmulatePeople);
	
	        return _possibleConstructorReturn(this, _PureComponent.call(this));
	    }
	
	    WeEmulatePeople.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { className: s.wrapper },
	            _react2.default.createElement(
	                'div',
	                { className: s.heading },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    _content.weEmulatePeople.weEmulatePeople.heading
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: s.content },
	                _content.weEmulatePeople.weEmulatePeople.content
	            ),
	            _react2.default.createElement('div', { className: s.image })
	        );
	    };
	
	    return WeEmulatePeople;
	}(_react.PureComponent);
	
	exports.default = WeEmulatePeople;
	
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _emotion.css)('position:relative;z-index:5;width:100%;transition:all 0.2s;align-items:center;', (0, _css.mq)({
	    display: ['block', 'block', 'flex'],
	    flexDirection: ['column', 'column', 'row'],
	    height: ['auto', 'auto', '100vh']
	}), ';');
	
	s.heading = /*#__PURE__*/(0, _emotion.css)('display:flex;align-items:center;h1{text-transform:uppercase;color:', _css.colors.blue, ';margin:0;line-height:', (0, _css.lineHeight)(130, 108), ';letter-spacing:', (0, _css.letterSpacing)(200), ';', (0, _css.mq)({
	    paddingBottom: [50, 50, 0],
	    maxWidth: ['350px', '450px', '350px'],
	    fontSize: [(0, _css.fontSize)(40), (0, _css.fontSize)(60), (0, _css.fontSize)(40), (0, _css.fontSize)(50), (0, _css.fontSize)(75), (0, _css.fontSize)(108)]
	}), ';}', (0, _css.mq)({
	    alignItems: ['center', 'center', 'flex-start'],
	    width: ['auto', 'auto', 'auto', 'auto', (0, _css.rWidth)(735)],
	    height: ['250px', '400px', 'auto'],
	    marginLeft: [20, 60, 50, 50, (0, _css.rWidth)(235)],
	    marginTop: [0, 0, -100, -100, -140]
	}), ';');
	
	s.content = /*#__PURE__*/(0, _emotion.css)('p{letter-spacing:', (0, _css.letterSpacing)(11), ';line-height:', (0, _css.lineHeight)(32, 16), ';color:', _css.colors.blue, ';margin:0 0 2em;', (0, _css.mq)({
	    maxWidth: ['100%', '100%', 700],
	    fontSize: [(0, _css.fontSize)(14), (0, _css.fontSize)(16), (0, _css.fontSize)(14), (0, _css.fontSize)(16), (0, _css.fontSize)(16)]
	}), ';}', (0, _css.mq)({
	    width: ['auto', 'auto', 'auto', 'auto', (0, _css.rWidth)(700)],
	    marginLeft: [20, 60, 65, 65, 'auto'],
	    marginRight: [20, 60, 60, 60, (0, _css.rWidth)(120)],
	    paddingTop: [30, 30, 0, 0, 0],
	    marginTop: [0, 0, -70, -70, -120]
	}), ';');
	
	s.image = /*#__PURE__*/(0, _emotion.css)('position:absolute;top:0;right:0;left:0;bottom:0;background:url(\'', _we_emulate_people2.default, '\');background-repeat:no-repeat;background-size:cover;background-position:50% 100%;z-index:-1;', (0, _css.mq)({
	    height: ['250px', '400px', 'auto']
	}));
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(9);
	
	var _utilities = __webpack_require__(43);
	
	exports.default = (0, _emotion.injectGlobal)('*{box-sizing:border-box}html{margin:0;', (0, _utilities.mq)({ marginTop: ['50px', '70px', '70px', '110px'] }), ';}body{margin:0;min-width:305px;font-family:\'Montserrat\',Helvetica,Arial;font-weight:300;font-style:normal;text-rendering:optimizeLegibility;}h1,h2,h3,h4,h5,h6{font-weight:300 !important;}');
	module.exports = exports['default'];

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _variables = __webpack_require__(44);
	
	Object.defineProperty(exports, 'colors', {
	  enumerable: true,
	  get: function get() {
	    return _variables.colors;
	  }
	});
	
	var _utilities = __webpack_require__(43);
	
	Object.defineProperty(exports, 'mq', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.mq;
	  }
	});
	Object.defineProperty(exports, 'fontSize', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.fontSize;
	  }
	});
	Object.defineProperty(exports, 'letterSpacing', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.letterSpacing;
	  }
	});
	Object.defineProperty(exports, 'lineHeight', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.lineHeight;
	  }
	});
	Object.defineProperty(exports, 'rWidth', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.rWidth;
	  }
	});
	
	var _global = __webpack_require__(76);
	
	Object.defineProperty(exports, 'global', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_global).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.rWidth = exports.lineHeight = exports.letterSpacing = exports.fontSize = exports.mq = undefined;
	
	var _facepaint = __webpack_require__(101);
	
	var _facepaint2 = _interopRequireDefault(_facepaint);
	
	var _variables = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mq = (0, _facepaint2.default)(_variables.breakpoints.map(function (bp) {
	  return '@media (min-width: ' + bp + 'px)';
	}));
	
	var fontSize = function fontSize(size) {
	  return size / _variables.fontSizes.default + 'rem';
	};
	
	var letterSpacing = function letterSpacing(size) {
	  return size / 1000 + 'em';
	};
	
	var lineHeight = function lineHeight(size, fontSize) {
	  return '' + size / fontSize;
	};
	
	var rWidth = function rWidth(width) {
	  return 'calc(100vw * (' + width + ' / ' + _variables.pageWidth + '))';
	};
	
	exports.mq = mq;
	exports.fontSize = fontSize;
	exports.letterSpacing = letterSpacing;
	exports.lineHeight = lineHeight;
	exports.rWidth = rWidth;

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var fontSizes = {
	    default: 16
	};
	
	var colors = {
	    blue: 'rgb(45,49,148)',
	    white: '#fff',
	    cyan: '#befffc',
	    black: '#323232'
	};
	
	var breakpoints = [480, 768, 992, 1200, 1600];
	
	var pageWidth = 1920;
	
	exports.colors = colors;
	exports.fontSizes = fontSizes;
	exports.breakpoints = breakpoints;
	exports.pageWidth = pageWidth;

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sections = __webpack_require__(254);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_PureComponent) {
	    _inherits(IndexPage, _PureComponent);
	
	    function IndexPage() {
	        _classCallCheck(this, IndexPage);
	
	        return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	    }
	
	    IndexPage.prototype.render = function render() {
	        var transition = this.props.transition;
	
	        return _react2.default.createElement(
	            'div',
	            { className: (0, _emotion.cx)(transition && transition.className, s.wrapper) },
	            _react2.default.createElement('div', { id: 'top' }),
	            _react2.default.createElement(_sections.WeEmulatePeople, null),
	            _react2.default.createElement(_sections.AboutUs, null),
	            _react2.default.createElement(_sections.OurPlatform, null),
	            _react2.default.createElement(_sections.OurVirtualExperts, null),
	            _react2.default.createElement(_sections.Partners, null)
	        );
	    };
	
	    return IndexPage;
	}(_react.PureComponent);
	
	exports.default = IndexPage;
	
	
	var s = {};
	
	s.wrapper = /*#__PURE__*/(0, _emotion.css)('display:flex;flex-direction:column;');
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-b6c426627ca9f7ce230f.js